import React, {
  useRef,
  useState,
  useEffect,
  useLayoutEffect,
  useCallback,
  useContext,
} from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5stock from "@amcharts/amcharts5/stock";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import Dashboardmenus from "./Dashboardmenus";
import Dashboardrightsidemenus from "./Dashboardrightsidemenus";
import CurrencyDollarSimple from "../../../images/CurrencyDollarSimple.svg";
import CurrencyBtc from "../../../images/CurrencyBtc.svg";
import DropHalfBottom from "../../../images/DropHalfBottom.svg";
import Files from "../../../images/Files.svg";
import TrendUp from "../../../images/TrendUp.svg";
import searchnormal from "../../../images/search-normal.svg";
import Star2 from "../../../images/Star-2.svg";
import arrowgreen from "../../../images/arrowgreen.png";
import redarrow from "../../../images/redarrow.png";
import Bitcoin from "../../../images/bitcoin-icon.svg";
import star from "../../../images/star.svg";
import lineup from "../../../images/line-up.svg";
import bars from "../../../images/bars.svg";
import gsap from "gsap";
import candles from "../../../images/candles.svg";
import chain from "../../../images/chain.svg";
import buyicon from "../../../images/buy-icon.svg";
import exp_flag from "../../../images/exp_flag.svg";
import exp_duplicate_flag from "../../../images/exp_duplicate_flag.png";
import sellicon from "../../../images/sell-icon.svg";
import { motion, AnimatePresence } from "framer-motion";
import islamicaccount from "../../../images/islamic-account.svg";
import { Await, Link } from "react-router-dom";
import { formatPrice, formatPricewithdesimal } from "../../common/formatPrice";
import {
  showErrorToast,
  showProcessToast,
  updateToastMessage,
} from "../../common/Tostify";
import { handleToggleCollapse, useModal } from "../../common/Collapsfunction";
import {
  createChart,
  LineStyle,
  PriceScaleMode,
  CrosshairMode,
} from "lightweight-charts";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  authcallApi,
  authcallApipost,
  authcallApitest,
  callApi,
  callApilivepair,
} from "../../common/API/Api";
import { WebSocketContext } from "../../common/API/WebSocketProvider";
import Indicator from "./Indicator";
import { setData } from "../../../store/dataSlice";
import { Stage, Layer, Line, Rect, Text } from "react-konva";
import Timezone from "./TimeZone";
import { useTranslation } from "react-i18next";
import {
  getServerTime,
  gettimezoneprefrence,
} from "./commonmodal/Getservertime";
import { useNotification } from "../../common/DashboardNotification";
import { factory } from "typescript";
import { v4 as uuidv4 } from "uuid";
import { getlang } from "./commonmodal/Commonapis";
import {
  LanguageSelector,
  Settings,
  TimezoneSelector,
} from "./commonmodal/Commondropdowns";
import coin_drop_close from "../../../images/coin_drop_close.mp3";
import tradeloss from "../../../sounds/tradeloss.mp3";
import tradewin from "../../../sounds/tradewin.mp3";
import coin_drop from "../../../sounds/buysellsound.mp3";
const Notification = (data) => {
  const notificationRef = useRef();
  console.log(data, "datadatadatadata");
  useEffect(() => {
    // Start showing animation
    const element = notificationRef.current;
    requestAnimationFrame(() => {
      element.classList.add("show");
    });
    // if (data?.removing) {
    //   element.classList.add("hide");
    // }
  }, [data?.removing]);

  return (
    <div
      ref={notificationRef}
      className={`notification ${data?.removing ? "hide show" : ""}`}
    >
      <div className="header">
        <span>{data?.title}</span>
        <span className="success-icon">
          {data?.type === "buy" ? (
            data?.profit_loss < 0 && data?.check !== "open" ? (
              <svg
                width="16"
                height="16"
                fill="rgba(243,56,44,1)"
                viewBox="0 0 24 24"
              >
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"></path>
              </svg>
            ) : (
              <svg
                width="16"
                height="16"
                fill="rgba(15,175,89,1)"
                viewBox="0 0 24 24"
              >
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"></path>
              </svg>
            )
          ) : data?.profit_loss < 0 && data?.check !== "open" ? (
            <svg
              width="16"
              height="16"
              fill="rgba(15,175,89,1)"
              viewBox="0 0 24 24"
            >
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"></path>
            </svg>
          ) : (
            <svg
              width="16"
              height="16"
              fill="rgba(243,56,44,1)"
              viewBox="0 0 24 24"
            >
              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.4571 9.45711L11 15.9142L6.79289 11.7071L8.20711 10.2929L11 13.0858L16.0429 8.04289L17.4571 9.45711Z"></path>
            </svg>
          )}
        </span>
      </div>

      <div className="pair">
        <b>{data?.asset_name}</b>
        {data?.type === "buy" ? (
          <svg
            width="16"
            height="16"
            fill="rgba(15,175,89,1)"
            viewBox="0 0 24 24"
          >
            <path d="M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z"></path>
          </svg>
        ) : (
          <svg
            width="16"
            height="16"
            fill="rgba(243,56,44,1)"
            viewBox="0 0 24 24"
          >
            <path d="M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z"></path>
          </svg>
        )}
      </div>

      <div className="details">
        <div>
          {data?.check === "open" ? (
            <>
              <b>Forecast:</b> {data?.type}
            </>
          ) : (
            <>
              <b>Payout:</b>${" "}
              {formatPrice(
                (
                  parseFloat(data?.profit_loss) + parseFloat(data?.amount)
                ).toFixed(2),
                2,
              )}
            </>
          )}
        </div>
        <div>
          {data?.check === "open" ? (
            <>
              <b>Amount:</b> $
              {formatPrice(parseInt(data?.amount).toFixed(2), 2)}
            </>
          ) : (
            <>
              <b>Profit:</b> ${" "}
              {data?.totelamount
                ? formatPricewithdesimal(data?.totelamount)
                : data?.profit_loss > 0
                  ? formatPrice(data?.profit_loss, 2)
                  : 0.0}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
const Userdeshboard = (props) => {
  document.title = "Equlix";
  const { ws, message } = useContext(WebSocketContext);
  const { showNotification } = useNotification();
  const [callclosetradeapi, setClosetradeapi] = useState(false);
  const timeoutMapRef = useRef(new Map());
  const remainingTimeMapRef = useRef(new Map());
  const startTimeMapRef = useRef(new Map());
  const openImagesRef = useRef(new Map());
  const totalTimeout = 3000;
  const [serverTime, setServerTime] = useState(null);
  const overlayRef = useRef(null);
  const [peandingtrade, setPendingtrade] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const hoverBackgroundRangeRef = useRef(null);
  const combinedBulletFactoryRef = useRef(null);
  const [settingloader, setSettingloader] = useState({
    default: false,
    classic: false,
  });
  const token = localStorage.getItem("token");
  const [userDetails, setUserDetails] = useState(null);
  const [isFullyZoomedOut, setIsFullyZoomedOut] = useState(false);
  const isFullyZoomedOutRef = useRef(false);
  const [panelInfo, setPanelInfo] = useState(null);
  const highestRangeRef = useRef(null);
  const currenttimeref = useRef(null);
  const lowestRangeRef = useRef(null);
  const highLowAnnotationSeriesRef = useRef(null);
  const panStartXRef = useRef(0);
  const userInteractedOnLeftRef = useRef(false);
  const backgroundBarSeriesRef = useRef(null);
  const hoverAnnotationSeriesRef = useRef(null);
  const buyOverlayRef = useRef(null);
  const sellOverlayRef = useRef(null);
  const checkimageopen = useRef(false);
  const activeHoverTypeRef = useRef(null);
    const closetradeapirun = useRef(false);
  const referencePrice = useRef(null);
  const m1BulletFactoryRef = useRef(null);
  const arrowBulletFactoryRef = useRef(null);
  const chartDiv = useRef(null);
  const [selecttime, setSelecttime] = useState();
  const [visible, setVisible] = useState(false);
  const [slideIn, setSlideIn] = useState(false);
  const [hideLeft, setHideLeft] = useState(false);
  const [showchartsetting, setShowChartSetting] = useState(false);
  const menubuttonref = useRef(null);
  const menupopupref = useRef(null);
  const rootref = useRef(null);
  const valueSeriesref = useRef();
  const currentLabelref = useRef();
  const currentValueDataItemref = useRef();
  const stockChartref = useRef();
  const indicatorInstancesRef = useRef({});
  const plotContainerref = useRef();
  const drawingcontrolref = useRef();
  const yAxisRef = useRef(null);
  const [opentimezon, setOpentimezone] = useState(false);
  const mainPanelRef = useRef();
  // const websoketarrref = useRef([]);
  const [searchpopup, setSearchpopup] = useState(true);
  const isReadyRef = useRef(false);
  const dateAxisref = useRef();
  const [pageloader, setPageloader] = useState({
    chartasset: true,
    favorites: true,
  });
  const { setSoundEnabled, soundEnabled } = props;
  const otcwebsoket = useRef(null);
  const targetRange = useRef(null);
  const [isFetchingHistory, setIsFetchingHistory] = useState(false);
  const [isFetchingOtcHistory, setIsFetchingOtcHistory] = useState(false);
  const animationRef = useRef(null);
  const setcandlerange = useRef([]);
  const currentSecondRef = useRef(null);

  let websoketarrref = useRef([]);
  const [updatecanvas, setUpdatecanvas] = useState({
    Background: { type: "solid", color: "transparent" },
    GridLines: { color: "#333" },
    Crosshair: { Color: "#fff" },
  });
  const groupedDataRef = useRef([]);
  const [checkcanvs, setCheckcanvas] = useState();
  const [classNameicMode, setClassNameicMode] = useState(false);
  const [checkliveaccount, setCheckliveaccount] = useState(false);
  const [showgraphsvg, setShowgraphsvg] = useState(false);
  const [updatetimezone, setUpdateTimezone] = useState();
  const [graphdata, setGraphdata] = useState({
    labelX: "",
    labelY: "",
    arrowEndX: "",
    arrowEndY: "",
    d: "",
    points: [],
  });
  const [imageurl, setImageurl] = useState();
  const timmerref = useRef();

  const [showindModal, setShowindModal] = useState(false);
  const [idmodaldata, setIdmodaldata] = useState();
  const openindModal = () => setShowindModal(true);
  const closeindModal = () => setShowindModal(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const dragStartref = useRef({ x: 0, y: 0 });
  const dragOffsetref = useRef({ x: 0, y: 0 });
  const [tooltipData, setTooltipData] = useState(null);
  const [showtooltip, setShowtooltip] = useState(false);
  const [soundbalance, setSoundbalance] = useState(false);
  const soundbalanceref = useRef(false);
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0,
    time: null,
    price: null,
  });
  const mousePositionref = useRef({ x: 0, y: 0, time: null, price: null });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStartX, setDragStartX] = useState(null);
  const [currentLine, setCurrentLine] = useState(null);
  const [drawingTool, setDrawingTool] = useState(null);
  const drawnShapesRef = useRef([]);
  const drawingCanvasRef = useRef(null);
  const [chartWidth, setChartWidth] = useState(0);
  const [chartHeight, setChartHeight] = useState(0);
  const dispatch = useDispatch();
  const walletdata = useSelector((state) => state.data.value);
  const processedIds = useRef(new Set());
  const chartRef = useRef(null);
  const seriesRef = useRef(null);
  const soketref = useRef(null);
  const websoketclose = useRef(false);
  const websoketrunning = useRef(false);
  const intervalIdRef = useRef(null);
  const buyTimeoutIdRef = useRef(null);
  const candleTimeoutRef = useRef(null);
  const priceLineref = useRef();
  const previousFromRef = useRef(null);
  const [updateSignal, setUpdateSignal] = useState(0);
  const closetraderesf = useRef([]);
  const wsresf = useRef(true);
  const tradestyleref = useRef("1");
  const [chartData, setChartData] = useState([]);
  const [opentrade, setOpentrade] = useState([]);
  const [checkclosetrade, setCheckclosetrade] = useState([]);
  const [closelimit, setCloselimit] = useState(10);
  const [drawings, setDrawings] = useState([]);
  const [currentdrawingshow, setCurrentdrawingshow] = useState(false);
  const [lastPrice, setLastPrice] = useState(null);
  const [stoptimmer, setStoptimmer] = useState(true);
  const [chertloader, setChartLoader] = useState(true);
  const [walletupdate, setWallupdate] = useState(false);
  const [assetlist, setAssrtlist] = useState([]);
  const [assetalllist, setAllAssrtlist] = useState([]);
  const [showcopytrades, setShowcopytrades] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermall, setSearchTermall] = useState("");
  const searchTermallref = useRef("");
  const [assetshowlist, setAssetshowlist] = useState({
    currency: [],
    cryptocurrency: [],
    commodities: [],
    stocks: [],
    indices: [],
    favorites: [],
  });
  const [showasset, setShowasset] = useState({
    currency: false,
    cryptocurrency: true,
    commodities: false,
    stocks: false,
    indices: false,
    favorites: false,
  });
  const [selectshowasset, setSelectshowasset] = useState(false);
  let API_KEY = process.env.REACT_APP_API_KEY;
  const apiCallMade = useRef(false);
  const [checkaccounttype, setCheckaccounttype] = useState(false);
  const [openmodal, setOpenmodal] = useState(false);
  const [chnagetype, setChangetype] = useState();
  const chnagetyperef = useRef();
  const tradingViewRef = useRef(null);
  const { modalRefs, openModal } = useModal();
  const [tradestyle, setTradestyle] = useState("1");
  const runningcandledataref = useRef([]);
  const [timezone, setTimezone] = useState();
  const [candleTime, setCandleTime] = useState("00:00:00");
  const [linesettings, setLinesettings] = useState({
    showarea: true,
    autoscroll: true,
  });
  const [customcaldle, setCustomcaldle] = useState({
    upColor: "#45b734",
    downColor: "#ff3e1f",
    borderUpColor: "#45b734",
    borderDownColor: "#ff3e1f",
    wickUpColor: "#45b734",
    wickDownColor: "#ff3e1f",
    priceLineVisible: false,
    lastValueVisible: false,
    priceScaleId: "right",
  });

  const [currentTime, setCurrentTime] = useState("");
  const [candletimer, setCandletimer] = useState({
    type: "minute",
    value: "1",
    duration: "M1",
  });

  const [timer, setTimer] = useState(60000);
  const [indicatorlist, setIndicatorlist] = useState(Indicator);
  const [showindicator, setShowindicator] = useState([]);
  const acSeriesrf = useRef(null);

  useEffect(() => {
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (userTimeZone === "Asia/Calcutta") {
      userTimeZone = "Asia/Kolkata";
    }
    setTimezone(userTimeZone);
  }, []);
  const fetchServerTime = async () => {
    const data = await getServerTime();

    if (data?.success) {
      setServerTime(data);
    }
    return data;
  };
  useEffect(() => {
    //  let currenttimmer = setInterval(() => {
    fetchServerTime();
    // }, 1000);
    // return () => clearInterval(currenttimmer);
  }, []);
  const [defaultwith, setDefaultwidth] = useState(false);

  // const setupdrawings = (type, image, tool) => {
  //   // const lastchartdata = values[values.length - 1];
  //   // let array = [...drawings];
  //       drawingcontrolref.current.set("tool", "Fibonacci");
  //       console.log(drawingcontrolref.current, "drawingcontrolref")
  //   // array.push({
  //   //   type,
  //   //   lastchartdata,
  //   //   image,
  //   // });
  //   // setDrawings(array);
  //   // setupdrawing(array);
  // };
  const setupdrawings = (tooltype, image, tool) => {
    const chart = stockChartref.current;
    const drawingControl = drawingcontrolref.current;
    if (!chart || !drawingControl) return;

    drawingControl.setAll({
      active: true,
      tool: tooltype,
      strokeColor: am5.color(0xff0000),
    });

    // ✅ Create a new drawing object
    const drawingId = Date.now() + Math.random();
    const newDrawing = {
      id: drawingId,
      type: tooltype,
      image,
      tool,
    };

    // ✅ Append to the drawings array
    setDrawings((prev) => [...prev, newDrawing]);

    // ✅ Show drawing panel section
    setCurrentdrawingshow(true);
  };
  const deletedrawing = (deletetype, key) => {
    let updatedrawing = [];
    if (deletetype === "all") {
      updatedrawing = [];
    } else {
      updatedrawing = drawings.filter((_, result) => result !== key);
    }

    if (updatedrawing?.length === 0) {
      setCurrentdrawingshow(false);
    }
    setDrawings(updatedrawing);
  };
  const drawVerticalLine = (ctx, xPosition) => {
    ctx.beginPath();
    ctx.moveTo(xPosition, 0);
    ctx.lineTo(xPosition, ctx.canvas.height);
    ctx.strokeStyle = "#67a01d";
    ctx.lineWidth = 1;
    ctx.stroke();
    const middleY = ctx.canvas.height / 2;
    ctx.beginPath();
    ctx.arc(xPosition, middleY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();

    return { type: "verticalLine", x: xPosition };
  };

  // 2. Horizontal Line
  const drawHorizontalLine = (ctx, yPosition) => {
    ctx.beginPath();
    ctx.moveTo(0, yPosition);
    ctx.lineTo(ctx.canvas.width, yPosition);
    ctx.strokeStyle = "#67a01d";
    ctx.lineWidth = 1;
    ctx.stroke();
    const middleX = ctx.canvas.width / 2;
    ctx.beginPath();
    ctx.arc(middleX, yPosition, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();

    return { type: "horizontalLine", y: yPosition };
  };

  // 3. Trend Line
  const drawTrendLine = (ctx, startX, startY, endX, endY) => {
    if (endY > startY) {
      const temp = startY;
      startY = endY;
      endY = temp;
    }

    // Draw the trend line
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.strokeStyle = "#67a01d";
    ctx.lineWidth = 1;
    ctx.stroke();

    ctx.beginPath();
    ctx.arc(startX, startY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();

    // Draw the dot at the end point
    ctx.beginPath();
    ctx.arc(endX, endY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();

    return { type: "trendLine", startX, startY, endX, endY };
  };

  // 4. Ray
  const drawRay = (ctx, startX, startY, endX, endY) => {
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.strokeStyle = "#67a01d";
    ctx.lineWidth = 1;
    // ctx.setLineDash([5, 5]);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(startX, startY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();
    const middleX = (startX + endX) / 2;
    const middleY = (startY + endY) / 2;
    ctx.beginPath();
    ctx.arc(middleX, middleY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();

    return { type: "ray", startX, startY, endX, endY };
  };

  // 5. Rectangle
  const drawRectangle = (ctx, startX, startY, width, height) => {
    ctx.beginPath();
    ctx.rect(startX, startY, width, height);
    ctx.strokeStyle = "#67a01d";
    ctx.lineWidth = 1;
    ctx.fillStyle = "rgba(46, 66, 40, 0.5)";
    ctx.fill();
    ctx.stroke();
    const topRightX = startX + width;
    const topRightY = startY;
    ctx.beginPath();
    ctx.arc(topRightX, topRightY, 3, 0, Math.PI * 2);
    ctx.fillStyle = "white";
    ctx.fill();
    ctx.strokeStyle = "white";
    ctx.lineWidth = 1;
    ctx.stroke();
    const bottomLeftX = startX;
    const bottomLeftY = startY + height;
    ctx.beginPath();
    ctx.arc(bottomLeftX, bottomLeftY, 3, 0, Math.PI * 2);
    ctx.fillStyle = "white";
    ctx.fill();
    ctx.strokeStyle = "white";
    ctx.lineWidth = 1;
    ctx.stroke();

    return { type: "rectangle", startX, startY, width, height };
  };

  // 6. Channel (draw two parallel trend lines)
  const drawChannel = (ctx, startX, startY, endX, endY) => {
    const channelWidth = 100;
    if (endY > startY) {
      const temp = startY;
      startY = endY;
      endY = temp;
    }
    drawTrendLine(ctx, startX, startY, endX, endY);
    drawTrendLine(
      ctx,
      startX,
      startY - channelWidth,
      endX,
      endY - channelWidth,
    );
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.lineTo(endX, endY - channelWidth);
    ctx.lineTo(startX, startY - channelWidth);
    ctx.closePath();
    ctx.fillStyle = "rgba(46, 66, 40, 0.5)";
    ctx.fill();
    return { type: "channel", startX, startY, endX, endY, channelWidth };
  };

  // 7. Fibonacci Retracement
  const drawFibonacciRetracement = (ctx, startX, startY, endX, endY) => {
    const fibLevels = [
      0, 0.236, 0.382, 0.5, 0.618, 0.786, 1, 1.236, 1.382, 1.5, 1.618, 1.786,
      2.618,
    ];

    const startPrice = seriesRef.current.coordinateToPrice(startY);
    const endPrice = seriesRef.current.coordinateToPrice(endY);
    const priceRange = endPrice - startPrice;
    const topPrice = seriesRef.current.coordinateToPrice(0);
    const bottomPrice = seriesRef.current.coordinateToPrice(ctx.canvas.height);
    const middlePrice = (topPrice + bottomPrice) / 2;
    const firstFibY = startY + (endY - startY) * fibLevels[6];
    const lastFibY = startY + (endY - startY) * fibLevels[fibLevels.length - 1];
    drawDashedLine(ctx, startX - 50, firstFibY, endX + 50, lastFibY);
    fibLevels.forEach((level) => {
      const fibY = startY + (endY - startY) * level;
      const priceAtLevel = (startPrice + priceRange * level).toFixed(2);
      if (priceAtLevel >= bottomPrice && priceAtLevel <= topPrice) {
        ctx.beginPath();
        ctx.moveTo(startX - 50, fibY);
        ctx.lineTo(endX + 50, fibY);
        ctx.strokeStyle = "#67a01d";
        ctx.lineWidth = 1;
        ctx.stroke();
        drawLabel(ctx, startX - 60, fibY - 5, `${level}`, "green");
        drawLabel(ctx, endX + 10, fibY - 5, `${priceAtLevel}`, "white");
      }
    });

    return {
      type: "fibonacciRetracement",
      startX,
      startY,
      endX,
      endY,
      startPrice,
      endPrice,
    };
  };
  const drawDashedLine = (ctx, startX, startY, endX, endY) => {
    ctx.beginPath();
    ctx.setLineDash([5, 5]);
    ctx.moveTo(startX, startY);
    ctx.lineTo(endX, endY);
    ctx.strokeStyle = "#67a01d";
    ctx.lineWidth = 1;
    ctx.stroke();
    ctx.setLineDash([]);
    ctx.beginPath();
    ctx.arc(startX, startY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();
    ctx.beginPath();
    ctx.arc(endX, endY, 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#fff";
    ctx.fill();
  };
  const drawLabel = (ctx, x, y, text, color) => {
    ctx.font = "12px Arial";
    ctx.fillStyle = color;
    ctx.fillText(text, x, y);
  };

  // 8. Fibonacci Fan
  const drawFibonacciFan = (ctx, startX, startY, endX, endY) => {
    const fibAngles = [0, 10, 20, 30, 45, 50, 60, 90];

    fibAngles.forEach((angle) => {
      const radian = (Math.PI / 180) * angle;
      const distance = endX - startX;
      const endXFan = startX + distance * Math.cos(radian);
      const endYFan = startY - distance * Math.sin(radian);

      drawTrendLine(ctx, startX, startY, endXFan, endYFan);
    });

    return { type: "fibonacciFan", startX, startY, endX, endY };
  };

  // 9. Andrew's Pitchfork
  const drawAndrewsPitchfork = (ctx, startX, startY, endX, endY) => {
    const pitchforkPoints = [
      { x: startX, y: startY },
      { x: endX, y: endY },
      { x: startX + 100, y: startY + 100 },
    ];
    drawTrendLine(
      ctx,
      pitchforkPoints[0].x,
      pitchforkPoints[0].y,
      pitchforkPoints[1].x,
      pitchforkPoints[1].y,
    );
    drawTrendLine(
      ctx,
      pitchforkPoints[0].x,
      pitchforkPoints[0].y,
      pitchforkPoints[2].x,
      pitchforkPoints[2].y,
    );
    drawTrendLine(
      ctx,
      pitchforkPoints[1].x,
      pitchforkPoints[1].y,
      pitchforkPoints[2].x,
      pitchforkPoints[2].y,
    );
    return { type: "andrewsPitchfork", startX, startY, endX, endY };
  };
  const drawSelectedTool = (ctx, mouseX, mouseY, tool, mouseZ, checkdrop) => {
    let shape = null;
    const toolCount = {};
    if (tool?.length) {
      tool.forEach((result) => {
        if (!result?.type) return;
        toolCount[result.type] = (toolCount[result.type] || 0) + 1;
        const adjustmentFactor = toolCount[result.type] - 1;
        const adjustedMouseX = mouseX + adjustmentFactor * 50;
        const adjustedMouseY = mouseY + adjustmentFactor * 50;
        const adjustedMouseZ = mouseZ + adjustmentFactor * 50;
        let shapeData = { type: result.type };
        if (result?.type === "Vertical line") {
          shape = drawVerticalLine(ctx, adjustedMouseX);
        } else if (result?.type === "Horizontal line") {
          shape = drawHorizontalLine(ctx, adjustedMouseY);
        } else if (result?.type === "Trend line") {
          const x1 = adjustedMouseX - 100;
          const y1 = adjustedMouseZ;
          const x2 = adjustedMouseX + 300;
          const y2 = adjustedMouseZ + 150;
          shape = drawTrendLine(ctx, x1, y1, x2, y2);
          shapeData = { ...shapeData, x1, y1, x2, y2 };
        } else if (result?.type === "Ray") {
          shape = drawRay(
            ctx,
            adjustedMouseX,
            adjustedMouseZ + 100,
            adjustedMouseX + 1000,
            adjustedMouseZ - 100,
          );
        } else if (result?.type === "Rectangle") {
          shape = drawRectangle(ctx, adjustedMouseX, adjustedMouseZ, 300, 200);
        } else if (result?.type === "Channel") {
          shape = drawChannel(
            ctx,
            adjustedMouseX,
            adjustedMouseZ,
            adjustedMouseX + 200,
            adjustedMouseZ + 100,
          );
        } else if (result?.type === "Fibonacci Retraceent") {
          shape = drawFibonacciRetracement(
            ctx,
            adjustedMouseX,
            adjustedMouseY - 400,
            adjustedMouseX + 200,
            adjustedMouseY - 200,
          );
        } else if (result?.type === "Fibonacci Fan") {
          shape = drawFibonacciFan(
            ctx,
            adjustedMouseX,
            adjustedMouseY,
            adjustedMouseX + 150,
            adjustedMouseY + 150,
          );
        } else if (result?.type === "Andrew’s Pitchfork") {
          shape = drawAndrewsPitchfork(
            ctx,
            adjustedMouseX,
            adjustedMouseY,
            adjustedMouseX + 200,
            adjustedMouseY + 200,
          );
        }
        drawnShapesRef.current.push(shapeData);
      });
    }
  };
  const setupdrawing = (tool) => {
    if (!drawingCanvasRef.current || !chartRef.current) return;
    let point = seriesRef.current.data().slice(-5)[0];
    if (point) {
    }
  };

  useEffect(() => {
    if (!drawingCanvasRef.current || !chartRef.current || !seriesRef.current)
      return;

    let point = seriesRef.current.data().slice(-5)[0];
    const chart = chartRef.current;
    if (point) {
      const canvas = drawingCanvasRef.current;
      const ctx = canvas.getContext("2d");
      const logical = seriesRef.current.priceToCoordinate(point?.close);
      const updateshow = logical - 50;
      const updateOnChartMove = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (drawings?.length) {
          const timeCoordinate = chartRef.current
            .timeScale()
            .timeToCoordinate(point?.time);
          const x = dragOffsetref.current.x
            ? dragOffsetref.current.x + timeCoordinate
            : timeCoordinate;
          const y = dragOffsetref.current.y
            ? dragOffsetref.current.y + 500
            : 500;
          const rect = tradingViewRef.current.getBoundingClientRect();
          const mouseX = rect.left;
          const mouseY = rect.top;
          drawSelectedTool(ctx, x, y, drawings, updateshow);
        }
      };

      chart.subscribeCrosshairMove(updateOnChartMove);
    }

    return () => {
      chart.unsubscribeCrosshairMove(updateOnChartMove);
    };
  }, [drawings, dragOffsetref.current]);
  function distanceToLineSegment(x, y, x1, y1, x2, y2) {
    const A = x - x1;
    const B = y - y1;
    const C = x2 - x1;
    const D = y2 - y1;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;

    let xx, yy;
    if (param < 0) {
      xx = x1;
      yy = y1;
    } else if (param > 1) {
      xx = x2;
      yy = y2;
    } else {
      xx = x1 + param * C;
      yy = y1 + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;
    return Math.sqrt(dx * dx + dy * dy);
  }

  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragStartref.current = { x: e.x, y: e.y };
    // setDragStart({ x: e.layerX, y: e.layerY });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    if (e.clientX === 0 && e.clientY === 0) {
      return;
    }
    // dragStartref.current = { x: e.x, y: e.y };

    const deltaX = e.x - dragStartref.current.x;
    const deltaY = e.y - dragStartref.current.y;
    // setDragOffset((prev) => ({
    //   x: deltaX,
    //   y: deltaX,
    // }));
    dragOffsetref.current = {
      x: deltaX,
      y: deltaY,
    };
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    // dragStartref.current = { x: 0, y: 0 };
  };

  const overlayCanvasRef = useRef(null);
  const zoomLevelRef = useRef(10);
  let animationFrameId = null;
  const setupUpdatecanvas = (category, property, value) => {
    setUpdatecanvas((state) => ({
      ...state,
      [category]: {
        ...state[category],
        [property]: value,
      },
    }));
  };
  const saveupdatecanvas = () => {
    setCheckcanvas(true);
  };
  const chartOptions = {
    grid: {
      vertLines: {
        color: updatecanvas?.GridLines?.color,
        lineWidth: 1,
      },
      horzLines: {
        color: updatecanvas?.GridLines?.color,
        lineWidth: 1,
      },
    },
    crosshair: {
      mode: 0,
    },
    priceScale: {
      position: "right",
      borderVisible: false,
      autoScale: true,
      alignLabels: true,
      overlay: true,
      scaleMargins: {
        top: 0.1,
        bottom: 0.1,
      },
      minMove: 0.00001,
      formatter: (price) => price.toFixed(5),
      precision: 5,
    },
    rightPriceScale: {
      visible: true,
      borderVisible: false,
      overlay: true,
      mode: PriceScaleMode.Normal,
      autoScale: true,
      transition: {
        type: "smooth", // Smooth transition for price scale
        duration: 300, // Duration of the transition
      },
    },
    crosshair: {
      mode: CrosshairMode.Normal,
    },
    barSpacing: 1,
    timeScale: {
      fixLeftEdge: true,
      lockVisibleTimeRangeOnResize: true,
      borderVisible: false,
      borderColor: updatecanvas?.GridLines?.color,
      lineWidth: 0.5,
      timeVisible: true,
      secondsVisible: false,
      barSpacing: 3,
      minBarSpacing: 1,
      // rightOffset: 10,
      rightOffset: 0,
      timezone: updatetimezone?.timezone,
      tickMarkFormatter: (time, tickMarkType, locale) => {
        const date = new Date(time * 1000);
        const minutes = date.getMinutes();
        const hours = date.getHours();
        if (minutes % 5 === 0) {
          const options = {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: updatetimezone?.timezone,
          };
          const formattedTime = new Intl.DateTimeFormat(locale, options).format(
            date,
          );
          return formattedTime;
        }

        return "";
      },
      transition: {
        type: "smooth", // Smooth transition for time scale
        duration: 300, // Duration of the transition
      },
    },
    layout: {
      textColor: "#D1D4DC",
      background: updatecanvas?.Background,
    },
    handleScroll: { horzTouchDrag: true, vertTouchDrag: false },

    // handleScale: true,
    handleScale: {
      axisPressedMouseMove: true,
      pinch: true,
      mouseWheel: true,
      mouseWheelMode: 1,
      mode: 2,
      mouseWheelScaleFactor: 1,
    },
    kineticScroll: {
      touch: true,
      mouse: true,
    },
    panningMode: 1,
    watermark: {
      visible: false,
    },
  };

  const [buyMarkers, setBuyMarkers] = useState([]);
  const buyMarkersref = useRef([]);
  const markerSeriesRef = useRef();
  const socialMarkersref = useRef([]);
  const [timeInterval, setTimeInterval] = useState("00:00:05");
  const parseTimeString = (timeString) => {
    let string = `${timeString?.hours}:${timeString?.minutes}:${timeString?.secound}`;
    const [hours, minutes, seconds] = string.split(":").map(Number);
    return (hours * 3600 + minutes * 60 + seconds) * 1000;
  };
  const timeScaleRef = useRef(null);
  const animationFrame = useRef(null);
  const initializeChart = () => {
    const chart = createChart(tradingViewRef.current, {
      ...chartOptions,
      handleScale: true,
      handleScroll: true,
      height: tradingViewRef.current?.clientHeight,
    });
    if (otcwebsoket.current) {
      seriesRef.current.setData([]);
      otcwebsoket.current = false;
    }
    // chartRef.current = chart;
    let serice;

    if (tradestyle === "1") {
      serice = chart.addCandlestickSeries({
        ...customcaldle,
        priceLineAnimation: {
          duration: 300,
          easing: "easeOutQuint",
        },
      });
    } else if (tradestyle === "3") {
      serice = chart.addLineSeries({
        color: "#4CAF50",
        lineWidth: 2,
        crosshairMarkerVisible: true,
        priceLineVisible: true,
        lineSmoothness: 1,
      });

      if (linesettings?.showarea) {
        serice = chart.addAreaSeries({
          lastValueVisible: true,
          crosshairMarkerVisible: true,
          topColor: "rgba(56, 33, 110,0.6)",
          bottomColor: "rgba(56, 33, 110, 0.1)",
        });
      }
    } else if (tradestyle === "2") {
      serice = chart.addBarSeries({
        ...customcaldle,
        borderVisible: true,
        thinBars: false,
      });
    } else if (tradestyle === "5") {
      serice = chart.addCandlestickSeries(customcaldle);
    }

    seriesRef.current = serice;
    if (chnagetyperef.current) {
      if (
        seriesRef.current &&
        tradestyle &&
        chnagetyperef.current?.ticker &&
        chnagetyperef.current?.csymbol !== "OTC"
      ) {
        // seriesRef.current.setData([]);
        // fetchInitialData();
        fetchKlineData();
        setCheckcanvas(false);
      } else if (chnagetyperef.current?.csymbol === "OTC") {
        setCheckcanvas(false);
        // seriesRef.current.setData([]);
        fatchotcdata(tradestyle, candletimer);
      }
    }
    const overlayCanvas = document.createElement("canvas");
    overlayCanvas.width = tradingViewRef.current.clientWidth;
    overlayCanvas.height = tradingViewRef.current.clientHeight;
    overlayCanvas.className = "tradingbuysell";
    overlayCanvas.style.position = "absolute";
    overlayCanvas.style.top = 0;
    overlayCanvas.style.left = 0;
    overlayCanvas.style.pointerEvents = "none";
    overlayCanvas.style.zIndex = 2;
    overlayCanvasRef.current = overlayCanvas;
    tradingViewRef.current.appendChild(overlayCanvas);
    setChartWidth(tradingViewRef.current.clientWidth);
    setChartHeight(tradingViewRef.current.clientHeight);
    // const drawingCanvas = document.createElement("canvas");
    // drawingCanvas.width = 841;
    // drawingCanvas.height = 650;
    // drawingCanvas.style.position = "absolute";
    // drawingCanvas.style.top = 0;
    // drawingCanvas.style.left = 0;
    // drawingCanvas.style.pointerEvents = "none";
    // drawingCanvas.style.zIndex = 2;
    // drawingCanvasRef.current = drawingCanvas;
    // tradingViewRef.current.appendChild(drawingCanvas);
    setTimeout(() => {
      const tradingViewWidget = document.getElementById("tradingview-widget");
      if (tradingViewWidget) {
        const chartElement = tradingViewWidget.querySelector(
          ".tv-lightweight-charts",
        );
        if (chartElement) {
          const tableElement = chartElement.querySelector("table");
          tableElement.style.position = "relative";
          if (tableElement) {
            const trElements = tableElement.querySelectorAll("tr");

            trElements.forEach((tr, index) => {
              tr.style.width = "100%";
              const tdElements = tr.querySelectorAll("td");

              if (index === 0) {
                tdElements.forEach((td, tdIndex) => {
                  // if (tdIndex === 1) {
                  //       td.style.position="absolute"
                  //       td.classList.add("w-100")
                  //        td.style.border="1px solid red"
                  // }
                  if (tdIndex === 1) {
                    const canvaselement = td.querySelectorAll("canvas");
                    canvaselement.forEach((canvastd, Index) => {
                      if (index === 0) {
                        const drawingCanvas = document.createElement("canvas");
                        drawingCanvas.width = canvastd?.width;
                        drawingCanvas.height = canvastd?.height;
                        drawingCanvas.style.position = "absolute";
                        drawingCanvas.style.top = 0;
                        drawingCanvas.style.left = 0;
                        drawingCanvas.style.pointerEvents = "none";
                        drawingCanvas.style.zIndex = 2;
                        drawingCanvasRef.current = drawingCanvas;
                        td.appendChild(drawingCanvas);
                      }
                    });
                  }
                  if (tdIndex === 2) {
                    td.style.borderTop = "1px solid #333333";
                    // td.style.borderBottom = "1px solid #333333";
                    td.style.borderRight = "1px solid #333333";
                    td.style.backgroundColor = "rgb(21 20 25)";
                    // td.style.position="relative"
                  }
                });
              }
            });
          }
        }
      }
    }, 500);
    chart.subscribeCrosshairMove(function (param) {
      if (!param || !param.time || !param.seriesData) return;

      const price = param.seriesData.get(serice);

      if (tradestyleref.current !== "3") {
        setTooltipData({
          time: new Date(param.time * 1000).toLocaleString(),
          open: price.open.toFixed(4),
          high: price.high.toFixed(4),
          low: price.low.toFixed(4),
          close: price.close.toFixed(4),
        });
      }
    });
    chart.applyOptions({
      rightPriceScale: {
        // autoScale: false,  // Disable auto-scaling
        // borderVisible: false,
        // mode: 1,  // Keep price labels in normal mode
        // scaleMargins: {
        //   top: 0.2,
        //   bottom: 0.2,
        // },
      },
      // grid: {
      //   vertLines: { visible: false },
      //   horzLines: {
      //     color: "#ccc",
      //     visible: true,
      //     // style: 1,
      //   },
      // },
      layout: {
        fontSize: 15,
        fontFamily: "Poppins",
        textColor: "#ccc",
      },
    });

    // Set fixed price step and increase spacing
    chart.priceScale("right").applyOptions({
      autoScale: true,
      minMove: 100, // Fixed price gap (e.g., 83580 → 83530 → 83480)
      tickMarkSpacingMultiplier: 10, // Increase grid gap (higher = more space)
    });
    chart.applyOptions({
      layout: {
        padding: {
          right: 20, // Reduce right padding to shift the price scale inside
        },
      },
    });
    chart.subscribeCrosshairMove((param) => {
      if (param.point && param.time) {
        const mouseX = param.point.x;
        const mouseY = param.point.y;
        const timeCoordinate = chart.timeScale().timeToCoordinate(param.time);
        mousePositionref.current = {
          x: mouseX,
          y: mouseY,
          time: timeCoordinate
            ? new Date(timeCoordinate * 1000).toLocaleString()
            : null,
          price: timeCoordinate ? timeCoordinate.toFixed(2) : null,
        };
      }
    });
    let visibleCandles = 9;
    // chart.timeScale().subscribeVisibleLogicalRangeChange((logicalRange) => {
    //         const visibleRange = logicalRange || { from: 0, to: 0 };
    //         const visibleBars = visibleRange.to - visibleRange.from;
    //         if (visibleBars < visibleCandles) {
    //             chart.timeScale().setVisibleLogicalRange({
    //                 from: visibleRange.to - visibleCandles,
    //                 to: visibleRange.to,
    //             });
    //         }
    //     });
    const handleWheel = (event) => {
      event.preventDefault();
      const wheelDelta =
        Math.sign(event.deltaY) * Math.min(1, Math.abs(event.deltaY * 0.01));
      const zoomFactor = wheelDelta > 0 ? 0.5 : 1.5;

      smoothZoom(zoomFactor);
    };
    chart.applyOptions({
      handleScale: {
        mouseWheel: true,
        pinch: true,
        axisPressedMouseMove: true,
        scaleSensitivity: 0.02, // Adjust lower for smoother zoom
      },
      handleScroll: {
        mouseWheel: true,
        pressedMouseMove: true,
        horzTouchDrag: true,
        scrollSensitivity: 0.01, // Adjust lower for smoother scroll
      },
      kineticScroll: {
        touch: true,
        mouse: true,
      },
      transition: {
        duration: 500, // Smooth animation duration
        timingFunction: "ease-in-out",
      },
    });

    tradingViewRef.current.addEventListener("wheel", handleWheel);
    // Resize observer
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === tradingViewRef.current) {
          const { width, height } = entry.contentRect;
          serice.applyOptions({ width, height });
        }
      }
    });

    resizeObserver.observe(tradingViewRef.current);
    // chart.subscribeCrosshairMove(() => {
    //   // setMaxZoom()
    //   const timeScale = chart.timeScale();
    //   const visibleRange = timeScale.getVisibleRange();
    //   // console.log(visibleRange, "visibleRange")
    //   const data = serice.data();
    //   if (visibleRange && data.length > 0) {
    //     const visibleCandles = data.filter(
    //       (candle) =>
    //         candle.time >= visibleRange.from && candle.time <= visibleRange.to
    //     );
    //     const currentMinuteTimestamp = data[data?.length - 1]?.time;
    //     const exists = visibleCandles.some(
    //       (item) => item.time === currentMinuteTimestamp
    //     );
    //     let checktime = timeScale.timeToCoordinate(
    //       data[data?.length - 1]?.time
    //     );
    //     if (exists && checktime < 532) {
    //       const len = visibleCandles?.length || 0;

    //       if (len > 7) {
    //         chart.timeScale().scrollToPosition(5, false);
    //       } else if (len >= 5 && len < 8) {
    //         chart.timeScale().scrollToPosition(3, false);
    //       } else {
    //         chart.timeScale().scrollToPosition(1, false);
    //       }
    //     }
    //   }
    // });

    return () => {
      //  cancelAnimationFrame(animationRef.current);
      resizeObserver.disconnect();
      chart.remove();
      // tradingViewRef.current.removeEventListener("wheel", handleWheel);
    };
  };
  // useEffect(() => {
  //   if (!chartRef.current) return;

  //   const setMaxZoom = () => {
  //     const lastVisibleRange =
  //       setcandlerange.current[setcandlerange.current.length - 1];
  //     const checkCandleVisible = chartRef.current
  //       .timeScale()
  //       .getVisibleLogicalRange();

  //     setcandlerange.current = [...setcandlerange.current, checkCandleVisible];

  //     animateClosePriceUpdate1(
  //       lastVisibleRange,
  //       checkCandleVisible,
  //       100, // Adjust duration (500ms for smoother animation)
  //       (animatedClose) => {
  //         chartRef.current.timeScale().setVisibleLogicalRange({
  //           from: animatedClose.from,
  //           to: animatedClose.to,
  //         });
  //       }
  //     );
  //   };

  //   const chart = chartRef.current;
  //   chart.subscribeCrosshairMove(setMaxZoom);

  //   return () => {
  //     chart.unsubscribeCrosshairMove(setMaxZoom);
  //   };
  // }, [setcandlerange.current]);

  function animateClosePriceUpdate1(oldClose, newClose, duration, onUpdate) {
    if (websoketclose.current) {
      const start = performance.now();

      function animate(now) {
        const progress = Math.min((now - start) / duration, 1);
        const easing = easeInOutQuad(progress); // Apply easing for smooth effect
        if (oldClose.from) {
          const interpolatedClose = {
            from: oldClose.from + (newClose.from - oldClose.from) * easing,
            to: oldClose.to + (newClose.to - oldClose.to) * easing,
          };
          onUpdate(interpolatedClose);
        }

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);
    }
  }

  // Easing Function (for smooth animation)
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  // useEffect(() => {
  //   if (otcwebsoket.current) {
  //     seriesRef.current.setData([]);
  //     otcwebsoket.current = false;
  //   }
  //   if (chnagetyperef.current) {
  //     const cleanup = initializeChart();
  //     return () => cleanup();
  //   }
  // }, [
  //   candletimer,
  //   customcaldle,
  //   linesettings,
  //   tradestyle,
  //   chnagetyperef.current,
  //   updatetimezone,
  //   checkcanvs,
  // ]);
  const easeOutExpo = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

  let zoomAnimations = {
    time: null,
    price: null,
  };

  const cancelAllAnimations = () => {
    Object.values(zoomAnimations).forEach((id) => {
      if (id) cancelAnimationFrame(id);
    });
    zoomAnimations = { time: null, price: null };
  };

  const smoothZoom = (delta) => {
    if (!chartRef.current || !seriesRef.current) return;
    cancelAllAnimations();
    const chart = chartRef.current;
    const candleSeries = seriesRef.current;
    const timeScale = chart.timeScale();
    const priceScale = chart.priceScale("right");

    // Get current state
    const width = timeScale.width();
    const centerCoordinate = width / 2;
    const logicalCenter = timeScale.coordinateToLogical(centerCoordinate);
    const currentSpacing = timeScale.options().barSpacing;
    const targetSpacing = Math.max(0.5, Math.min(currentSpacing * delta, 500));

    // Animation parameters
    const duration = 100; // Adjusted for smoothness
    let startTime = null;

    // Time scale animation
    const animateTimeScale = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutExpo(progress);

      // Calculate new spacing
      const newSpacing =
        currentSpacing + (targetSpacing - currentSpacing) * easedProgress;

      // Recalculate center after each frame for smooth transition
      const currentLogicalCenter =
        timeScale.coordinateToLogical(centerCoordinate);
      const halfVisibleBars = width / newSpacing / 2;

      // Apply bar spacing and maintain center
      timeScale.applyOptions({ barSpacing: newSpacing });
      timeScale.setVisibleLogicalRange({
        from: currentLogicalCenter - halfVisibleBars,
        to: currentLogicalCenter + halfVisibleBars,
      });

      if (progress < 1) {
        zoomAnimations.time = requestAnimationFrame(animateTimeScale);
      } else {
        zoomAnimations.time = null;
      }
    };

    // Start the animation
    zoomAnimations.time = requestAnimationFrame(animateTimeScale);
  };

  const handleScroll1 = () => {
    if (!chartRef.current || !seriesRef.current) return;
    const chart = chartRef.current;
    const candleSeries = seriesRef.current;

    const timeScale = chart.timeScale();
    const priceScale = chart.priceScale("right");
    const visibleLogicalRange = timeScale.getVisibleLogicalRange();

    if (!visibleLogicalRange) return;

    const barsInfo = candleSeries.barsInLogicalRange(visibleLogicalRange);
    if (!barsInfo || !barsInfo.barsBefore || !barsInfo.barsAfter) return;

    let { lowest, highest } = barsInfo;
    if (lowest === undefined || highest === undefined) return;

    let newMin = lowest;
    let newMax = highest;

    // Define a padding factor for smooth zoom
    let paddingFactor = 10.15;
    let padding = (newMax - newMin) * paddingFactor;

    newMin -= padding;
    newMax += padding;

    let currentMin = priceScale.options().minValue || newMin;
    let currentMax = priceScale.options().maxValue || newMax;

    let steps = 100; // Number of animation steps for the price scale
    let priceStepMin = (newMin - currentMin) / steps;
    let priceStepMax = (newMax - currentMax) / steps;
    let priceCount = 0;

    // Function to animate the price scale transition smoothly
    const animatePriceScale = () => {
      if (priceCount < steps) {
        priceScale.applyOptions({
          minValue: currentMin + priceStepMin * priceCount,
          maxValue: currentMax + priceStepMax * priceCount,
        });
        priceCount++;
        requestAnimationFrame(animatePriceScale);
      }
    };

    animatePriceScale();
  };

  // useEffect(() => {
  //   if (!chartRef.current) return;
  //   const timeScale = chartRef.current.timeScale();
  //   timeScale.subscribeVisibleTimeRangeChange(handleScroll1);
  //   return () => timeScale.unsubscribeVisibleTimeRangeChange(handleScroll1);
  // }, []);

  const zoomAnimationRef = useRef(null);
  const zoomTargetRef = useRef(null);
  const zoomStartRef = useRef(null);
  const lastScrollTimeRef = useRef(0);

  const smoothTimeScaleZoom = (targetZoom, duration = 300) => {
    const timeScale = chartRef.current.timeScale();
    const startZoom = timeScale.options().barSpacing;
    const startTime = performance.now();
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    if (zoomAnimationRef.current) {
      cancelAnimationFrame(zoomAnimationRef.current);
    }

    zoomTargetRef.current = targetZoom;
    zoomStartRef.current = startZoom;

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutCubic(progress);
      const easedZoom = startZoom + (targetZoom - startZoom) * easedProgress;

      timeScale.applyOptions({ barSpacing: easedZoom });

      if (progress < 1) {
        zoomAnimationRef.current = requestAnimationFrame(animate);
      }
    };

    zoomAnimationRef.current = requestAnimationFrame(animate);
  };

  // Optimized Scroll Handler
  const handleScroll = (event) => {
    // chartRef.current.applyOptions({
    //   handleScale: { scaleSensitivity: 0.5 },
    // });
    // chartRef.current.applyOptions({
    //   handleScroll: { scrollSensitivity: 0.5 },
    // });
    // event.preventDefault();
    // const now = performance.now();
    // // Efficient throttle (100ms delay for smoother feel)
    // if (now - lastScrollTimeRef.current < 100) return;
    // lastScrollTimeRef.current = now;
    // const timeScale = chartRef.current.timeScale();
    // // Exponential zoom factor for consistent scaling effect
    // const zoomFactor = event.deltaY > 0 ? 0.95 : 1.05;
    // // Set a dynamic target zoom level within min/max constraints
    // const targetBarSpacing = Math.max(2, Math.min(500, timeScale.options().barSpacing * zoomFactor));
    // // Check if already zooming to avoid jerky resets
    // if (zoomTargetRef.current !== targetBarSpacing) {
    //   smoothTimeScaleZoom(targetBarSpacing, 300);
    // }
  };
  function cubicSplineInterpolation(data, numPoints) {
    const smoothData = [];
    const xValues = data.map((item) => item.time);
    const yValues = data.map((item) => item.value);
    const step = (xValues[xValues.length - 1] - xValues[0]) / (data.length - 1);

    for (let i = 0; i < data.length; i++) {
      const x = xValues[0] + step * i;
      let y = 0;

      for (let j = 0; j < xValues.length - 1; j++) {
        if (x >= xValues[j] && x <= xValues[j + 1]) {
          const slope =
            (yValues[j + 1] - yValues[j]) / (xValues[j + 1] - xValues[j]);
          y = yValues[j] + slope * (x - xValues[j]);
          break;
        }
      }
      smoothData.push({ time: x, value: y });
    }

    return smoothData;
  }
  const [crosshairPosition, setCrosshairPosition] = useState({ x: 0, y: 0 });
  const doesTextOverlap = (
    newTextX,
    newTextY,
    newTextWidth,
    newTextHeight,
    existingTexts,
  ) => {
    for (const existingText of existingTexts) {
      const { x, y, width, height } = existingText;
      if (
        newTextX < x + width &&
        newTextX + newTextWidth > x &&
        newTextY < y + height &&
        newTextY + newTextHeight > y
      ) {
        return true;
      }
    }
    return false;
  };
  const getAdjustedTextPosition = (
    ctx,
    text,
    timeCoordinate,
    logical,
    existingTexts,
  ) => {
    const textWidth = ctx.measureText(text).width + 10;
    const textHeight = 20;
    let textX = timeCoordinate - textWidth - 10;
    let textY = logical - textHeight / 2;
    while (
      doesTextOverlap(textX, textY, textWidth, textHeight, existingTexts)
    ) {
      textX -= textWidth + 10;
      if (textX < 10) {
        textX += 30;
        textY += textHeight + 5;
      }
    }

    return { textX, textY, textWidth, textHeight };
  };

  const updateOnChartMove = (param) => {
    if (!param || !param.localPoint) return;
    const { localPoint } = param;
    setCrosshairPosition({
      x: localPoint.x,
      y: localPoint.y,
    });
  };

  const indicatorSeriesRef = useRef();
  const markerDataItemsRef = useRef();
  const horizontalLineSeriesRef = useRef([]);
  const closeTimeLinesRef = useRef([]);
  const createFlagBullet = useCallback(() => {
    const root = rootref.current;
    const mainPanel = mainPanelRef.current;
    if (!root || !mainPanel) return null;

    // Overlay container pinned to plotContainer
    const overlay = mainPanel.plotContainer.children.push(
      am5.Container.new(root, {
        isMeasured: false,
        y: 0, // always top
        x: 0,
        width: am5.p100,
        height: 1, // no height, just overlay
        zIndex: 10000,
        interactive: false,
      }),
    );

    // Add the flag inside overlay
    const flagSprite = overlay.children.push(
      am5.Picture.new(root, {
        src: exp_duplicate_flag,
        width: 20,
        height: 13,
        centerX: am5.p0,
        centerY: 0,
      }),
    );

    // Wrap in AxisBullet so it moves horizontally with the axis
    return am5xy.AxisBullet.new(root, {
      location: 1,
      sprite: overlay,
    });
  }, []);
  useEffect(() => {
    if (
      !isReadyRef.current ||
      !rootref.current ||
      !valueSeriesref.current ||
      rootref.current.isDisposed()
    )
      return;
    let matches = buyMarkersref.current.filter(
      (item) => item.ticker === chnagetyperef.current.ticker,
    );
    console.log(matches, "matchesmatches", buyMarkersref.current);
    const root = rootref.current;
    const chart = valueSeriesref.current.chart;
    const xAxis = valueSeriesref.current.get("xAxis");
    const yAxis = valueSeriesref.current.get("yAxis");
    // Dispose previous indicator series if exists
    if (
      indicatorSeriesRef.current &&
      !indicatorSeriesRef.current.isDisposed()
    ) {
      chart.series.removeValue(indicatorSeriesRef.current);
      indicatorSeriesRef.current.dispose();
    }
    horizontalLineSeriesRef.current.forEach((line) => {
      if (!line.isDisposed()) line.dispose();
    });
    horizontalLineSeriesRef.current = [];
    // Create new indicator series
    const indicatorSeries = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Buy Indicators",
        xAxis: valueSeriesref.current.get("xAxis"),
        yAxis: valueSeriesref.current.get("yAxis"),
        valueXField: "time",
        valueYField: "price",
        visible: true,
        strokeOpacity: 0,
        fillOpacity: 0,
      }),
    );

    indicatorSeries.strokes.template.setAll({
      strokeOpacity: 0,
      strokeWidth: 0,
    });
    indicatorSeries.strokes.clear();
    indicatorSeriesRef.current = indicatorSeries;

    // Configure bullets for markers

    indicatorSeries.bullets.push((root, series, dataItem) => {
      const markerData = dataItem.dataContext;
      if (!markerData || !markerData.isMarker) return;
      const container = am5.Container.new(root, {
        layout:
          markerData?.status === "open"
            ? root.horizontalLayout
            : root.verticalLayout,
        centerY: markerData?.status === "open" ? am5.p50 : am5.p100,
        centerX: markerData?.status === "open" ? am5.p100 : am5.p50,
        dy: markerData?.status === "open" ? 0 : 10,
        dx: 0,
        location: 0,
        //  paddingTop: 2,
        //   paddingBottom: 2,
        layer: 150,
      });

      const dot = am5.Circle.new(root, {
        radius: 4,
        fill: am5.color(0xffffff),
        stroke: am5.color(markerData?.color),
        strokeWidth: 1,
        dy: 6,
      });

      const line = am5.Line.new(root, {
        height: 1,
        width: markerData?.dx ? markerData?.dx + 50 : 10,
        stroke: am5.color(markerData?.color),
        strokeWidth: 1.5,
        dy: 5,
      });
      const label = am5.Label.new(root, {
        text:
          markerData?.tradetype === "buy"
            ? `▲ [bold]${markerData.text}[/]`
            : `▼ [bold]${markerData.text}[/]`,
        fill: am5.color("#ffffff"),
        fontWeight: "normal",
        textAlign: "center",
        background: am5.RoundedRectangle.new(root, {
          fill: am5.color(markerData?.color),
          fillOpacity: 0.8,
          cornerRadius: 4,
          stroke: am5.color(markerData?.color),
          strokeWidth: 1,
          // dy:-50
        }),
        paddingTop: 4,
        paddingLeft: 8,
        paddingRight: 8,
        dy: -15,
        // marginLeft:50
        // html: true
      });

      if (markerData?.status === "open") {
        dataItem.set("customLabel", label);
        container.children.push(label);
        container.children.push(line);
        container.children.push(dot);
        console.log(markerData, "markerData open", container);
      } else {
        console.log(markerData, "markerData close");
        const valueLabel = am5.Label.new(root, {
          text: `${markerData.text} ✓`,
          fontSize: 12,
          fontWeight: "bold",
          fill: am5.color("#ffffff"),
          centerX: am5.p50,
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 4,
          paddingBottom: 4,
          background: am5.RoundedRectangle.new(root, {
            fill: am5.color(0x000000), // Black background
            stroke: am5.color(markerData?.color), // Green border
            strokeWidth: 1,
            cornerRadius: 6,
          }),
          marginBottom: markerData?.marginBottom,
        });
        const dot = am5.Circle.new(root, {
          // text: "▼",
          radius: 4,
          fill: am5.color(0xffffff),
          stroke: am5.color(markerData?.color),
          strokeWidth: 1,
          dy: 2,
        });
        const imageWrapper = am5.Container.new(root, {
          width: 200,
          height: 100,
          centerX: am5.p50,
          centerY: am5.p50,
          visible: openImagesRef.current.get(markerData?.id) === true,
          background: am5.Rectangle.new(root, { fillOpacity: 0 }),
        });

        // Track current image index
        let currentImageIndex = 0;

        const imagesArray = Array.isArray(markerData?.imageurl)
          ? markerData.imageurl
          : [markerData?.imageurl];

        const image = am5.Picture.new(root, {
          width: 200,
          height: 100,
          x: 0,
          y: 0,
          src: imagesArray[currentImageIndex],
          mask: am5.RoundedRectangle.new(root, {
            cornerRadius: 25,
            width: 200,
            height: 100,
          }),
        });

        imageWrapper.children.push(image);

        const closeIcon = am5.Label.new(root, {
          text: "✕",
          fontSize: 14,
          fill: am5.color(0xffffff),
          background: am5.RoundedRectangle.new(root, {
            fill: am5.color(0x0000),
            cornerRadius: 20,
          }),
          paddingTop: 2,
          paddingBottom: 2,
          paddingLeft: 6,
          paddingRight: 6,
          x: 180,
          y: 0,
          cursorOverStyle: "pointer",
        });

        closeIcon.events.on("click", function () {
          imageWrapper.set("visible", false);
          checkimageopen.current = false;
          openImagesRef.current.set(markerData?.id, false);
          resumeTimeout(markerData);
        });

        imageWrapper.children.push(closeIcon);

        // === Prev & Next buttons ===
        if (imagesArray.length > 1) {
          // Prev (left center)
          const prevIcon = am5.Label.new(root, {
            text: "<",
            fontSize: 16,
            fill: am5.color(0xffffff),
            x: -10,
            y: 50, // vertical center (half of height)
            background: am5.RoundedRectangle.new(root, {
              fill: am5.color(0x000000),
              fillOpacity: 0.4,
              cornerRadius: 20,
            }),
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 6,
            paddingRight: 6,
            cursorOverStyle: "pointer",
          });

          prevIcon.events.on("click", () => {
            currentImageIndex =
              (currentImageIndex - 1 + imagesArray.length) % imagesArray.length;
            image.set("src", imagesArray[currentImageIndex]);
          });

          // Next (right center)
          const nextIcon = am5.Label.new(root, {
            text: ">",
            fontSize: 16,
            fill: am5.color(0xffffff),
            x: 195,
            y: 50, // vertical center
            background: am5.RoundedRectangle.new(root, {
              fill: am5.color(0x000000),
              fillOpacity: 0.4,
              cornerRadius: 20,
            }),
            paddingTop: 4,
            paddingBottom: 4,
            paddingLeft: 6,
            paddingRight: 6,
            cursorOverStyle: "pointer",
          });

          nextIcon.events.on("click", () => {
            currentImageIndex = (currentImageIndex + 1) % imagesArray.length;
            image.set("src", imagesArray[currentImageIndex]);
          });

          imageWrapper.children.push(prevIcon);
          imageWrapper.children.push(nextIcon);
        }

        // Attach marker visuals
        container.children.push(imageWrapper);
        container.children.push(valueLabel);
        container.children.push(dot);

        // Toggle image visibility
        function toggleImage() {
          if (openImagesRef.current.get(markerData?.id)) return;
          imageWrapper.set("visible", true);
          checkimageopen.current = true;
          openImagesRef.current.set(markerData?.id, true);
          pauseTimeout(markerData?.id);
        }

        valueLabel.events.on("click", toggleImage);
        dot.events.on("click", toggleImage);
      }

      return am5.Bullet.new(root, {
        sprite: container,
        locationY: 1,
        layer: 9999,
      });
    });

    // Prepare initial indicator data with dx offset
    const markerSpacing = 70;
    const maxPerRow = 15;
    //     console.log(matches, "markerData close");
    // console.log("indicatorData", indicatorSeriesRef.current.data )
    const indicatorData = matches.map((marker, index) => {
      const marginBottom = index < matches.length - 1 ? 25 : 0;
      const dx = (index % maxPerRow) * markerSpacing;
      return {
        time: marker.time,
        price: parseFloat(marker.price),
        text: marker.text,
        color: marker.color,
        isMarker: true,
        dx: dx,
        status: marker?.status,
        ticker: marker?.ticker,
        tradetype: marker?.tradetype,
        marginBottom: marginBottom,
        duration: marker?.duration,
        closeTime: marker?.close_time,
        id: marker?.id,
        imageurl: marker?.imageurl,
      };
    });

    // console.log(indicatorSeriesRef.current, "indicatorData 23")

    indicatorSeries.data.setAll(indicatorData);
    indicatorSeriesRef.current = indicatorSeries;
    closeTimeLinesRef.current.forEach((range) => {
      range.dispose();
    });
    return;
    closeTimeLinesRef.current = [];
    function convertUTCToLocalTimestamp(timeString) {
      const utcDate = new Date(timeString + " UTC"); // force it to parse as UTC

      const localDate = new Date(utcDate.getTime()); // convert to local time automatically

      const localTimeString = localDate.toLocaleString(); // for readable local time
      const localTimestamp = localDate.getTime(); // local timestamp in ms

      return { localTimeString, localTimestamp };
    }

    // === Create vertical line for each marker with closeTime ===
    indicatorData.forEach((marker) => {
      if (marker.closeTime) {
        const closeTimestamp = convertUTCToLocalTimestamp(
          marker.closeTime,
        )?.localTimestamp;

        // === Vertical line with flag ===
        const rangeDataItem = xAxis.makeDataItem({ value: closeTimestamp });
        const range = xAxis.createAxisRange(rangeDataItem);
        range.get("grid").setAll({
          stroke: am5.color(0xffffff),
          strokeOpacity: 0.5,
          strokeWidth: 0.5,
        });
        range.set("bullet", createFlagBullet());
        closeTimeLinesRef.current.push(range);

        // === Extra vertical line with flag (duplicate) ===
        const rangeDataItemh = xAxis.makeDataItem({ value: closeTimestamp });
        const rangef = xAxis.createAxisRange(rangeDataItemh);
        rangef.get("grid").setAll({
          stroke: am5.color(0xffffff),
          strokeOpacity: 0.5,
          strokeWidth: 0.5,
        });
        rangef.set("bullet", createFlagBullet());
        closeTimeLinesRef.current.push(rangef);

        if (window.innerWidth >= 900) {
          const horizontalLine = chart.series.push(
            am5xy.LineSeries.new(root, {
              xAxis: xAxis,
              yAxis: yAxis,
              valueXField: "valueX",
              valueYField: "valueY",
              stroke: am5.color(marker.color),
              strokeWidth: 1,
            }),
          );
        }
      }
    });
  }, [buyMarkersref.current.map((m) => `${m?.status}-${m?.imageurl}`).join()]);
  function pauseTimeout(trade) {
    const ids = Array.isArray(trade) ? trade : [trade];
    ids.forEach((id) => {
      const timeoutId = timeoutMapRef.current.get(id);
      if (!timeoutId) return;

      clearTimeout(timeoutId);
      timeoutMapRef.current.delete(id);

      const elapsed = Date.now() - (startTimeMapRef.current.get(id) ?? 0);
      const remaining =
        (remainingTimeMapRef.current.get(id) ?? totalTimeout) - elapsed;

      remainingTimeMapRef.current.set(id, remaining);
    });
  }

  // --- Resume Timeout (optional call from outside)
  function resumeTimeout(trade) {
    const ids = Array.isArray(trade.id) ? trade.id : [trade.id];
    ids.forEach((id) => {
      const filtered = buyMarkersref.current.filter((m) => m.id !== trade?.id);
      buyMarkersref.current = [...filtered];
    });
  }
  useEffect(() => {
    const series = indicatorSeriesRef.current;
    if (!series || !series.dataItems) return;
    const currentMarkers = buyMarkersref.current;
    series.dataItems.forEach((dataItem, index) => {
      const updated = currentMarkers[index];

      if (
        !updated ||
        typeof updated.text !== "string" ||
        updated.text.trim() === ""
      )
        return;
      const label = dataItem.get("customLabel");
      if (label && updated && label.get("text") !== updated.text) {
        label.set(
          "text",
          updated?.tradetype === "buy"
            ? `▲ [bold]${updated.text}[/]`
            : `▼ [bold]${updated.text}[/]`,
        ); // ✅ manually update the label's text
      }
    });
  }, [buyMarkersref.current.map((m) => m.text).join()]);
  const generateUniqueId = () => {
    const id = uuidv4();
    return id;
  };
  const [uniqueidkey, setUniqueidkey] = useState([]);
  const startTimer = (time, uid) => {
    // const [hours, minutes, seconds] = time.split(":");
    const totalSeconds =
      (parseInt(time?.hours) || 0) * 3600 +
      (parseInt(time?.minutes) || 0) * 60 +
      (parseInt(time?.secound) || 0);
    return totalSeconds;
  };
  const formatAmount = (amount) => {
    const num = parseFloat(amount);
    return Number.isInteger(num) ? num.toFixed(0) : num.toFixed(2);
  };
  const timeoutRef = useRef(null);
  const getStartAndCloseTimefortime = (time, duration) => {
    const formatTime = (date) =>
      date.toLocaleTimeString("en-US", { hour12: false }) +
      " " +
      date.toISOString().split("T")[0];
    const startDate = new Date(time);
    const [h, m, s] = duration?.split(":").map(Number);
    const closeDate = new Date(
      startDate.getTime() + h * 3600 * 1000 + m * 60 * 1000 + s * 1000,
    );

    return {
      closeTime: closeDate,
    };
  };
  function adjustUTCWithDate12(dateStr, timezone) {
    if (!dateStr || !timezone) return null;

    let utcDate;

    if (dateStr.includes("T") && dateStr.endsWith("Z")) {
      utcDate = new Date(dateStr);
    } else {
      const [datePart, timePart] = dateStr.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);
      utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    }
    const { haur, minute: tzMin, plus } = timezone;
    const hourOffset = parseInt(haur, 10) || 0;
    const minuteOffset = parseInt(tzMin, 10) || 0;
    const totalOffsetMinutes = hourOffset * 60 + minuteOffset;

    // Apply offset (+ or -)
    if (plus === "+") {
      utcDate.setUTCMinutes(utcDate.getUTCMinutes() + totalOffsetMinutes);
    } else {
      utcDate.setUTCMinutes(utcDate.getUTCMinutes() - totalOffsetMinutes);
    }

    return utcDate.getTime();
  }
  function applyTimezoneOffset(timestampSec, timezone) {
    const baseDateMs = timestampSec * 1000;
    const sign = timezone.plus === "+" ? 1 : -1;
    const offsetMs =
      (Number(timezone.haur) * 60 + Number(timezone.minute)) * 60 * 1000 * sign;

    return baseDateMs + offsetMs;
  }

  const tradetimmer = async (opentrade, buyMarkers) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    const updateTime = () => {
      if (!opentrade?.length || !buyMarkers?.length) return;
      if (!currenttimeref.current) {
        timeoutRef.current = setTimeout(updateTime, 1000);
        return;
      }

      const updatedTrades = opentrade.map((trade) => {
        if (!trade?.close_time) return;

        const closeTime = adjustUTCWithDate12(
          trade?.close_time,
          updatetimezone,
        );
        const timestampMs = new Date(trade?.trade_timestamp).getTime();
        let now;

        if (timestampMs > currenttimeref.current.timestamp * 1000) {
          now = applyTimezoneOffset(
            currenttimeref.current.timestamp + 1,
            updatetimezone,
          );
        } else {
          now = applyTimezoneOffset(
            currenttimeref.current.timestamp,
            updatetimezone,
          );
        }
        const timeDiff = Math.max(0, Math.floor((closeTime - now) / 1000));
        const initialTime =
          trade.initialTime ||
          Math.floor((closeTime - new Date(trade.start_time).getTime()) / 1000);
        const remainingTime = Math.max(0, Math.ceil(initialTime - timeDiff));
        const progress = Math.min((remainingTime / initialTime) * 100, 100);
        const newTimeLeft = [
          String(Math.floor(timeDiff / 3600)).padStart(2, "0"),
          String(Math.floor((timeDiff % 3600) / 60)).padStart(2, "0"),
          String(timeDiff % 60).padStart(2, "0"),
        ].join(":");
        const newTimeLeftCompact =
          timeDiff >= 3600
            ? newTimeLeft
            : [
                String(Math.floor((timeDiff % 3600) / 60)).padStart(2, "0"),
                String(timeDiff % 60).padStart(2, "0"),
              ].join(":");

        return {
          ...trade,
          timeleft: newTimeLeft,
          progress,
          text: `$${formatPrice(trade.amount, 2)}[/]\n${newTimeLeftCompact}`,
          newTimeLeftCompact: newTimeLeftCompact,
        };
      });
      console.log(
        [
          ...updatedTrades.filter(
            (t) => t?.timeleft !== "00:00:00" && t?.status !== "close",
          ),
        ],
        "opentradeopentrade 1",
      );
      setOpentrade([
        ...updatedTrades.filter(
          (t) => t?.timeleft !== "00:00:00" && t?.status !== "close",
        ),
      ]);

      updatedTrades.forEach((trade) => {
        const markerIndex = buyMarkersref.current.findIndex(
          (m) => m.id === trade.id,
        );

        if (
          markerIndex !== -1 &&
          trade.status === "open" &&
          trade?.timeleft !== "00:00:00"
        ) {
          buyMarkersref.current[markerIndex] = {
            ...buyMarkersref.current[markerIndex],
            ...trade,
          };
        }
        console.log(buyMarkersref.current[markerIndex], "markerIndex");
      });

      // ✅ Ensure all `id`s in `buyMarkersref.current` are unique
      const uniqueMap = new Map();
      buyMarkersref.current.forEach((item) => {
        if (item && item.id) {
          uniqueMap.set(item.id, item); // this keeps only the latest entry for duplicate ids
        }
      });

      buyMarkersref.current = Array.from(uniqueMap.values());
      if (updatedTrades.some((t) => t.status !== "close")) {
        timeoutRef.current = setTimeout(updateTime, 1000);
      }
    };
    updateTime();
  };

  useEffect(() => {
    if (websoketclose.current) {
      opentradedata(true);
      buyMarkersref.current = [];
      clearTimeout(timeoutRef.current);
    }
  }, [
    chnagetyperef.current,
    updatetimezone,
    websoketclose.current,
    checkliveaccount,
  ]);
  const getStartAndCloseTime = (time, duration) => {
    const formatTime = (date) =>
      date.toLocaleTimeString("en-US", { hour12: false });
    const startDate = new Date(time);
    const formattedStartTime = formatTime(startDate);

    // Parse the duration
    const [h, m, s] = duration?.split(":").map(Number);

    // Calculate the close time
    const closeDate = new Date(
      startDate.getTime() + h * 3600 * 1000 + m * 60 * 1000 + s * 1000,
    );
    const formattedCloseTime = formatTime(closeDate);

    // Convert duration to the desired format
    const formatDuration = (h, m, s) => {
      let result = "";
      if (h > 0) result += `${h}H`;
      if (m > 0) result += `${m}M`;
      if (s > 0) result += `${s}S`;
      return result || "0S"; // Default to "0S" if duration is 0
    };

    const formattedDuration = formatDuration(h, m, s);

    return {
      startTime: formattedStartTime,
      closeTime: formattedCloseTime,
      duration: formattedDuration,
    };
  };
  function timeToUnixTimestamp(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    const now = new Date();
    now.setHours(hours, minutes, seconds, 0);
    return Math.floor(now.getTime() / 1000); // returns Unix timestamp in seconds
  }
  const width = 150;
  const height = 100;
  function convertSvgToImageBase64(
    svgString,
    type = "image/png",
    width = 300,
    height = 150,
  ) {
    return new Promise((resolve) => {
      const svgBlob = new Blob([svgString], {
        type: "image/svg+xml;charset=utf-8",
      });
      const url = URL.createObjectURL(svgBlob);

      const image = new Image();
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, width, height);

        const dataUrl = canvas.toDataURL(type); // "image/png" or "image/jpeg"
        URL.revokeObjectURL(url);
        resolve(dataUrl);
      };

      image.src = url;
    });
  }
  const getDurationType = (durationStr) => {
    const [hours, minutes, seconds] = durationStr.split(":").map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;

    if (totalSeconds >= 1 && totalSeconds <= 60) {
      return { duration: 1, type: "second", format: "S1" };
    } else if (totalSeconds >= 61 && totalSeconds <= 1800) {
      return { duration: 10, type: "second", format: "S10" };
    } else if (totalSeconds >= 1801 && totalSeconds <= 3600) {
      return { duration: 1, type: "minute", format: "M1" };
    } else if (totalSeconds >= 3601 && totalSeconds <= 8200) {
      return { duration: 2, type: "minute", format: "M2" };
    } else {
      return { duration: 5, type: "minute", format: "M5" }; // fallback case
    }
  };

  const polygonapi = async (apidata, checkptofit) => {
    try {
      setGraphdata({
        labelX: "",
        labelY: "",
        arrowEndX: "",
        arrowEndY: "",
        d: "",
        points: [],
      });

      const { startTime, closeTime } = getStartAndCloseTime(
        apidata?.trade_timestamp,
        apidata?.duration,
      );
      const DurationType = getDurationType(apidata?.duration);

      let updatestarttime = "";
      let updateclosetime = "";
      let response = "";
      let callapi;

      // ---------- Data Fetch ----------
      if (apidata?.pair_to === "OTC") {
        updatestarttime = timeToUnixTimestamp(startTime) - 5;
        updateclosetime = timeToUnixTimestamp(closeTime) + 5;
        const postdata = await callApi(
          {},
          `api/get-ohlc-data/${apidata?.ticker}/${DurationType?.duration}/${DurationType?.type}/${updatestarttime}/${updateclosetime}?adjusted=false&sort=asc`,
          "GET",
        );
        if (postdata?.data?.success) {
          response = { results: postdata?.data?.data, status: "OK" };
          callapi = await response;
        }
      } else {
        updatestarttime = (timeToUnixTimestamp(startTime) - 5) * 1000;
        updateclosetime = (timeToUnixTimestamp(closeTime) + 5) * 1000;
        const ticker =
          apidata?.trade_type === "currencies"
            ? `C:${apidata?.pair_from}${apidata?.pair_to}`
            : `X:${apidata?.pair_from}${apidata?.pair_to}`;
        const postdata = `https://api.massive.com/v2/aggs/ticker/${ticker}:${apidata?.pair_from}${apidata?.pair_to}/range/${DurationType?.duration}/${DurationType?.type}/${updatestarttime}/${updateclosetime}?adjusted=true&apiKey=${API_KEY}`;
        response = await fetch(postdata);
        callapi = await response.json();
      }

      // ---------- Chart Build ----------
      if (callapi?.status === "OK" && callapi?.results?.length) {
        const data = callapi?.results
          ?.filter(({ t }) => t >= updatestarttime && t <= updateclosetime)
          .map(({ t, c }) => ({ time: t, value: c }));

        if (!data.length) return;

        // ✅ FIXED SCALE + CLAMP
        const verticalPadding = 25;
        const values = data.map((d) => d.value);
        const rawMax = Math.max(...values);
        const rawMin = Math.min(...values);
        const buffer = (rawMax - rawMin) * 0.1 || 1;
        const max = rawMax + buffer;
        const min = rawMin - buffer;

        const chartHeight = height - verticalPadding * 2;
        const pointGap = width / (data.length - 1);

        const points = data.map((d, idx) => {
          const x = idx * pointGap;
          let normalizedY = ((d.value - min) / (max - min)) * chartHeight;
          if (isNaN(normalizedY)) normalizedY = chartHeight / 2;
          let y = height - verticalPadding - normalizedY;
          y = Math.min(height - verticalPadding, Math.max(verticalPadding, y)); // clamp
          return { x, y };
        });

        // Path
        let d = `M${points[0].x},${points[0].y}`;
        for (let i = 1; i < points.length; i++) {
          const prev = points[i - 1];
          const curr = points[i];
          const cx = (prev.x + curr.x) / 2;
          const cy = (prev.y + curr.y) / 2;
          d += ` Q${prev.x},${prev.y} ${cx},${cy}`;
        }
        d += ` L${points[points.length - 1].x},${height} L0,${height} Z`;

        // Labels + layout
        const labelX = points[Math.min(4, points.length - 1)].x;
        const labelY = points[Math.min(4, points.length - 1)].y;
        const arrowEndX = points[Math.max(points.length - 4, 0)].x;
        const arrowEndY = labelY;

        const profitText = apidata?.profit_loss
          ? `$${apidata?.profit_loss}`
          : "$0.00";

        const padding = 10;
        const fontSize = 10;
        const font = `${fontSize}px Poppins, Montserrat`;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.font = font;
        const textWidth = ctx.measureText(profitText).width;
        const boxWidth = textWidth + padding * 2;
        const boxX = labelX - boxWidth / 2;
        const textX = labelX;
        const totalProfit = (
          apidata.amount +
          (apidata.payout / 100) * apidata.amount
        ).toFixed(2);

        // ---------- SVG ----------
        const svgString = `
          <svg width="${width}" height="${height + 40}" viewBox="0 0 ${width} ${
            height + 40
          }" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="fade" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#999" stop-opacity="0.8" />
                <stop offset="100%" stop-color="#fff" stop-opacity="0" />
              </linearGradient>
            </defs>
  
            <rect x="0" y="0" width="${width}" height="${
              height + 40
            }" fill="#151419" />
            <rect x="0" y="0" width="${width}" height="${
              height + 40
            }" fill="none" stroke="black" stroke-width="2" rx="8" />
  
            ${
              apidata?.profit_loss > 0
                ? `
            <text
              x="${width / 2}"
              y="20"
              text-anchor="middle"
              font-family="Poppins, Montserrat, sans-serif"
              font-size="14"
              dominant-baseline="middle"
            >
              <tspan fill="#fcfcfc">Profit :</tspan>
              <tspan fill="#40cb53"> $${totalProfit}</tspan>
            </text>`
                : ""
            }
  
            <g transform="translate(0, 40)">
              <path d="${d}" fill="url(#fade)" stroke="#ffffff" stroke-width="1" />
  
              <rect
                x="${boxX}"
                y="${labelY - 25}"
                width="${boxWidth}"
                height="20"
                fill="${apidata?.type === "buy" ? "#40cb53" : "#f44c41"}"
                rx="4"
              />
  
              <text
                font-family="Poppins, Montserrat, sans-serif"
                x="${textX}"
                y="${labelY - 15}"
                fill="#fcfcfc"
                font-size="10"
                text-anchor="middle"
                dominant-baseline="middle"
              >
               ${profitText}
              </text>
  
              <line
                x1="${labelX}"
                y1="${labelY}"
                x2="${arrowEndX}"
                y2="${arrowEndY}"
                stroke="${apidata?.type === "buy" ? "#40cb53" : "#f44c41"}"
                stroke-width="2"
              />
  
              <circle
                cx="${labelX}"
                cy="${labelY}"
                r="3"
                fill="${apidata?.type === "buy" ? "#40cb53" : "#f44c41"}"
              />
  
              <line
                x1="${arrowEndX}"
                y1="${arrowEndY}"
                x2="${arrowEndX}"
                y2="${points[Math.max(points.length - 4, 0)].y}"
                stroke="#ddcaca"
                stroke-width="1"
              />
            </g>
          </svg>
        `;

        const base64 = btoa(unescape(encodeURIComponent(svgString)));
        const dataUrl = `data:image/svg+xml;base64,${base64}`;

        // ---------- Update refs ----------
        if (buyMarkersref.current?.length) {
          const index = buyMarkersref.current.findIndex(
            (item) => item.id === apidata?.id,
          );

          if (index !== -1) {
            if (buyMarkersref.current[index]?.id?.length) {
              buyMarkersref.current[index].id.forEach(() => {
                if (!buyMarkersref.current[index].imageurl) {
                  buyMarkersref.current[index].imageurl = [];
                }
                buyMarkersref.current[index].imageurl.push(dataUrl);
              });
            } else {
              buyMarkersref.current[index].imageurl = dataUrl;
            }
          }
        }

        setImageurl(dataUrl);
        setGraphdata({
          labelX,
          labelY,
          arrowEndX,
          arrowEndY,
          d,
          points,
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const opentradedata = async (checkfrist) => {
    try {
      buyMarkersref.current = [];
      clearTimeout(timeoutRef.current);
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/gettrade?status=open&account_type=${
          checkliveaccount ? "demo" : "real"
        }&pending_trades=0`,
        "GET",
      );
      if (res?.data?.success) {
        let openarry = [...res?.data?.trade];
        console.log("handleBuy 7");
   const hasCopyTrade =
          showcopytrades && openarry?.some((item) => item?.copy_id);

        if (hasCopyTrade) {
          console.log(showcopytrades, "showcopytrades");
          return;
        }

        if (openarry?.length) {
          // const latestData = seriesRef.current.data();

          // const lastCandle = latestData[latestData.length - 1];

          openarry.forEach(async (result) => {
            const [hours, minutes, seconds] = result?.duration
              .split(":")
              .map(Number);
            const foundItem = opentrade.find((item) => item.id === result?.id);
            // result.profit_loss =
            //   (parseFloat(result?.amount) * 92).toFixed(2) / 100;
            result.timeleft =
              foundItem?.id === result?.id
                ? foundItem?.timeleft
                : result?.duration;
            result.progress = 0;
            result.initialTime = hours * 3600 + minutes * 60 + seconds;
          });
        } else {
          setOpentrade([]);
        }

        if (checkfrist && openarry?.length) {
          setTimeout(() => {
            setWallupdate(true);
          }, 1000);
          setWallupdate(true);
          let array1 = openarry;
          let array2 = buyMarkersref.current;
          if (array2.length === 0) {
            console.log("handleBuy 6");
            handleBuy("", "", "", "", "", openarry);
          } else {
            const isMatch = array1.some((item1) =>
              array2.some((item2) => item1.id === item2.id),
            );

            if (!isMatch || array1.length > array2.length) {
              handleBuy("", "", "", "", "", openarry);
              console.log("handleBuy 89");
            }
          }
        } else {
          return openarry;
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  function roundToMinute(timestamp) {
    const date = new Date(timestamp);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date.getTime();
  }
  const handleBuy = async (
    amount,
    time,
    peramount,
    tradetype,
    pending,
    checkopen = [],
    tradeclosetime,
  ) => {
    if (!updatetimezone) return;
    if (!checkopen) {
      if (amount < 1) {
        return;
      }
    }

    // let currentAsset = `${chnagetyperef.current?.sortname}/${chnagetyperef.current?.csymbol}`;
    // if (checkopen?.length) {
    //   const isAssetMatched = checkopen.some(
    //     (item) => item.asset === currentAsset
    //   );

    //   if (!isAssetMatched) {
    //     return;
    //   }
    // }

    const intervalMs = parseTimeString(time);

    // const latestData = seriesRef.current.data();
    // const lastCandle = latestData[latestData.length - 1];

    let uniqueid = generateUniqueId();
    let secondsLeft = await startTimer(time, uniqueid);
    let idarrr = [...uniqueidkey];
    idarrr.push(uniqueid);
    setUniqueidkey(idarrr);
    clearInterval(buyTimeoutIdRef.current);

    if (!pending && !checkopen?.length) {
      let lastCandle = valueSeriesref.current.data.getIndex(
        valueSeriesref.current.data.length - 1,
      );

      let buydata = await buysellhandle(
        peramount,
        uniqueid,
        time,
        lastCandle,
        amount,
        tradetype,
        "open",
        tradeclosetime,
      );
    }

    let openarry = [];
    if (checkopen?.length) {
      openarry = checkopen;
    } else {
      // openarry = await opentradedata();
    }

    if (checkopen?.length) {
      const updatedMarkers = [...buyMarkersref.current];
      if (openarry?.length) {
        openarry.forEach((item, index) => {
          const { startTime, closeTime, duration } = getStartAndCloseTime(
            item?.trade_timestamp,
            item?.duration,
          );
          if (updatedMarkers[index]) {
            updatedMarkers[index] = {
              id: item?.id,
              status: "open",
              amount: item?.amount,
              peramount,
              tradetype: item?.type,
              secondsLeft,
              rendomid: uniqueid,
              time: pending
                ? roundToMinute(item?.polygontime)
                : item?.polygontime,
              price: item?.entry_price,
              // position: item?.type === "buy" ? "belowBar" : "aboveBar",
              color: item?.type === "buy" ? "#00C853" : "#FF3B30",
              // shape: item?.type === "buy" ? "arrowUp" : "arrowDown",
              ticker: item?.ticker,
              duration: item?.duration,
              closeTime: closeTime,
            };
          } else {
            updatedMarkers[index] = {
              id: item?.id,
              status: "open",
              amount: item?.amount,
              peramount,
              tradetype: item?.type,
              secondsLeft,
              rendomid: uniqueid,
              time: pending
                ? roundToMinute(item?.polygontime)
                : item?.polygontime,
              price: item?.entry_price,
              // position: item?.type === "buy" ? "belowBar" : "aboveBar",
              color: item?.type === "buy" ? "#00C853" : "#FF3B30",
              // shape: item?.type === "buy" ? "arrowUp" : "arrowDown",
              ticker: item?.ticker,
              duration: item?.duration,
              closeTime: closeTime,
            };
          }
        });
      }

      const check = openarry.some(
        (trade) => trade.pair_from === chnagetyperef.current?.sortname,
      );
      if (check) {
        buyMarkersref.current = updatedMarkers;
        tradetimmer(openarry, updatedMarkers);
      }
    }

    setWallupdate(false);
  };
  // useEffect(() => {
  //   const updateTime = () => {
  //     const userOffset = updatetimezone?.time ? updatetimezone?.time : "+05:30";
  //     const [sign, hours, minutes] = userOffset
  //       .match(/([+-])(\d{2}):(\d{2})/)
  //       .slice(1);
  //     const offsetMinutes =
  //       (parseInt(hours, 10) * 60 + parseInt(minutes, 10)) *
  //       (sign === "+" ? 1 : -1);
  //     const date = new Date();
  //     const utcTime = date.getTime() + date.getTimezoneOffset() * 60000;
  //     const localTime = new Date(utcTime + offsetMinutes * 60000);
  //     const hoursFormatted = String(localTime.getHours()).padStart(2, "0");
  //     const minutesFormatted = String(localTime.getMinutes()).padStart(2, "0");
  //     const secondsFormatted = String(localTime.getSeconds()).padStart(2, "0");
  //     const finalTime = `${hoursFormatted}:${minutesFormatted}:${secondsFormatted} UTC${userOffset}`;
  //     setCurrentTime(finalTime);
  //   };
  //   const interval = setInterval(updateTime, 1000);
  //   return () => clearInterval(interval);
  // }, [updatetimezone]);

  const utcDateRef = useRef(null);

  // Convert UTC date to dynamic offset time
  function convertUTCToOffsetTime(utcDateObj, offsetStr) {
    const match = offsetStr.match(/^([+-])(\d{2}):(\d{2})$/);
    if (!match) return "Invalid offset format";

    const [, sign, hours, minutes] = match;
    const offsetMinutes =
      (parseInt(hours) * 60 + parseInt(minutes)) * (sign === "+" ? 1 : -1);

    const adjustedTimestamp = utcDateObj.getTime() + offsetMinutes * 60 * 1000;
    const adjustedDate = new Date(adjustedTimestamp);

    const pad = (n) => n.toString().padStart(2, "0");

    const hour = pad(adjustedDate.getUTCHours());
    const minute = pad(adjustedDate.getUTCMinutes());
    const second = pad(adjustedDate.getUTCSeconds());

    return `${hour}:${minute}:${second}`;
  }

  // Set initial time from server
  // useEffect(() => {
  //   if (serverTime?.adjustedTime && updatetimezone?.time) {
  //     utcDateRef.current = new Date(serverTime.adjustedTime);
  //     const formattedTime = convertUTCToOffsetTime(
  //       utcDateRef.current,
  //       updatetimezone.time
  //     );
  //     setCurrentTime(formattedTime);
  //   }
  // }, [serverTime, updatetimezone]);

  // // Running timer: tick every 1 sec
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (utcDateRef.current && updatetimezone?.time) {
  //       utcDateRef.current = new Date(utcDateRef.current.getTime() + 1000);
  //       const formattedTime = convertUTCToOffsetTime(
  //         utcDateRef.current,
  //         updatetimezone.time
  //       );
  //       setCurrentTime(formattedTime);
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [updatetimezone, serverTime]);

  function getThreeDigitNumber() {
    const number = Math.floor(Math.random() * 1000); // 0 to 999
    return number.toString().padStart(3, "0");
  }
  const getFutureTimestamp = (time, checktimmer) => {
    if (checktimmer) {
      let totalSeconds =
        parseInt(time.hours || 0) * 3600 +
        parseInt(time.minutes || 0) * 60 +
        parseInt(time.secound || 0);

      // Enforce minimum of 5 seconds
      if (totalSeconds < 5) {
        time = {
          hours: "00",
          minutes: "00",
          secound: "05",
        };
      }

      let obj = {
        ...time,
        checktimmer,
        currenttimestamp: currenttimeref?.current?.timestamp,
      };
      setSelecttime(obj);
    } else {
      setSelecttime(time);
    }
    const now = new Date();
    // Parse additional time from your `time` object
    const addedHours = parseInt(time?.hours || 0, 10);
    const addedMinutes = parseInt(time?.minutes || 0, 10);
    const addedSeconds = parseInt(time?.secound || 0, 10); // assuming typo of 'second'

    // Add the custom time to the current time
    const futureTime = new Date(now.getTime());
    futureTime.setHours(futureTime.getHours() + addedHours);
    futureTime.setMinutes(futureTime.getMinutes() + addedMinutes);
    futureTime.setSeconds(futureTime.getSeconds() + addedSeconds);

    // Get the timestamp in milliseconds
    return futureTime.getTime();
  };
  const parseToUnix = (dateStr) => {
    const [datePart, timePart] = dateStr.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    // Manual UTC timestamp calculation (no new Date)
    return Math.floor(
      Date.UTC(year, month - 1, day, hour, minute, second) / 1000,
    );
  };

  // Convert UNIX timestamp (seconds) -> "YYYY-MM-DD HH:mm:ss"
  const formatFromUnix = (unix) => {
    const pad = (n) => String(n).padStart(2, "0");

    let sec = unix;
    let ms = sec * 1000;

    // Use UTC parts from math
    let year = new Date(ms).getUTCFullYear();
    let month = pad(new Date(ms).getUTCMonth() + 1);
    let day = pad(new Date(ms).getUTCDate());
    let hour = pad(new Date(ms).getUTCHours());
    let minute = pad(new Date(ms).getUTCMinutes());
    let second = pad(new Date(ms).getUTCSeconds());

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  };

  // Ensure minimum 5 seconds
  const ensureMinCloseTime = (colsetradetime, timestamp) => {
    let closeTimeSec = parseToUnix(colsetradetime);
    let currentTimeSec = parseInt(timestamp);

    if (closeTimeSec - currentTimeSec < 5) {
      closeTimeSec = currentTimeSec + 6;
    }

    return {
      colsetradetime: formatFromUnix(closeTimeSec),
      timestamp: currentTimeSec,
    };
  };
  const buysellhandle = async (
    peramount,
    uniqueid,
    time,
    lastCandle,
    amount,
    type,
    status,
    colsetradetime,
  ) => {
    try {
      // if (chnagetyperef.current?.csymbol !== "OTC") return;
      if (!updatetimezone) return;
      // setCheckclosetrade(false);
      const now = new Date();
      if (!currenttimeref.current?.timestamp) return;
      const timestamp = currenttimeref.current?.timestamp; // milliseconds
      if (colsetradetime) {
        colsetradetime = await ensureMinCloseTime(colsetradetime, timestamp)
          ?.colsetradetime;
      }
      // break it down manually
      // convert to parts
      const year = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        timeZone: "UTC",
      }).format(timestamp * 1000);
      const month = new Intl.DateTimeFormat("en-GB", {
        month: "2-digit",
        timeZone: "UTC",
      }).format(timestamp * 1000);
      const day = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        timeZone: "UTC",
      }).format(timestamp * 1000);
      const hour = new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        hour12: false,
        timeZone: "UTC",
      }).format(timestamp * 1000);
      const minute = new Intl.DateTimeFormat("en-GB", {
        minute: "2-digit",
        timeZone: "UTC",
      }).format(timestamp * 1000);
      const second = new Intl.DateTimeFormat("en-GB", {
        second: "2-digit",
        timeZone: "UTC",
      }).format(timestamp * 1000);

      const formattedTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      let buypostdata = {
        account_type: !checkliveaccount ? "real" : "demo",
        asset: `${chnagetyperef.current?.sortname}/${chnagetyperef.current?.csymbol}`,
        amount: amount,
        start_price: tradestyle === "3" ? lastCandle?.value : lastCandle?.close,
        duration: `${time?.hours}:${time?.minutes}:${time?.secound}`,
        type: type,
        status: status,
        currentTime: formattedTime,
        // id: id ? id : "",
        // exit_price: exit_price ? exit_price : 0,
        profit_loss: peramount
          ? peramount
          : (amount * parseInt(chnagetyperef.current?.payout)) / 100,
        keyword: `${chnagetyperef.current?.keyword}/${chnagetyperef.current?.csymbol}`,
        reference_id: uniqueid,
        trade_type: chnagetyperef.current?.type,
        pair_from: chnagetyperef.current?.sortname,
        pair_to: chnagetyperef.current?.csymbol,
        pendingtrade: 0,
        polygontime: lastCandle?.time ? lastCandle?.time : "",
        payout: chnagetyperef.current?.payout,
        ticker: chnagetyperef.current?.ticker,
        closetime: getThreeDigitNumber(),
        opentime: getThreeDigitNumber(),
        close_time: colsetradetime ? colsetradetime : "",
        asset_name: chnagetyperef.current?.name,
      };
      if (!buypostdata?.start_price) return;
      if (!buypostdata?.currentTime) return;
      const formData = new FormData();
      for (let key in buypostdata) {
        if (buypostdata.hasOwnProperty(key)) {
          formData.append(key, buypostdata[key]);
        }
      }

      let buyres = await authcallApitest(formData, `api/trade`, "POST");
      if (buyres?.data?.success) {
        // addNotification(buyres?.data?.trade, "open");
      } else {
        setNotifications([]);
        showNotification(buyres?.data?.message ?? "please try again", "error");
        // showErrorToast(buyres?.data?.message ?? "please try again");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  let previousHAOpen = null;
  let previousHAClose = null;
  function convertToHeikenAshi(candle) {
    const haClose = (candle.open + candle.high + candle.low + candle.close) / 4;
    const haOpen =
      previousHAOpen === null
        ? candle.open
        : (previousHAOpen + previousHAClose) / 2;
    const haHigh = Math.max(candle.high, haOpen, haClose);
    const haLow = Math.min(candle.low, haOpen, haClose);
    previousHAOpen = haOpen;
    previousHAClose = haClose;

    return {
      time: candle.time,
      open: haOpen,
      high: haHigh,
      low: haLow,
      close: haClose,
    };
  }
  const splitDataIntoIntervals = (data, interval, unit = "minute") => {
    if (!Array.isArray(data) || data.length === 0) {
      return [];
    }
    const intervalInMilliseconds = getIntervalInMilliseconds(interval, unit);
    const startTime = data[0]?.t;
    const endTime = data[data.length - 1]?.t;
    const intervals = [];
    let currentStartTime =
      Math.floor(startTime / intervalInMilliseconds) * intervalInMilliseconds;
    let currentEndTime = currentStartTime + intervalInMilliseconds;
    let intervalData = [];
    let updatedData = [];

    data.forEach((item) => {
      while (item.t >= currentEndTime) {
        if (intervalData.length > 0) {
          intervals.push({
            start: currentStartTime,
            end: currentEndTime,
            data: aggregateData(intervalData, currentStartTime),
          });
        }
        currentStartTime = currentEndTime;
        currentEndTime += intervalInMilliseconds;
        intervalData = [];
      }
      intervalData.push(item);
    });
    if (intervalData.length > 0) {
      intervals.push({
        start: currentStartTime,
        end: currentEndTime,
        data: aggregateData(intervalData, currentStartTime),
      });
    }

    updatedData = intervals.map((result) => result?.data);
    if (updatedData.length > 0) {
      runningcandledataref.current.push(updatedData[updatedData?.length - 1]);
    }
    return updatedData.slice(1);
  };

  const getIntervalInMilliseconds = (interval, unit) => {
    switch (unit) {
      case "minute":
        return interval * 60 * 1000;
      case "second":
        return interval * 1000;
      case "hour":
        return interval * 60 * 60 * 1000;
      case "day":
        return interval * 24 * 60 * 60 * 1000;
      default:
        return interval * 60 * 1000;
    }
  };
  const aggregateData = (data, currentStartTime) => {
    const open = data[0]?.o;
    const close = data[data.length - 1]?.c;
    const high = Math.max(...data.map((item) => item.h));
    const low = Math.min(...data.map((item) => item.l));
    const volume = data.reduce((sum, item) => sum + (item.v || 0), 0);
    const time = currentStartTime;
    return { open, close, high, low, volume, time };
  };

  const candleFetchRanges_OnScrollToFirstData = {
    second: {
      5: 12 * 60 * 60 * 1000, // 12 hours
      10: 12 * 60 * 60 * 1000,
      15: 12 * 60 * 60 * 1000,
      30: 12 * 60 * 60 * 1000,
    },
    minute: {
      1: 2 * 24 * 60 * 60 * 1000, // 2 days
      2: 4 * 24 * 60 * 60 * 1000, // 4 days
      3: 6 * 24 * 60 * 60 * 1000,
      5: 10 * 24 * 60 * 60 * 1000,
      10: 20 * 24 * 60 * 60 * 1000,
      15: 30 * 24 * 60 * 60 * 1000,
      30: 60 * 24 * 60 * 60 * 1000,
    },
    hour: {
      1: 180 * 24 * 60 * 60 * 1000,
      4: 365 * 24 * 60 * 60 * 1000,
    },
    day: {
      1: 3 * 365 * 24 * 60 * 60 * 1000,
    },
  };

  const getLookbackDuration_onScrollToFirstData = (type, value) => {
    const v = parseInt(value);
    if (
      candleFetchRanges_OnScrollToFirstData[type] &&
      candleFetchRanges_OnScrollToFirstData[type][v]
    ) {
      return candleFetchRanges_OnScrollToFirstData[type][v];
    }
    // default fallback
    // return 2 * 24 * 60 * 60 * 1000; // 2 days
    return 1 * 60 * 60 * 1000; // 4 hrs
  };

  const getDaysBeforeTimestampInMilliseconds = (timestamp, type, value) => {
    const lookbackDuration = getLookbackDuration_onScrollToFirstData(
      type,
      value,
    );
    return timestamp - lookbackDuration;
  };
  const onScrollToFirstData = async (firstDataTime) => {
    if (isFetchingHistory) return;
    try {
      let postdata = {};
      setIsFetchingHistory(true);
      const currentStart = dateAxisref.current.get("start");
      const currentEnd = dateAxisref.current.get("end");
      const currentTimestamp = Math.floor(firstDataTime / 1000) - 1;
      // const fourHoursBefore = currentTimestamp - 2 * 60 * 60;
      const secondDurations = ["S1", "S5", "S10", "S15", "S30"];
      const utcMidnight = currentTimestamp - (currentTimestamp % 86400);
      let fourHoursBefore;
      if (secondDurations.includes(candletimer?.duration)) {
        fourHoursBefore = currentTimestamp - 2 * 60 * 60;
      } else if (["H4", "D1"].includes(candletimer?.duration)) {
        fourHoursBefore = utcMidnight - 100 * 24 * 60 * 60;
      } else {
        fourHoursBefore = utcMidnight;
      }
      let timeduration =
        tradestyleref.current === "3" ? "S1" : candletimer?.duration;
      let res = await callApilivepair(
        postdata,
        `api/alltick/history?symbol=${chnagetyperef.current?.keyword.toLowerCase()}&type=${chnagetyperef.current?.type}&interval=${timeduration}&start_time=${fourHoursBefore}&end_time=${currentTimestamp}`,
        "GET",
      );
      if (res?.data?.success) {
        const formattedResults = res?.data?.data?.data?.map((point) => ({
          time: point?.start_time,
          open: point?.open,
          high: point?.high,
          low: point?.low,
          close: point?.close,
        }));

        const currentData = [...valueSeriesref.current.data.values];
        const newData = [...formattedResults, ...currentData];
        const uniqueData = newData.reduce((acc, current) => {
          if (!acc.some((item) => item.time === current.time)) {
            acc.push(current);
          }
          return acc;
        }, []);
        uniqueData.sort((a, b) => a.time - b.time);
        valueSeriesref.current.data.setAll(uniqueData);
        const oldTotalLength = currentData.length;
        const newTotalLength = uniqueData.length;
        const visibleCandles = Math.floor(
          (currentEnd - currentStart) * oldTotalLength,
        );
        const newStartIndex = formattedResults.length;
        const newEndIndex = newStartIndex + visibleCandles;
        const newStart = newStartIndex / newTotalLength;
        const newEnd = newEndIndex / newTotalLength;
        dateAxisref.current.setAll({
          start: newStart,
          end: newEnd,
        });
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setIsFetchingHistory(false);
    }
  };
  // const onScrollToFirstData = async (firstDataTime) => {
  //   console.log("formattedDate", firstDataTime)
  //   if (isFetchingHistory) return;
  //   try {
  //     setIsFetchingHistory(true);

  //     // 1. Get current visible candle range (as fractions)
  //     const currentStart = dateAxisref.current.get("start"); // 0-1
  //     const currentEnd = dateAxisref.current.get("end"); // 0-1

  //     // 2. Cache current data and visible candle count
  //     const currentData = [...valueSeriesref.current.data.values];
  //     const oldLength = currentData.length;
  //     const visibleCandleCount = Math.round(
  //       (currentEnd - currentStart) * oldLength,
  //     );
  //     const lastVisibleIndex = Math.round(currentEnd * oldLength);

  //     // 3. Fetch previous candles
  //     const formattedDate = await getDaysBeforeTimestampInMilliseconds(
  //       firstDataTime,
  //       candletimer?.type,
  //     );

  //     const initialUrl = `https://api.massive.com/v2/aggs/ticker/${chnagetyperef.current?.ticker}/range/${candletimer?.value}/${candletimer?.type}/${formattedDate}/${firstDataTime}?adjusted=true&sort=asc&apiKey=${API_KEY}`;

  //     const response = await fetch(initialUrl);
  //     const data = await response.json();

  //     if (!data?.results?.length) return;

  //     const formattedResults = data.results.map((point) => ({
  //       time: point.t,
  //       open: point.o,
  //       high: point.h,
  //       low: point.l,
  //       close: point.c,
  //     }));

  //     // 4. Merge new + old
  //     const merged = [...formattedResults, ...currentData];
  //     const uniqueData = merged.reduce((acc, cur) => {
  //       if (!acc.some((item) => item.time === cur.time)) acc.push(cur);
  //       return acc;
  //     }, []);

  //     uniqueData.sort((a, b) => a.time - b.time);
  //     valueSeriesref.current.data.setAll(uniqueData);

  //     // 5. Recalculate new indices after adding candles
  //     const newLength = uniqueData.length;
  //     const newEndIndex = lastVisibleIndex + formattedResults.length;
  //     const newStartIndex = newEndIndex - visibleCandleCount;

  //     const safeStartIndex = Math.max(0, newStartIndex);
  //     const safeEndIndex = Math.min(newLength, newEndIndex);

  //     // 6. Set fractional zoom range again (preserves zoom level)
  //     const newStart = safeStartIndex / newLength;
  //     const newEnd = safeEndIndex / newLength;

  //     am5.time.sleep(0).then(() => {
  //       dateAxisref.current.setAll({
  //         start: newStart,
  //         end: newEnd,
  //       });
  //     });
  //   } catch (error) {
  //     console.error("Error loading history:", error);
  //   } finally {
  //     setIsFetchingHistory(false);
  //   }
  // };

  const otcbackdata = async (firstDataTime) => {
    if (isFetchingOtcHistory) return;
    try {
      let postdata = {};
      setIsFetchingOtcHistory(true);

      // 1. Store current visible range BEFORE loading new data
      const currentStart = dateAxisref.current.get("start"); // fractional 0-1
      const currentEnd = dateAxisref.current.get("end"); // fractional 0-1
      const currentTimestamp = Math.floor(firstDataTime / 1000);
      const fourHoursBefore = currentTimestamp - 2 * 60 * 60;
      let res = await callApi(
        postdata,
        `api/get-ohlc-data/${chnagetyperef.current?.ticker}/${candletimer?.value}/${candletimer?.type}/${fourHoursBefore}/${currentTimestamp}?adjusted=true&sort=asc`,
        "GET",
      );
      if (res?.data?.success) {
        const formattedResults = res?.data?.data?.map((point) => ({
          time: point.t * 1000,
          open: point.o,
          high: point.h,
          low: point.l,
          close: point.c,
        }));
        // 3. Merge new data with existing
        const currentData = [...valueSeriesref.current.data.values];
        const newData = [...formattedResults, ...currentData];

        // Remove duplicates by 'time'
        const uniqueData = newData.reduce((acc, current) => {
          if (!acc.some((item) => item.time === current.time)) {
            acc.push(current);
          }
          return acc;
        }, []);

        // // Sort ascending by time
        // uniqueData.sort((a, b) => a.time - b.time);

        // Set new combined data
        // for (let i = formattedResults.length - 1; i >= 0; i--) {
        //   valueSeriesref.current.data.insertIndex(0, formattedResults[i]);
        // }
        // Sort ascending by time
        uniqueData.sort((a, b) => a.time - b.time);
        valueSeriesref.current.data.setAll(uniqueData);

        // 4. Restore visible range relative to new data

        // OLD data length (before prepending)
        const oldTotalLength = currentData.length;

        // NEW data length (after prepending)
        const newTotalLength = uniqueData.length;

        // ✅ Preserve visible candle count
        const visibleCandles = Math.floor(
          (currentEnd - currentStart) * oldTotalLength,
        );

        // ✅ Maintain same visible range, shifted after prepending
        const newStartIndex = formattedResults.length;
        const newEndIndex = newStartIndex + visibleCandles;

        // ✅ Convert to fractional range
        const newStart = newStartIndex / newTotalLength;
        const newEnd = newEndIndex / newTotalLength;

        // ✅ Apply to dateAxis
        dateAxisref.current.setAll({
          start: newStart,
          end: newEnd,
        });
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setIsFetchingOtcHistory(false);
    }
  };

  const handleVisibleTimeRangeChange = (chartRef, seriesRef) => {
    if (!chartRef) return;

    if (chnagetyperef.current?.csymbol === "OTC") {
      chartRef.timeScale().subscribeVisibleTimeRangeChange((visibleRange) => {
        if (!visibleRange) return;
        const firstData = seriesRef.data();
        const firstDataTime = firstData[0]?.time;
        if (
          previousFromRef.current !== null &&
          previousFromRef.current !== visibleRange.from
        ) {
          if (visibleRange.from <= firstDataTime && !apiCallMade.current) {
            // wsresf.current = false;
            // if (!wsresf.current) {
            otcbackdata(firstDataTime, seriesRef, visibleRange);

            // }
          }
        }

        previousFromRef.current = visibleRange.from;
      });
    } else {
      chartRef.timeScale().subscribeVisibleTimeRangeChange((visibleRange) => {
        if (!visibleRange) return;
        const firstData = seriesRef.data();
        const firstDataTime = firstData[0]?.time;

        const isAtRightEdge =
          chartRef.timeScale().getVisibleLogicalRange()?.to >=
          firstData.length - 1;
        const visibleCandles = firstData.filter(
          (candle) =>
            candle.time >= visibleRange.from && candle.time <= visibleRange.to,
        );
        if (
          previousFromRef.current !== null &&
          previousFromRef.current !== visibleRange.from
        ) {
          if (visibleRange.from <= firstDataTime && !apiCallMade.current) {
            wsresf.current = false;
            if (!wsresf.current) {
              if (chnagetyperef.current?.csymbol === "OTC") {
                otcbackdata(firstDataTime, seriesRef, visibleRange);
              } else {
                onScrollToFirstData(firstDataTime, seriesRef, visibleRange);
              }
            }
          }
        }

        previousFromRef.current = visibleRange.from;
      });
    }
  };

  // useEffect(() => {
  //   if (chartRef.current && seriesRef.current) {
  //     handleVisibleTimeRangeChange(chartRef.current, seriesRef.current);
  //        console.log("in function")
  //   }
  // }, [candletimer, chartRef, seriesRef, chnagetyperef.current]);
  const getCurrentDate = () => {
    const currentDate = new Date();
    return formatDate(currentDate);
  };

  const getTwoDaysBeforeDate = (unit) => {
    let beforedate = 0;
    // switch (unit) {
    //   case "minute":
    //     beforedate = 2; // Minutes to milliseconds
    //   case "second":
    //      beforedate  = 0; // Seconds to milliseconds
    //   case "hour":
    //      beforedate = 5; // Hours to milliseconds
    //   case "day":
    //      beforedate = 30 ; // Days to milliseconds
    //   default:
    //      beforedate  = 2; // Default to minutes
    // }
    if (tradestyleref.current === "3") {
      beforedate = 0;
    } else {
      if (unit === "minute") {
        beforedate = 2;
      } else if (unit === "second") {
        beforedate = 0;
      } else if (unit === "hour") {
        beforedate = 30;
      } else if (unit === "day") {
        beforedate = 365;
      } else {
        beforedate = 2;
      }
    }

    const date = new Date();
    date.setDate(date.getDate() - beforedate);
    return formatDate(date);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const candleFetchRanges = {
    second: {
      5: (4 * 60 * 60 * 1000) / 12, // M1 = 4hr → S5 = 20min
      10: (4 * 60 * 60 * 1000) / 6, // S10 = 40min
      15: (4 * 60 * 60 * 1000) / 4, // S15 = 1hr
      30: (4 * 60 * 60 * 1000) / 2, // S30 = 2hr
    },
    minute: {
      1: 4 * 60 * 60 * 1000, // 4hr
      2: 8 * 60 * 60 * 1000, // 8hr
      3: 12 * 60 * 60 * 1000, // 12hr
      5: 24 * 60 * 60 * 1000, // 1d
      10: 2 * 24 * 60 * 60 * 1000, // 2d
      15: 3 * 24 * 60 * 60 * 1000, // 3d
      30: 5 * 24 * 60 * 60 * 1000, // 5d
    },
    hour: {
      1: 30 * 24 * 60 * 60 * 1000, // 30d
      4: 90 * 24 * 60 * 60 * 1000, // 90d
    },
    day: {
      1: 365 * 24 * 60 * 60 * 1000, // 1y
    },
  };

  const getLookbackDuration = (type, value) => {
    const v = parseInt(value);
    if (candleFetchRanges[type] && candleFetchRanges[type][v]) {
      return candleFetchRanges[type][v];
    }
    // default fallback
    // return 2 * 24 * 60 * 60 * 1000; // 2 days
    return 8 * 60 * 60 * 1000; // 4 hrs
  };
  const fetchKlineData = async () => {
    try {
      if (otcwebsoket.current) {
        otcwebsoket.current = false;
      }

      websoketarrref.current = [];

      runningcandledataref.current = [];
      let postdata = {};
      const lookbackDuration = getLookbackDuration_fatchotcdata(
        candletimer?.type,
        candletimer?.value,
      );

      const currentTimestamp = Math.floor(serverTime?.server_time / 1000);
      const secondDurations = ["S1", "S5", "S10", "S15", "S30"];
      let fromTimestamp;
      const utcMidnight = currentTimestamp - (currentTimestamp % 86400);

      if (secondDurations.includes(candletimer?.duration)) {
        fromTimestamp = currentTimestamp - Math.floor(lookbackDuration / 1000);
      } else if (["H4", "D1"].includes(candletimer?.duration)) {
        fromTimestamp = utcMidnight - 100 * 24 * 60 * 60;
      } else {
        fromTimestamp = utcMidnight;
      }
      let timeduration =
        tradestyleref.current === "3" ? "S1" : candletimer?.duration;
      let res = await callApilivepair(
        postdata,
        `api/alltick/history?symbol=${chnagetyperef.current?.keyword.toLowerCase()}&type=${chnagetyperef.current?.type}&interval=${timeduration}&start_time=${fromTimestamp}&end_time=${currentTimestamp}`,
        "GET",
      );
      if (res?.data?.success) {
        if (soketref.current) {
          soketref.current.close();
        }
        let minutedata = res?.data?.data?.data;
        const visibleRange = {
          from: minutedata.length - 15,
          to: minutedata.length - 1,
        };
        setcandlerange.current = [visibleRange];
        let data = minutedata.map((item) => ({
          open: Number(item?.open),
          close: Number(item?.close),
          high: Number(item?.high),
          low: Number(item?.low),
          time: item?.start_time,
        }));
        if (!data?.length) return;
        let patchedData = [];
        if (tradestyleref.current === "5") {
          const heikenAshiData = await data.map((candle) => {
            return convertToHeikenAshi({
              time: candle.time,
              open: candle.open,
              high: candle.high,
              low: candle.low,
              close: candle.close,
            });
          });
        } else if (tradestyleref.current === "3") {
          let linedata = convertToLineChartData(data);
        } else {
          // patchedData = fillMissingCandles(data, 60);
          valueSeriesref.current.data.setAll(data);
        }

        if (data.length > 0) {
          runningcandledataref.current.push(data[data?.length - 1]);
        }
        valueSeriesref.current.events.once("datavalidated", function () {
          const data = valueSeriesref.current.data;
          const total = data.length;

          if (!total) return;

          const displayCount = 20;
          const rightPaddingRatio = 0.5;

          const lastItem = data.getIndex(total - 1);
          const startIndex = total - displayCount;
          const startItem = data.getIndex(startIndex > 0 ? startIndex : 0);

          if (startItem && lastItem) {
            const startTime = new Date(startItem.time);
            const lastTime = new Date(lastItem.time);

            const range = lastTime.getTime() - startTime.getTime();
            const paddedEndTime = new Date(
              lastTime.getTime() + range * rightPaddingRatio,
            );

            dateAxisref.current.zoomToDates(startTime, paddedEndTime);
          }
        });
        const lastIndex = valueSeriesref.current.data.length - 1;
        const lastDataPoint = valueSeriesref.current.data.getIndex(lastIndex);
        // setChartLoader(false);
        setupwebsoket(data, parseInt(candletimer?.value), candletimer?.type);
          if (data?.length < 50) {
          const firstDataTime = data?.[0]?.time;
          onScrollToFirstData(firstDataTime);
        }
        // backendwebsoket(
        //   patchedData,
        //   parseInt(candletimer?.value),
        //   candletimer?.type
        // );
        // websoketdata(candletimer);
        // Set a new interval after stopping the previous one
        // setTimeout(() => {
        //   if (!window.updateInterval) {
        //     // Prevent multiple intervals
        //     window.updateInterval = setInterval(() => {
        //       getlastotcdata(candletimer);
        //     }, 1000);
        //   }
        // }, 1000);

        // Return cleanup function (for React useEffect if needed)
        return () => {
          clearInterval(window.updateInterval);
          window.updateInterval = null;
        };
      }
    } catch (err) {
      console.log(err, "historydata err");
    }
  };

  let currentCandle = null;
  let lastMinute = null;

  // Convert second-level candles to minute-level candles
  function convertToMinuteCandles(data) {
    let minuteCandles = [];
    let currentMinute = null;
    let minuteGroup = [];

    data.forEach((candle) => {
      const minuteStart = Math.floor(candle.t / 60) * 60;

      if (minuteStart === currentMinute) {
        minuteGroup.push(candle);
      } else {
        if (minuteGroup.length > 0) {
          const open = minuteGroup[0].o;
          const close = minuteGroup[minuteGroup.length - 1].c;
          const high = Math.max(...minuteGroup.map((c) => parseFloat(c.h)));
          const low = Math.min(...minuteGroup.map((c) => parseFloat(c.l)));
          const timestamp = minuteGroup[0].t;

          minuteCandles.push({
            o: open,
            c: close,
            h: high,
            l: low,
            t: timestamp,
          });
        }

        currentMinute = minuteStart;
        minuteGroup = [candle];
      }
    });

    if (minuteGroup.length > 0) {
      const open = minuteGroup[0].o;
      const close = minuteGroup[minuteGroup.length - 1].c;
      const high = Math.max(...minuteGroup.map((c) => parseFloat(c.h)));
      const low = Math.min(...minuteGroup.map((c) => parseFloat(c.l)));
      const timestamp = minuteGroup[0].t;

      minuteCandles.push({
        o: open,
        c: close,
        h: high,
        l: low,
        t: timestamp,
      });
    }

    return minuteCandles;
  }
  function fillMissingCandles(data, intervalSeconds = 60) {
    const filled = [];
    for (let i = 0; i < data.length - 1; i++) {
      filled.push(data[i]);

      const current = data[i];
      const next = data[i + 1];
      let nextExpectedTime = current.time + intervalSeconds;

      while (nextExpectedTime < next.time) {
        filled.push({
          time: nextExpectedTime * 1000,
          open: current.close,
          high: current.close,
          low: current.close,
          close: current.close,
        });
        nextExpectedTime += intervalSeconds;
      }
    }
    filled.push(data[data.length - 1]); // Don't forget the last candle
    return filled;
  }
  const candleFetchRanges_fatchotcdata = {
    second: {
      5: (4 * 60 * 60 * 1000) / 12, // M1 = 4hr → S5 = 20min
      10: (4 * 60 * 60 * 1000) / 6, // S10 = 40min
      15: (4 * 60 * 60 * 1000) / 4, // S15 = 1hr
      30: (4 * 60 * 60 * 1000) / 2, // S30 = 2hr
    },
    minute: {
      1: 4 * 60 * 60 * 1000, // 4hr
      2: 8 * 60 * 60 * 1000, // 8hr
      3: 12 * 60 * 60 * 1000, // 12hr
      5: 24 * 60 * 60 * 1000, // 1d
      10: 2 * 24 * 60 * 60 * 1000, // 2d
      15: 3 * 24 * 60 * 60 * 1000, // 3d
      30: 3 * 24 * 60 * 60 * 1000, // 5d
    },
    hour: {
      1: 2 * 24 * 60 * 60 * 1000, // d
      4: 4 * 24 * 60 * 60 * 1000, // 90d
    },
    day: {
      1: 7 * 24 * 60 * 60 * 1000, // 1y
    },
  };

  const getLookbackDuration_fatchotcdata = (type, value) => {
    const v = parseInt(value);
    if (
      candleFetchRanges_fatchotcdata[type] &&
      candleFetchRanges_fatchotcdata[type][v]
    ) {
      return candleFetchRanges_fatchotcdata[type][v];
    }
    // return 2 * 24 * 60 * 60 * 1000; // fallback
    return 4 * 60 * 60;
  };
  function adjustTimestampForTimezone(utcTimestamp, timezoneData) {
    const { haur, minute, plus } = timezoneData;

    // Calculate offset in seconds
    const offsetSeconds = (parseInt(haur, 10) * 60 + parseInt(minute, 10)) * 60;

    let adjustedTimestamp;
    if (plus === "+") {
      adjustedTimestamp = utcTimestamp + offsetSeconds;
    } else {
      adjustedTimestamp = utcTimestamp - offsetSeconds;
    }

    return adjustedTimestamp; // return timestamp in seconds
  }
  const fatchotcdata = async () => {
    try {
      // setChartLoader(true);

      // Stop any running interval before starting a new one
      if (otcwebsoket.current) {
        otcwebsoket.current = false;
      }

      websoketarrref.current = [];

      runningcandledataref.current = [];
      let postdata = {};
      // const currentTimestamp = Math.floor(Date.now() / 1000);
      // const fourHoursBefore = currentTimestamp - 4 * 60 * 60;
      const lookbackDuration = getLookbackDuration_fatchotcdata(
        candletimer?.type,
        candletimer?.value,
      );

      const currentTimestamp = Math.floor(serverTime?.server_time / 1000);
      const fromTimestamp =
        currentTimestamp - Math.floor(lookbackDuration / 1000);

      // Then use fromTimestamp in your API

      let timeduration =
        tradestyleref.current === "3" ? "S1" : candletimer?.duration;
      let res = await callApi(
        postdata,
        `api/get-ohlc-data/${chnagetyperef.current?.ticker}/${candletimer?.value}/${candletimer?.type}/${fromTimestamp}/${currentTimestamp}?adjusted=true&sort=asc`,
        "GET",
      );
      if (res?.data?.success) {
        if (soketref.current) {
          soketref.current.close();
        }
        let minutedata = res?.data?.data;
        const visibleRange = {
          from: minutedata.length - 15,
          to: minutedata.length - 1,
        };
        setcandlerange.current = [visibleRange];
        // chartRef.current.timeScale().setVisibleLogicalRange(visibleRange);
        // chartRef.current.timeScale().scrollToPosition(5);

        let data = minutedata.map((item) => ({
          open: parseFloat(parseFloat(item?.o)),
          close: parseFloat(parseFloat(item?.c)),
          high: parseFloat(parseFloat(item?.h)),
          low: parseFloat(parseFloat(item?.l)),
          time: item?.t * 1000,
        }));
        if (!data?.length) return;
        let patchedData = [];
        if (tradestyleref.current === "5") {
          const heikenAshiData = await data.map((candle) => {
            return convertToHeikenAshi({
              time: candle.time,
              open: candle.open,
              high: candle.high,
              low: candle.low,
              close: candle.close,
            });
          });
          // seriesRef.current.setData(heikenAshiData);
        } else if (tradestyleref.current === "3") {
          let linedata = convertToLineChartData(data);
          // seriesRef.current.setData(linedata);
        } else {
          patchedData = fillMissingCandles(data, 60);
          // seriesRef.current.setData(patchedData);

          valueSeriesref.current.data.setAll(data);
        }

        if (data.length > 0) {
          runningcandledataref.current.push(data[data?.length - 1]);
        }
        valueSeriesref.current.events.once("datavalidated", function () {
          const data = valueSeriesref.current.data;
          const total = data.length;

          if (!total) return;

          const displayCount = 20;
          const rightPaddingRatio = 0.5;

          const lastItem = data.getIndex(total - 1);
          const startIndex = total - displayCount;
          const startItem = data.getIndex(startIndex > 0 ? startIndex : 0);

          if (startItem && lastItem) {
            const startTime = new Date(startItem.time);
            const lastTime = new Date(lastItem.time);

            const range = lastTime.getTime() - startTime.getTime();
            const paddedEndTime = new Date(
              lastTime.getTime() + range * rightPaddingRatio,
            );

            dateAxisref.current.zoomToDates(startTime, paddedEndTime);
          }
        });
        const lastIndex = valueSeriesref.current.data.length - 1;
        const lastDataPoint = valueSeriesref.current.data.getIndex(lastIndex);
        // setChartLoader(false);
        setupwebsoket(
          patchedData,
          parseInt(candletimer?.value),
          candletimer?.type,
        );
        // backendwebsoket(
        //   patchedData,
        //   parseInt(candletimer?.value),
        //   candletimer?.type
        // );
        // websoketdata(candletimer);
        // Set a new interval after stopping the previous one
        // setTimeout(() => {
        //   if (!window.updateInterval) {
        //     // Prevent multiple intervals
        //     window.updateInterval = setInterval(() => {
        //       getlastotcdata(candletimer);
        //     }, 1000);
        //   }
        // }, 1000);

        // Return cleanup function (for React useEffect if needed)
        return () => {
          clearInterval(window.updateInterval);
          window.updateInterval = null;
        };
      }
    } catch (err) {
      console.log(err, "historydata err");
    }
  };

  const convertToLineChartData = (candlestickData, convertobj) => {
    if (convertobj === "convertobj") {
      const convertedObj = {
        time: candlestickData?.time / 1000,
        value: candlestickData?.close,
      };
      return convertedObj;
    } else {
      return candlestickData.map((data) => ({
        time: data?.time,
        value: data?.close,
      }));
    }
  };
  const formatCandlestickData = (data) => {
    return {
      time: data.e / 1000,
      open: data.o,
      high: data.h,
      low: data.l,
      close: data.c,
    };
  };
  useEffect(() => {
    let unit = candletimer?.type;
    let value = parseInt(candletimer?.value);
    switch (unit) {
      case "second":
      case "seconds":
        return setTimer(value * 1000);
      case "minute":
      case "minutes":
        return setTimer(value * 60000);
      case "hour":
      case "hours":
        return setTimer(value * 3600000);
      case "day":
      case "days":
        return setTimer(value * 86400000);
      default:
        return setTimer(0);
    }
  }, [candletimer]);
  function convertForexToXT(quote) {
    return {
      ev: "CT",
      pair: quote?.p,
      p: (quote?.a + quote?.b) / 2, // synth price
      t: quote?.t,
      s: 1, // mock size (not real in Forex)
      c: [],
      i: quote?.i || null,
      x: quote?.x,
      r: quote?.t,
    };
  }
  function convertToISTTimestamp(dateStr) {
    const utcDate = new Date(dateStr + "Z"); // Treat input as UTC
    console.log(utcDate, "utcDate", dateStr);
    const istDate = new Date(
      utcDate.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
    );

    return {
      istDate, // Date object in IST
      timestampMillis: istDate.getTime(), // Timestamp in milliseconds
      timestampSeconds: Math.floor(istDate.getTime() / 1000), // Timestamp in seconds
    };
  }
  const getwebsoketauth = async (id) => {
    try {
      const channel = `private-user.${id}`;
      let postdata = { channel_name: channel, socket_id: "9999.9999999" };
      let res = await authcallApi(postdata, `api/broadcasting/auth`, "POST");
      tradewebsoket(channel, res?.data?.auth);
    } catch (err) {
      console.log(err, "err");
    }
  };
  function adjustUTC(baseTime, offset) {
    const [h, m, s] = baseTime.split(":").map(Number);
    const utcDate = new Date(Date.UTC(1970, 0, 1, h, m, s || 0));
    const sign = offset.startsWith("-") ? -1 : 1;
    const [offH, offM] = offset.substring(1).split(":").map(Number);
    utcDate.setUTCHours(utcDate.getUTCHours() + sign * offH);
    utcDate.setUTCMinutes(utcDate.getUTCMinutes() + sign * offM);
    const result = utcDate.toISOString().substr(11, 8);
    return result;
  }

  function adjustUTCWithDate(baseDateTime, offset) {
    const [datePart, timePart] = baseDateTime.split(" ");
    const [day, month, year] = datePart.split("-").map(Number);
    const [h, m, s] = timePart.split(":").map(Number);
    const utcDate = new Date(Date.UTC(year, month - 1, day, h, m, s || 0));
    const sign = offset.startsWith("-") ? -1 : 1;
    const [offH, offM] = offset.substring(1).split(":").map(Number);
    utcDate.setUTCHours(utcDate.getUTCHours() + sign * offH);
    utcDate.setUTCMinutes(utcDate.getUTCMinutes() + sign * offM);
    return Math.floor(utcDate.getTime() / 1000);
  }
  let wsInstanceref = useRef(null);
  let pingIntervalsync = useRef(null);
  const timewebsoket = (timezometime) => {
    if (wsInstanceref.current) {
      wsInstanceref.current.close();
      clearInterval(pingIntervalsync.current);
      wsInstanceref.current = null;
    }
    const WebSocketurl = process.env.REACT_APP_WSS_URL;
    wsInstanceref.current = new WebSocket(WebSocketurl);
    if (wsInstanceref.current) {
      wsInstanceref.current.onopen = () => {
        wsInstanceref.current.send(
          JSON.stringify({
            event: "pusher:subscribe",
            data: {
              channel: `sync`,
            },
          }),
        );

        pingIntervalsync.current = setInterval(() => {
          wsInstanceref.current.pingInterval = wsInstanceref.current.send(
            JSON.stringify({ event: "pusher:ping", data: {} }),
          );
        }, 1000);
      };
    }

    wsInstanceref.current.onmessage = async (event) => {
      const data = JSON.parse(event.data);
      if (!data?.channel || !timezometime) return;

      const convertdata = JSON.parse(data?.data);
      const time = convertdata?.data;
      if (time) {
        let upadtedtime = adjustUTC(time?.time, timezometime);
        let lasttime = `${upadtedtime} UTC${timezometime}`;
        setCurrentTime(lasttime);
        currenttimeref.current = time;
        // if (time?.assets === 1) {
        //   assetapi();
        // }
      }
    };
    wsInstanceref.current.onerror = (error) => {
      console.log("WebSocket Error:", error);
    };

    wsInstanceref.current.onclose = () => {
      if (wsInstanceref.current?.pingInterval)
        clearInterval(wsInstanceref.current.pingInterval);
    };

    return () => {
      if (wsInstanceref.current) {
        wsInstanceref.current.close();
        wsInstanceref.current = null;
      }
    };
  };
  useEffect(() => {
    if (updatetimezone?.time && serverTime) {
      timewebsoket(updatetimezone?.time);
    }
  }, [updatetimezone, serverTime]);
  let currentopenWsRef = useRef(null);
  let pingIntervalopen = useRef(null);
  const getopenids = async (id) => {
    try {
      let ids = [];
      if (id?.length) {
        id.forEach((item) => {
          ids.push(item.id);
        });
      }

      let postdata = { ids };
      let res = await authcallApi(postdata, `api/gettradesbyid`, "POST");
      if (res?.data?.success) {
        let trades = res?.data?.data;
        console.log(trades, "idsids");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const tradewebsoket = (channel) => {
    if (
      currentopenWsRef.current &&
      currentopenWsRef.current.readyState === WebSocket.OPEN
    ) {
      currentopenWsRef.current.close();
      if (pingIntervalopen.current) {
        clearInterval(pingIntervalopen.current);
      }
    }
    const WebSocketurl = process.env.REACT_APP_WSS_URL;
    const ws = new WebSocket(WebSocketurl);
    currentopenWsRef.current = ws;
    ws.onopen = () => {
      ws.send(
        JSON.stringify({
          event: "pusher:subscribe",
          data: {
            channel: `open.${channel}`,
          },
        }),
      );

      pingIntervalopen.current = setInterval(() => {
        ws.send(JSON.stringify({ event: "pusher:ping", data: {} }));
      }, 1000);
    };
    ws.onmessage = async (event) => {
      const data = JSON.parse(event.data);

      if (!data?.channel) return;
      setWallupdate(false);
      const convertdata = JSON.parse(data?.data);
      let trades = convertdata?.data;

      if (convertdata?.data === undefined) return;
      getopenids(convertdata?.data);

      // Ensure trades is always an array
      if (!Array.isArray(trades)) {
        trades = [trades];
      }
           console.log(showcopytrades, "showcopytrades");
      trades.forEach((trade) => {
          if (trade?.copy_id) {
          if (showcopytrades) {
            setWallupdate(true);
            return;
          }
        }
        if (
          trade?.id &&
          trade?.status === "pending" &&
          trade?.websocketopendingrun === "false"
        ) {
          setPendingtrade(trade?.id);
        }

        if (!trade?.id || trade?.status !== "open") return;
        addNotification(trade, "open");
        console.log(soundbalanceref.current, "soundbalanceref out");
        if (soundEnabled && soundbalanceref.current) {
          console.log(soundbalanceref.current, "soundbalanceref");
          const click = new Audio(coin_drop);
          click.currentTime = 0;
          click.play();
        }
        let updatedOpenTrades = [...opentrade];

        const isAlreadyInBuyMarkers = buyMarkersref.current.some(
          (item) => item.id === trade.id,
        );

        const isAlreadyInOpenTrades = updatedOpenTrades.some(
          (item) => item.id === trade.id,
        );

        if (!isAlreadyInBuyMarkers && !isAlreadyInOpenTrades) {
          const [hours, minutes, seconds] = trade?.duration
            .split(":")
            .map(Number);
          const initialTime = hours * 3600 + minutes * 60 + seconds;

          const enrichedTrade = {
            ...trade,
            timeleft: trade.duration,
            progress: 0,
            initialTime,
          };
          setWallupdate(true);
          updatedOpenTrades.push(enrichedTrade);

          const { startTime, closeTime } = getStartAndCloseTime(
            trade?.trade_timestamp,
            trade?.duration,
          );

          const updatedMarkers = [
            ...buyMarkersref.current.filter((item) => item.id !== trade.id),
            {
              ...enrichedTrade,
              id: trade.id,
              status: "open",
              amount: trade.amount,
              tradetype: trade.type,
              time: trade.polygontime,
              price: trade.entry_price,
              color: trade.type === "buy" ? "#00C853" : "#FF3B30",
              ticker: trade.ticker,
              duration: trade.duration,
              close_time: closeTime,
              start_time: startTime,
              text: `$${formatPrice(trade.amount, 2)}[/]\n${trade?.duration}`,
            },
          ];

          buyMarkersref.current = updatedMarkers;
          setOpentrade((prevOpentrade) => {
            const filtered = prevOpentrade.filter((t) => t.id !== trade.id);
            const updated = [enrichedTrade, ...filtered].map((item) => {
              const [h, m, s] = item.duration.split(":").map(Number);
              const initial = h * 3600 + m * 60 + s;
              return {
                ...item,
                timeleft: item.duration,
                progress: 0,
                initialTime: initial,
              };
            });
            tradetimmer(updated, buyMarkersref.current);
            return updated;
          });
        }
      });
    };

    ws.onerror = (error) => {
      console.log("WebSocket Error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket Closed");
    };

    return () => ws.close();
  };

  let currentWsRef = useRef(null);
  let pingIntervalclose = useRef(null);
  const tradewebsoketclose = (channel) => {
    if (
      currentWsRef.current &&
      currentWsRef.current.readyState === WebSocket.OPEN
    ) {
      currentWsRef.current.close();
      if (pingIntervalclose.current) {
        clearInterval(pingIntervalclose.current);
      }
    }
    const WebSocketurl = process.env.REACT_APP_WSS_URL;
    const ws = new WebSocket(WebSocketurl);
    currentWsRef.current = ws;
    ws.onopen = () => {
      ws.send(
        JSON.stringify({
          event: "pusher:subscribe",
          data: {
            channel: `close.${channel}`,
          },
        }),
      );

      pingIntervalclose.current = setInterval(() => {
        ws.send(JSON.stringify({ event: "pusher:ping", data: {} }));
      }, 1000);
    };
    ws.onmessage = async (event) => {
      setWallupdate(false);
      const data = JSON.parse(event.data);

      if (!data?.channel) return;
      const convertdata = JSON.parse(data?.data);
      if (convertdata?.data?.length) {
        let markersNow = Array.isArray(buyMarkersref.current)
          ? [...buyMarkersref.current]
          : [];
        let opentradeUpdates = [];

        const closedTrades = convertdata.data.filter(
          (t) => t?.id && t.status === "close",
        );
        if (!closedTrades.length) return;
        setWallupdate(false);
        const hasCopyTrade =
          showcopytrades && closedTrades?.some((item) => item?.copy_id);

        if (hasCopyTrade) {
          setWallupdate(true);
          return;
        }
        if (closedTrades.length > 1) {
          const updatedTrades = closedTrades.map((t) => {
            const isNumber =
              typeof t.profit_loss === "number" && !Number.isNaN(t.profit_loss);

            let overallprofit = 0;

            if (isNumber) {
              if (t.profit_loss > 0) {
                overallprofit = t.amount; // profit → add amount
              } else {
                overallprofit = -t.amount; // loss → subtract amount
              }
            }

            return {
              ...t,
              overallprofit,
            };
          });
          const totalProfit = updatedTrades.reduce(
            (acc, t) =>
              acc +
              (typeof t.overallprofit === "number" &&
              !Number.isNaN(t.overallprofit)
                ? t.overallprofit
                : 0),
            0,
          );
          const totelamount = updatedTrades.reduce(
            (acc, t) =>
              acc +
              (typeof t.profit_loss === "number" && !Number.isNaN(t.profit_loss)
                ? Number(t.amount) + t.profit_loss
                : 0),
            0,
          );
          const combinedIds = closedTrades.map((t) => t.id);
          const baseTrade = closedTrades[0];
             if (baseTrade?.copy_id) {
            if (showcopytrades) {
              setWallupdate(true);
              return;
            }
          }
          const isProfit = totalProfit > 0;
          const targetIdx = markersNow.findIndex((m) =>
            combinedIds.includes(m.id),
          );
          opentradeUpdates = opentrade.filter(
            (m) => !combinedIds.includes(m.id),
          );
          if (targetIdx !== -1) {
            const mergedMarker = {
              ...markersNow[targetIdx],
              id: combinedIds,
              status: "close",
              timeleft: "00:00:00",
              text:
                totalProfit === 0
                  ? `+$${formatPrice(totelamount)}`
                  : baseTrade.profit_loss > 0
                    ? `+$${formatPrice(totelamount)}`
                    : baseTrade.profit_loss < 0
                      ? `$0`
                      : `+$${formatPrice(baseTrade.amount)}`,

              color:
                totalProfit === 0
                  ? "#ffc107"
                  : baseTrade.profit_loss > 0
                    ? "#00C853"
                    : baseTrade.profit_loss < 0
                      ? "#FF3B30"
                      : "#ffc107",
              time:
                convertToISTTimestamp(baseTrade?.close_time)?.timestampMillis ??
                markersNow[targetIdx].time,
              price: baseTrade?.exit_price ?? markersNow[targetIdx].price,
              profit_loss:
                baseTrade?.profit_loss > 0 ? baseTrade?.profit_loss : 0,
              exit_price: baseTrade?.exit_price,
              totelamount: totelamount,
            };
            markersNow = markersNow.filter((m) => !combinedIds.includes(m.id));
            polygonapi(mergedMarker);
            console.log(mergedMarker, "mergedMarker");
            addNotification(mergedMarker, "close");

            if (soundEnabled && soundbalanceref.current) {
              if (baseTrade.profit_loss > 0) {
                const click = new Audio(tradewin);
                click.currentTime = 0;
                click.play();
              } else {
                const click = new Audio(tradeloss);
                click.currentTime = 0;
                click.play();
              }
            }
            markersNow.push(mergedMarker);
            closedTrades.forEach((trade) => {
              setCheckclosetrade((prev) => [...prev, trade]);
            });
            startOrResumeTimeout(mergedMarker, false);
          }
        } else {
          closedTrades.forEach((trade) => {
            polygonapi(trade);
            addNotification(trade, "close");

            const idx = markersNow.findIndex(
              (m) => String(m.id) === String(trade.id),
            );
            setCheckclosetrade((prev) => [...prev, trade]);

            const profitIsNum =
              typeof trade?.profit_loss === "number" &&
              !Number.isNaN(trade.profit_loss);
            const isProfit = profitIsNum && trade.profit_loss > 0;
            if (soundEnabled && soundbalanceref.current) {
              if (trade.profit_loss > 0) {
                const click = new Audio(tradewin);
                click.currentTime = 0;
                click.play();
              } else {
                const click = new Audio(tradeloss);
                click.currentTime = 0;
                click.play();
              }
            }
            const updatedMarker = {
              ...(idx !== -1 ? markersNow[idx] : {}),
              id: trade.id,
              status: "close",
              timeleft: "00:00:00",
              text: profitIsNum
                ? trade.profit_loss > 0
                  ? `+$${formatPrice(trade.amount + trade.profit_loss)}`
                  : trade.profit_loss < 0
                    ? `$0`
                    : `+$${formatPrice(trade.amount)}`
                : `$0`,
              price: trade?.exit_price ? trade?.exit_price : "",
              color:
                trade.profit_loss > 0
                  ? "#00C853"
                  : trade.profit_loss < 0
                    ? "#FF3B30"
                    : "#ffc107",
              time:
                convertToISTTimestamp(trade?.close_time)?.timestampMillis ??
                Date.now(),
            };

            if (idx !== -1) {
              markersNow[idx] = updatedMarker;
            } else {
              markersNow.push(updatedMarker);
            }
            if (opentradeUpdates?.length) {
              opentradeUpdates = opentradeUpdates.map((t) =>
                t.id === trade.id
                  ? {
                      ...t,
                      status: "close",
                      profit_loss: trade.profit_loss,
                      text: profitIsNum
                        ? isProfit
                          ? `+$${formatPrice(trade.amount + trade.profit_loss)}`
                          : `$0`
                        : `$0`,
                      color: isProfit ? "#00C853" : "#FF3B30",
                      time:
                        convertToISTTimestamp(trade?.close_time)
                          ?.timestampMillis ?? t.time,
                      price: trade?.exit_price ?? t.price,
                    }
                  : t,
              );
            }

            startOrResumeTimeout(updatedMarker, false);
          });
        }
        buyMarkersref.current = [...markersNow];

        if (opentradeUpdates?.length > 0) {
          setOpentrade([...opentradeUpdates]);
          console.log([...opentradeUpdates], "opentradeopentrade 4");
        }

        setWallupdate((v) => !v);
      }
    };
    ws.onerror = (error) => console.error("WebSocket Error:", error);
    ws.onclose = () => console.log("WebSocket Closed");

    return () => ws.close();
  };
  function startOrResumeTimeout(trade, check) {
    const ids = Array.isArray(trade.id) ? trade.id : [trade.id]; // normalize to array

    ids.forEach((id) => {
      startTimeMapRef.current.set(id, Date.now());
      const remainingTime = remainingTimeMapRef.current.get(id) ?? totalTimeout;

      // clear existing timeout if any
      if (timeoutMapRef.current.has(id)) {
        clearTimeout(timeoutMapRef.current.get(id));
        timeoutMapRef.current.delete(id);
      }

      const timeoutId = setTimeout(() => {
        const filtered = buyMarkersref.current.filter(
          (m) => m.id !== trade?.id,
        );
        buyMarkersref.current = [...filtered];

        // if (buyMarkersref.current?.length === 1) {
        //   buyMarkersref.current = [];
        // }

        timeoutMapRef.current.delete(id);
        remainingTimeMapRef.current.delete(id);
        startTimeMapRef.current.delete(id);
      }, remainingTime);

      timeoutMapRef.current.set(id, timeoutId);
    });
  }
  // useEffect(() => {

  //   let timeoutId;

  //   const runFilter = () => {
  //     const hasClosed = buyMarkersref.current.some(m => m.status === "close");
  //         console.log(hasClosed, "filtered 144")
  //     if (checkimageopen.current === false && hasClosed) {
  //       timeoutId = setTimeout(() => {
  //         const filtered = buyMarkersref.current.filter(m => m.status !== "close");

  //         buyMarkersref.current = [...filtered];
  //         console.log("Filtered after 3s:", buyMarkersref.current);
  //       }, 1000);
  //     }
  //   };
  //  console.log("Filtered after 3s999:", buyMarkersref.current);
  //   runFilter(); // Run immediately on dependency change

  //   return () => {
  //     clearTimeout(timeoutId); // Clean up if deps change or unmount
  //   };
  // }, [checkimageopen.current, buyMarkersref.current]);
  let pingInterval = useRef(null);
  const setupwebsoket = (updatecalndleddata, interval, unit) => {
    console.log(updatecalndleddata, "updatecalndleddata");
    let WebSocketurl = "";
    let purms = "";

    if (soketref.current) {
      websoketarrref.current = [];
      soketref.current.onclose = null;
      soketref.current.onmessage = null;
      soketref.current.onerror = null;
      soketref.current.close();
      soketref.current = null;
      websoketclose.current = false;
      clearInterval(pingInterval.current);
    }
    WebSocketurl =
      chnagetyperef.current?.type === "otc"
        ? process.env.REACT_APP_WSS_URL
        : "wss://vmi2989372.contaboserver.net:8083/app/tbxtl8ae5l5ohkhozehl?protocol=7";

    let sign = chnagetyperef.current?.sortname.toLowerCase();
    if (chnagetyperef.current?.type === "crypto") {
      sign = chnagetyperef.current?.keyword.toLowerCase();
      purms = `crypto.${sign}`;
      // purms = `crypto.btcusd`;
    } else if (chnagetyperef.current?.type === "currencies") {
      let csymbollower = chnagetyperef?.current?.csymbol.toLowerCase();
      purms = `forex.${sign}${csymbollower}`;
    } else if (chnagetyperef.current?.type === "otc") {
      let csymbollower = chnagetyperef?.current?.ticker.toLowerCase();
      purms = `otc.${csymbollower}`;
    }
    const ws = new WebSocket(WebSocketurl);
    setChartLoader(false);
    soketref.current = ws;
    websoketclose.current = true;
    ws.onopen = () => {
      ws.send(
        JSON.stringify({
          event: "pusher:subscribe",
          data: {
            channel: purms,
          },
        }),
      );
    };
    pingInterval.current = setInterval(() => {
      ws.send(JSON.stringify({ event: "pusher:ping", data: {} }));
    }, 9000);

    ws.onmessage = async (event) => {
      const data = JSON.parse(event.data);
      let csymbollower = chnagetyperef?.current?.ticker.toLowerCase();
      let checkotc = `otc.${csymbollower}`;
      if (data?.channel === checkotc) {
        // setChartLoader(false);
        const convertdata = JSON.parse(data.data);

        if (convertdata?.data?.symbol) {
          const newData = {
            open: parseFloat(parseFloat(convertdata?.data?.o).toFixed(5)),
            close: parseFloat(parseFloat(convertdata?.data?.c).toFixed(5)),
            high: parseFloat(parseFloat(convertdata?.data?.h).toFixed(5)),
            low: parseFloat(parseFloat(convertdata?.data?.l).toFixed(5)),
            time: convertdata?.data?.t * 1000,
          };

          let updatedData = [];
          if (tradestyleref.current !== "3") {
            websoketclose.current = true;
            websoketrunning.current = true;
            updatedData = await updateDataWithWebSocketData(
              updatecalndleddata,
              newData,
              parseInt(candletimer?.value),
              candletimer?.type,
            );
          }

          if (tradestyleref.current === "5") {
            const heikenAshiData = await updatedData.map((candle) => {
              return convertToHeikenAshi({
                time: candle.time,
                open: candle.open,
                high: candle.high,
                low: candle.low,
                close: candle.close,
              });
            });
            // seriesRef.current.setData(heikenAshiData);
          } else if (tradestyleref.current === "3") {
            let linedata = await convertToLineChartData(newData, "convertobj");
            // seriesRef.current.update(linedata);
          }
        }
      } else {
      if (data?.channel) {
  if (chnagetyperef.current?.type === "otc") return;

  const convertdata = JSON.parse(data.data);
  let livedata = convertdata?.data;

  if (livedata?.symbol) {
    if (runningcandledataref.current) {
      let obj = {
        close: parseFloat(parseFloat(livedata?.p).toFixed(4)),
        time: livedata?.t,
        st: livedata?.st,
      };

      if (obj?.time && obj?.close) {

        // keep websocket millisecond timestamp
        const newEntry = {
          p: obj?.close,
          t: obj?.time,
          st: obj?.st,
        };

        // console.log(obj, "timer in websocket", newEntry);


        if (tradestyleref.current !== "3") {

          // every websocket tick update
          groupedDataRef.current.push(newEntry);


          let data1 = [];

          if (groupedDataRef.current?.length) {

            let newobj = {
              close: parseFloat(
                parseFloat(
                  groupedDataRef.current[
                    groupedDataRef.current.length - 1
                  ]?.p
                ).toFixed(4)
              ),

              time:
                groupedDataRef.current[
                  groupedDataRef.current.length - 1
                ]?.t,

              st:
                groupedDataRef.current[
                  groupedDataRef.current.length - 1
                ]?.st,
            };


            // console.log(obj, "timer outer", newobj);


            if (websoketclose.current) {
              websoketrunning.current = true;

              data1 = await updateDataWithWebSocketData(
                updatecalndleddata,
                newobj,
                interval,
                unit,
                livedata?.ev,
              );
            }
          }
        }


        if (tradestyleref.current === "3") {

          let linedata = await convertToLineChartData(
            obj,
            "convertobj",
          );

          valueSeriesref.current.data.setIndex(
            valueSeriesref.current.data.length - 1,
            obj,
          );
        }
      }
    }
  }
}
      }
    };

    ws.onerror = (error) => {
      console.log("WebSocket Error:", error);
      websoketclose.current = false;
      websoketrunning.current = false;
    };

    ws.onclose = (event) => {
      websoketarrref.current = [];
      clearInterval(pingInterval.current);
      websoketclose.current = false;
      websoketrunning.current = false;
      console.log("WebSocket Closed");
    };

    return () => {
      ws.close();
      // clearTimeout(candleTimeoutRef.current);
    };
  };

  function getReserveTimer(timestamp, interval, unit = "minute") {
    const currentTime = new Date(timestamp * 1000);
    const currentSeconds = currentTime.getSeconds();
    const currentMinutes = currentTime.getMinutes();
    const currentHours = currentTime.getHours();
    const currentDay = currentTime.getDate();
    const currentMonth = currentTime.getMonth();
    const currentYear = currentTime.getFullYear();

    let remainingSeconds;

    if (unit === "minute") {
      remainingSeconds =
        interval * 60 -
        ((currentMinutes * 60 + currentSeconds) % (interval * 60));
    } else if (unit === "second") {
      remainingSeconds = interval - (currentSeconds % interval);
    } else if (unit === "hour") {
      remainingSeconds =
        interval * 3600 -
        ((currentHours * 3600 + currentMinutes * 60 + currentSeconds) %
          (interval * 3600));
    } else if (unit === "day") {
      const startOfDay = new Date(
        currentYear,
        currentMonth,
        currentDay,
      ).getTime();
      remainingSeconds =
        interval * 86400 -
        (((timestamp - startOfDay) / 1000) % (interval * 86400));
    }
    const days = Math.floor(remainingSeconds / 86400);
    const hours = Math.floor((remainingSeconds % 86400) / 3600);
    const minutes = Math.floor((remainingSeconds % 3600) / 60);
    const seconds = remainingSeconds % 60;
    if (unit === "day") {
      return `${days}d ${String(hours).padStart(2, "0")}h ${String(
        minutes,
      ).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
    } else if (unit === "hour") {
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0",
      )}:${String(seconds).padStart(2, "0")}`;
    } else {
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
        2,
        "0",
      )}`;
    }
  }
  const roundToNearestSecond = (timestamp) => {
    return Math.floor(timestamp / 1000) * 1000;
  };
  function convertToMinuteTimestamp(
    msTimestamp,
    interval,
    unit = "minute",
    showtime,
  ) {
    const secondsTimestamp = Math.floor(msTimestamp / 1000);
    const secondsTimestamp01 = Math.floor(showtime / 1000);
    let timer =
      chnagetyperef.current?.type === "otc"
        ? getReserveTimer(secondsTimestamp, interval, unit)
        : getReserveTimer(secondsTimestamp01, interval, unit);
     console.log(msTimestamp, "timer outer", showtime)
    setCandleTime(timer);

    let calculatedTimestamp;

    if (unit === "minute") {
      calculatedTimestamp =
        Math.floor(secondsTimestamp / (interval * 60)) * interval * 60;
    } else if (unit === "second") {
      calculatedTimestamp = Math.floor(secondsTimestamp / interval) * interval;
    } else if (unit === "hour") {
      const hoursTimestamp = Math.floor(secondsTimestamp / 3600) * 3600;
      calculatedTimestamp =
        Math.floor(hoursTimestamp / (interval * 3600)) * interval * 3600;
    } else if (unit === "day") {
      const dayTimestamp = Math.floor(secondsTimestamp / 86400) * 86400;
      calculatedTimestamp =
        Math.floor(dayTimestamp / (interval * 86400)) * interval * 86400;
    }

    return calculatedTimestamp;
  }

  function updateDataWithWebSocketData(
    initialData,
    newData,
    interval = 1,
    unit = "minute",
    showdata,
  ) {
    const newTimestamp =
      convertToMinuteTimestamp(newData.time, interval, unit, newData.st) * 1000;
    const lastIndex = initialData.length - 1;
    const lastCandle = initialData[lastIndex];
    let updated = false;

    if (websoketclose.current) {
      for (let i = 0; i < initialData.length; i++) {
        if (initialData[i].time === newTimestamp) {
          const prevClose = lastCandle.close;
          if (runningcandledataref.current?.length) {
            // runningcandledataref.current.push({
            //   open: newData.open,
            //   close: newData.close,
            //   high: newData.high,
            //   low: newData.low,
            //   time: newData.time,
            // });

            websoketarrref.current.push({
              // open: newData.open,
              close: newData.close,
              // high: newData.high,
              // low: newData.low,
              // time: newData.time,
            });

            const highestHigh = Math.max(
              ...runningcandledataref.current.map((item) => item.high),
            );
            const lowestLow = Math.min(
              ...runningcandledataref.current.map((item) => item.low),
            );
            const highestClose = Math.max(
              ...websoketarrref.current.map((item) => item?.close),
            );
            const lowestClose = Math.min(
              ...websoketarrref.current.map((item) => item?.close),
            );

            initialData[i] = {
              ...initialData[i],
              close: newData.close,
              high: Math.max(highestHigh, highestClose),
              low: Math.min(lowestLow, lowestClose),
              volume: initialData[i].volume + newData.volume,
              time: newTimestamp,
            };
            if (tradestyleref.current === "5") {
              let hikendata = convertToHeikenAshi(initialData[i]);
              valueSeriesref.current.data.setIndex(
                valueSeriesref.current.data.length - 1,
                hikendata,
              );
              setLastPrice({ ...initialData[i], currenttime: newData.time });
            } else {
              // seriesRef.current.update(initialData[i]);
              valueSeriesref.current.data.setIndex(
                valueSeriesref.current.data.length - 1,
                initialData[i],
              );
            }
            setLastPrice({ ...initialData[i], currenttime: newData.time });
            const lastDataObject = valueSeriesref.current.data.getIndex(
              valueSeriesref.current.data.length - 1,
            );
            // if (lastDataObject) {
            if (currentLabelref.current) {
              currentValueDataItemref.current.animate({
                key: "value",
                to: initialData[i]?.close,
                duration: 500,
                easing: am5.ease.out(am5.ease.cubic),
              });

              currentLabelref.current.set(
                "text",
                stockChartref.current
                  .getNumberFormatter()
                  .format(initialData[i]?.close),
              );

              // Set text color to white
              currentLabelref.current.set("fillOpacity", 1);

              // Ensure background is not transparent
              let bg = currentLabelref.current.get("background");

              // If no background exists, create one
              if (!bg) {
                bg = am5.Rectangle.new(rootref.current, {});
                currentLabelref.current.set("background", bg);
              }

              // Apply solid background style
              bg.setAll({
                fill: am5.color(0x474451),
                fillOpacity: 1, // Fully opaque
                opacity: 1, // Also fully opaque
                strokeOpacity: 0,
                cornerRadius: 6,
              });
            }
            // }

            updated = true;
            break;
          } else {
            websoketarrref.current.push({
              // open: newData.open,
              close: newData.close,
              // high: newData.high,
              // low: newData.low,
              // time: newData.time,
            });

            const highestHigh = Math.max(
              ...websoketarrref.current.map((item) => item.close),
            );
            const lowestLow = Math.min(
              ...websoketarrref.current.map((item) => item.close),
            );

            initialData[i] = {
              ...initialData[i],
              close: newData.close,
              high: highestHigh,
              low: lowestLow,
              volume: initialData[i].volume + newData.volume,
              time: newTimestamp,
            };
            if (tradestyleref.current === "5") {
              let hikendata = convertToHeikenAshi(initialData[i]);
              // seriesRef.current.update(hikendata);
            } else {
              // seriesRef.current.update(initialData[i]);
              if (initialData) {
                if (valueSeriesref.current.data?._values?.length > 10) {
                  valueSeriesref.current.data.setIndex(
                    valueSeriesref.current.data.length - 1,
                    initialData[i],
                  );
                }
              }
            }
            setLastPrice({ ...initialData[i], currenttime: newData.time });
            if (currentLabelref.current) {
              currentValueDataItemref.current.animate({
                key: "value",
                to: initialData[i]?.close,
                duration: 500,
                easing: am5.ease.out(am5.ease.cubic),
              });

              currentLabelref.current.set(
                "text",
                stockChartref.current
                  .getNumberFormatter()
                  .format(initialData[i]?.close),
              );

              // Set text color to white
              currentLabelref.current.set("fillOpacity", 1);

              // Ensure background is not transparent
              let bg = currentLabelref.current.get("background");

              // If no background exists, create one
              if (!bg) {
                bg = am5.Rectangle.new(rootref.current, {});
                currentLabelref.current.set("background", bg);
              }

              // Apply solid background style
              bg.setAll({
                fill: am5.color(0x474451),
                fillOpacity: 1,
                opacity: 1,
                strokeOpacity: 0,
                cornerRadius: 6,
                location: 0.5,
              });
            }
            updated = true;
            break;
          }
        }
      }

      if (!updated) {
        websoketarrref.current = [];
        runningcandledataref.current = [];
        if (chnagetyperef.current?.type === "otc") {
          initialData.push({
            open: lastCandle.close,
            close: lastCandle.close,
            high: lastCandle.close,
            low: lastCandle.close,
            volume: lastCandle.close,
            time: newTimestamp,
          });

          if (tradestyleref.current === "5") {
            let hikendata = convertToHeikenAshi({
              open: newData.close,
              close: newData.close,
              high: newData.close,
              low: newData.close,
              volume: newData.volume,
              time: newTimestamp,
            });
          } else {
            if (websoketclose.current) {
              valueSeriesref.current.data.push({
                open: lastCandle.close,
                close: lastCandle.close,
                high: lastCandle.close,
                low: lastCandle.close,
                volume: lastCandle.close,
                time: newTimestamp,
              });
            }
          }
        } else {
          initialData.push({
            open: newData.close,
            close: newData.close,
            high: newData.close,
            low: newData.close,
            volume: newData.volume,
            time: newTimestamp,
          });

          if (tradestyleref.current === "5") {
            let hikendata = convertToHeikenAshi({
              open: newData.close,
              close: newData.close,
              high: newData.close,
              low: newData.close,
              volume: newData.volume,
              time: newTimestamp,
            });
          } else {
            if (websoketclose.current) {
              valueSeriesref.current.data.push({
                open: newData.close,
                close: newData.close,
                high: newData.close,
                low: newData.close,
                volume: newData.volume,
                time: newTimestamp,
              });
            }
          }
        }
        setLastPrice({
          ...initialData[initialData.length - 1],
          currenttime: newData.time,
        });
        // setLastPrice(initialData[initialData.length - 1]);
      }

      // setLastPrice(initialData[initialData.length - 1]);

      return initialData;
    }
  }

  // useEffect(() => {
  //   if (
  //     chartRef.current &&
  //     time &&
  //     lastPrice &&
  //     tradestyleref.current !== "3"
  //   ) {
  //     if (priceLineref.current) {
  //       seriesRef.current.removePriceLine(priceLineref.current);
  //     }
  //     const price = parseFloat(lastPrice?.close);
  //     // const animatedPrice =   animatePrice(lastPrice?.close)
  //     const priceLine = seriesRef.current.createPriceLine({
  //       price: price,
  //       color: lastPrice?.open > lastPrice?.close ? "#f3382c" : "#32ac41",
  //       lineWidth: 1,
  //       lineStyle: 3,
  //       axisLabelVisible: true,
  //       visible: true,
  //       mode: CrosshairMode.Magnet,
  //     });
  //     priceLineref.current = priceLine;
  //     const chartContainer = tradingViewRef.current;

  //     if (chartContainer) {
  //       let label = document.getElementById("floating-price-label");

  //       if (!label) {
  //         label = document.createElement("div");
  //         label.id = "floating-price-label";
  //         label.style.position = "absolute";
  //         label.style.background =
  //           lastPrice?.open > lastPrice?.close
  //             ? customcaldle?.downColor
  //             : customcaldle?.upColor;
  //         label.style.color = "#fff";
  //         label.style.padding = "4px 8px";
  //         label.style.borderRadius = "4px";
  //         label.style.fontSize = "12px";
  //         label.style.pointerEvents = "none";
  //         label.style.left = "100px";
  //         label.style.marginLeft = "100px";
  //         label.style.zIndex = "2";
  //         label.style.display =
  //           tradestyleref.current === "3" || !stoptimmer ? "none" : "block";
  //         chartContainer.appendChild(label);
  //       }

  //       label.innerText = stoptimmer ? time : time;
  //       const updateLabelPosition = () => {
  //         const logicalPrice = seriesRef.current.priceToCoordinate(price);
  //         const logicalTime = chartRef.current
  //           .timeScale()
  //           .timeToCoordinate(lastPrice.time);
  //         if (logicalPrice !== null && logicalTime !== null) {
  //           label.style.left = `${logicalTime}px`;
  //           label.style.top = `${logicalPrice - 20}px`;
  //           label.style.display =
  //             tradestyleref.current === "3" || !stoptimmer ? "none" : "block";
  //         }
  //       };
  //       // timmerref.current = label;
  //       updateLabelPosition();
  //       chartRef.current.subscribeCrosshairMove(updateLabelPosition);
  //     }
  //     return () => {
  //       if (seriesRef.current && priceLineref.current) {
  //         seriesRef.current.removePriceLine(priceLine);
  //       }

  //       const label = document.getElementById("floating-price-label");
  //       if (label) label.remove();
  //     };
  //   }
  // }, [
  //   chartRef,
  //   time,
  //   lastPrice,
  //   stoptimmer,
  //   customcaldle,
  //   chnagetyperef,
  //   tradestyleref,
  // ]);
  // useEffect(() => {
  //   if (!valueSeriesref.current) return;

  //   // Clear previous bullets
  //   valueSeriesref.current.bullets.clear();
  //   if (!stoptimmer) return;
  //   // Add bullet only to latest candle
  //   valueSeriesref.current.bullets.push(function (root, series, dataItem) {
  //     const dataItems = series.dataItems;
  //     const lastDataItem = dataItems[dataItems.length - 1];

  //     if (dataItem === lastDataItem) {
  //       // Create container for arrow + label
  //       const container = am5.Container.new(root, {
  //         layout: root.verticalLayout, // stack vertically
  //         centerX: am5.p50,
  //         centerY: am5.p50,
  //         dx: 50,
  //         dy: 4,
  //       });

  //       // Text label (valueY)
  //       const label = am5.Label.new(root, {
  //         text: `${candletimer?.duration}\n${time}`, // show price
  //         fontSize: 12,
  //         fill: am5.color(0xffffff),
  //         centerX: am5.p50,
  //         textAlign: "end",
  //       });

  //       container.children.push(label);

  //       return am5.Bullet.new(root, {
  //         locationX: 0.5,
  //         locationY: 0.5,
  //         sprite: container,
  //         field: "value",
  //       });
  //     }
  //     return undefined;
  //   });
  // }, [lastPrice, stoptimmer]);
  //   useEffect(() => {
  //   if (!valueSeriesref.current) return;

  //   // Remove previous M1 factory if exists
  //   if (m1BulletFactoryRef.current) {
  //     valueSeriesref.current.bullets.removeValue(m1BulletFactoryRef.current);
  //   }

  //   if (!stoptimmer) return;

  //   // Add bullet only to latest candle
  //   const factory = function (root, series, dataItem) {
  //     const dataItems = series.dataItems;
  //     const lastDataItem = dataItems[dataItems.length - 1];

  //     if (dataItem === lastDataItem) {
  //       const container = am5.Container.new(root, {
  //         layout: root.verticalLayout,
  //         centerX: am5.p50,
  //         centerY: am5.p50,
  //         dx: 50,
  //         dy: 4,
  //       });

  //       const label = am5.Label.new(root, {
  //         text: `${candletimer?.duration}\n${time}`,
  //         fontSize: 12,
  //         fill: am5.color(0xffffff),
  //         centerX: am5.p50,
  //         textAlign: "end",
  //       });

  //       container.children.push(label);

  //       return am5.Bullet.new(root, {
  //         locationX: 0.5,
  //         locationY: 0.5,
  //         sprite: container,
  //         field: "value",
  //       });
  //     }

  //     return undefined;
  //   };

  //   m1BulletFactoryRef.current = factory;
  //   valueSeriesref.current.bullets.push(factory);
  // }, [lastPrice, stoptimmer, candletimer]);
  const toggleAutoScroll = (isAutoScrollEnabled) => {
    if (chartRef.current && seriesRef.current) {
      const chart = chartRef.current;
      const timeScale = chart.timeScale();

      if (isAutoScrollEnabled) {
        const dataLength = seriesRef.current.data().length;
        const visibleRange = {
          from: dataLength - 30,
          to: dataLength - 1,
        };
        timeScale.setVisibleLogicalRange(visibleRange);
        timeScale.scrollToPosition(5);
      } else {
        timeScale.scrollToRealTime(5);
      }
      // setIsAutoScrollEnabled(!isAutoScrollEnabled);
    }
  };
  const [error, setError] = useState(null);
  const SPREAD_PERCENT = 0.5;
  const RANDOM_FLUCTUATION = 0.2;
  const timeoutRef1 = useRef(null);
  const socialtradetimmer = (opentrade, buyMarkers) => {
    if (timeoutRef1.current || !opentrade?.length || !buyMarkers?.length) {
      clearTimeout(timeoutRef1.current);
    }
    const markerTimers = new Map();

    const updateTime = () => {
      if (!opentrade?.length || !buyMarkers?.length) return;
      let updatedTrades = opentrade.map((trade) => {
        const closeTimeParts = trade.close_time.split(/[- :]/);
        const localCloseDate = new Date(
          closeTimeParts[0],
          closeTimeParts[1] - 1,
          closeTimeParts[2],
          closeTimeParts[3],
          closeTimeParts[4],
          closeTimeParts[5],
        );

        const closeTime = localCloseDate.getTime() + 5.5 * 60 * 60 * 1000;
        const currentTime = Date.now();

        const timeDiff = Math.max(
          0,
          Math.floor((closeTime - currentTime) / 1000),
        );

        if (timeDiff === 0) {
          return {
            ...trade,
            timeleft: "00:00:00",
            progress: 100,
            status: "close",
          };
        }

        const newTimeLeft = [
          String(Math.floor(timeDiff / 3600)).padStart(2, "0"),
          String(Math.floor((timeDiff % 3600) / 60)).padStart(2, "0"),
          String(timeDiff % 60).padStart(2, "0"),
        ].join(":");

        const initialTime =
          trade.initialTime ||
          Math.floor((closeTime - new Date(trade.start_time).getTime()) / 1000);
        const elapsedTime = initialTime - timeDiff;
        const newProgress = Math.min((elapsedTime / initialTime) * 100, 100);

        return {
          ...trade,
          timeleft: newTimeLeft,
          progress: newProgress,
          status: "open",
          text: `${newTimeLeft} $${trade.amount}`,
        };
      });
      let updatedMarkers = buyMarkers.map((marker, index) => {
        const trade = updatedTrades[index];
        if (closetraderesf.current?.length) {
          if (closetraderesf.current.includes(marker.id)) {
            return null;
          }
        }

        if (trade?.timeleft === "00:00:00") {
          const lastCandle = seriesRef.current.data().slice(-1)[0];
          const finalPrice =
            tradestyle === "3" ? lastCandle?.value : lastCandle?.close;
          const isProfit =
            (marker.tradetype === "buy" && marker.price < finalPrice) ||
            (marker.tradetype === "sell" && marker.price > finalPrice);
          return {
            id: trade?.id,
            time: marker.time,
            status: "pending",
            rendomid: marker.rendomid,
            // position: marker.tradetype === "buy" ? "belowBar" : "aboveBar",
            color: marker.tradetype === "buy" ? "#00C853" : "#FF3B30",
            // shape: marker.tradetype === "buy" ? "arrowUp" : "arrowDown",
            price: finalPrice,
            text: `...`,
          };
        }
        return {
          ...marker,
          text: trade.text,
          status: trade.status,
          id: trade?.id,
        };
      });
      updatedMarkers = updatedMarkers.filter((marker) => marker !== null);
      socialMarkersref.current = updatedMarkers;
      updatedMarkers.forEach((marker) => {
        if (marker.status === "pending" && !markerTimers.has(marker.id)) {
          const timer = setTimeout(() => {
            checksocialclose(marker, socialMarkersref.current);
            updatedMarkers = updatedMarkers.filter(
              (trade) => trade.status !== "pending",
            );
            markerTimers.delete(marker.id);
          }, 2000);
          markerTimers.set(marker.id, timer);
        }
      });
      if (updatedTrades.some((trade) => trade.timeleft !== "00:00:00")) {
        timeoutRef1.current = setTimeout(updateTime, 1000);
      }
    };

    updateTime();
  };
  const checksocialclose = async (checkpending, updatedMarkers) => {
    if (checkpending && !processedIds.current.has(checkpending.id)) {
      processedIds.current.add(checkpending.id);
      try {
        let postdata = {};
        let res = await authcallApi(
          postdata,
          `api/checktrade/${checkpending?.id}`,
          "GET",
        );
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        if (res?.data?.trade) {
          closetraderesf.current.push(res?.data?.trade?.id);
          addNotification(res?.data?.trade, "close");
          let checkptofit = socialMarkersref.current.find(
            (trade) => trade.status === "pending",
          );

          const updatedMarkers = socialMarkersref.current.map((marker) => {
            if (marker.id === checkptofit.id) {
              return {
                ...marker,
                text: res?.data?.trade?.profit
                  ? `+$${res?.data?.trade?.profit_loss}`
                  : `$0`,
                color: res?.data?.trade?.profit
                  ? customcaldle?.upColor
                  : customcaldle?.downColor,
              };
            }
            return marker;
          });

          socialMarkersref.current = updatedMarkers;
          if (socialMarkersref.current?.length === 1) {
            const clearMarkers = async () => {
              await delay(2000);
              socialMarkersref.current = [];
            };
            clearMarkers();
          }
        }
      } catch (err) {
        console.log(err, "Error during API call");
      }
    }
  };
  const getsocialwatch = (trades) => {
    if (trades?.length) {
      let updatedtrade = trades.map((result) => {
        return {
          id: result?.id,
          status: "open",
          amount: result?.amount,
          // peramount : ,
          tradetype: result?.type,
          // secondsLeft,
          rendomid: result?.reference_id,
          time: result?.polygontime,
          price: result?.entry_price,
          // position: result?.type === "buy" ? "belowBar" : "aboveBar",
          color:
            result?.type === "buy"
              ? customcaldle?.upColor
              : customcaldle?.downColor,
          // shape: result?.type === "buy" ? "arrowUp" : "arrowDown",
        };
      });

      socialMarkersref.current = updatedtrade;
      socialtradetimmer(trades, updatedtrade);
    } else {
      socialMarkersref.current = [];
      socialtradetimmer(trades, []);
    }
  };
  const [assetlistpre, setAssetlistpre] = useState({
    cryptocurrencieslist: [],
    currencieslist: [],
  });

  const assetapi = async (autorefresh) => {
    try {
      let postdata = {};
      let res = await callApi(postdata, `api/assets`);
      if (res?.data?.success) {
        setAssetlistpre({
          cryptocurrencieslist: res?.data?.cryptocurrencieslist?.sort(
            (a, b) => Number(b.payout) - Number(a.payout),
          ),
          currencieslist: res?.data?.currencieslist?.sort(
            (a, b) => Number(b.payout) - Number(a.payout),
          ),
        });
        if (!autorefresh) {
          selectasset(res?.data?.cryptocurrencieslist);
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    assetapi();
  }, []);
  useEffect(() => {
    let array = [
      ...assetlistpre?.cryptocurrencieslist,
      ...assetlistpre?.currencieslist,
    ];
    if (array?.length && chnagetyperef.current) {
      const match = array.find((item) => item.sr === chnagetyperef.current.sr);

      if (!match) {
        setshowtradeasset(array[0], "chartasset");
      } else {
        if (match.payout !== chnagetyperef.current.payout) {
          chnagetyperef.current = {
            ...chnagetyperef.current,
            payout: match.payout,
          };
          setshowtradeasset(chnagetyperef.current, "chartasset");
        }
      }
    }
  }, [assetlistpre, chnagetyperef.current]);
  const selectasset = async (cryptocurrencieslist) => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/topcurrency`, `GET`);
      if (res?.data?.success) {
        if (res?.data?.trade_type === "crypto") {
          setShowasset({
            currency: false,
            cryptocurrency: true,
            commodities: false,
            stocks: false,
            indices: false,
            favorites: false,
          });
        } else if (res?.data?.trade_type === "forex") {
          setShowasset({
            currency: true,
            cryptocurrency: false,
            commodities: false,
            stocks: false,
            indices: false,
            favorites: false,
          });
        } else {
          const exists = cryptocurrencieslist.some(
            (item) => item?.ticker === res?.data?.ticker,
          );
          if (exists) {
            setShowasset({
              currency: false,
              cryptocurrency: true,
              commodities: false,
              stocks: false,
              indices: false,
              favorites: false,
            });
          } else {
            setShowasset({
              currency: true,
              cryptocurrency: false,
              commodities: false,
              stocks: false,
              indices: false,
              favorites: false,
            });
          }
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const showassetactive = (type) => {
    const assetTypes = [
      "currency",
      "cryptocurrency",
      "commodities",
      "stocks",
      "indices",
      "favorites",
      "all",
    ];
    const newState = assetTypes.reduce((acc, asset) => {
      acc[asset] = asset === type;
      return acc;
    }, {});

    setShowasset(newState);
  };

  useEffect(() => {
    let updatefavscrypto = [];
    let updatefavscurrency = [];
    if (assetshowlist?.favorites?.length) {
      updatefavscrypto = assetlistpre?.cryptocurrencieslist.map((currency) => {
        const isFavorite = assetshowlist.favorites.some(
          (favorite) => favorite.ticker === currency.ticker,
        );
        if (isFavorite) {
          return {
            ...currency,
            favorite: true,
          };
        } else {
          return {
            ...currency,
            favorite: false,
          };
        }
      });
      updatefavscurrency = assetlistpre?.currencieslist.map((currency) => {
        const isFavorite = assetshowlist.favorites.some(
          (favorite) => favorite.ticker === currency.ticker,
        );
        if (isFavorite) {
          return {
            ...currency,
            favorite: true,
          };
        } else {
          return {
            ...currency,
            favorite: false,
          };
        }
      });
    } else {
      updatefavscrypto = assetlistpre?.cryptocurrencieslist.map((currency) => {
        return {
          ...currency,
          favorite: false,
        };
      });
      updatefavscurrency = assetlistpre?.currencieslist.map((currency) => {
        return {
          ...currency,
          favorite: false,
        };
      });
    }
    let alldata = [
      ...(updatefavscurrency?.length
        ? updatefavscurrency
        : assetlistpre?.currencieslist || []),
      ...(updatefavscrypto?.length
        ? updatefavscrypto
        : assetlistpre?.cryptocurrencieslis || []),
    ];

    const assetToListMap = {
      currency: updatefavscurrency?.length
        ? updatefavscurrency
        : assetlistpre?.currencieslist,
      cryptocurrency: updatefavscrypto?.length
        ? updatefavscrypto
        : assetlistpre?.cryptocurrencieslist,
      commodities: [],
      stocks: [],
      indices: [],
      favorites: assetshowlist?.favorites,
      all: alldata,
    };
    const activeAsset = Object.keys(showasset).find((key) => showasset[key]);
    if (activeAsset === "all") {
      if (searchTermall) {
        const filtered = assetToListMap[activeAsset].filter(
          (asset) =>
            asset?.name?.toLowerCase().includes(searchTermall.toLowerCase()) ||
            asset?.sortname
              .toLowerCase()
              .includes(searchTermall.toLowerCase()) ||
            asset?.keyword
              ?.toLowerCase()
              .includes(searchTermall.toLowerCase()) ||
            asset?.csymbol?.toLowerCase().includes(searchTermall.toLowerCase()),
        );
        setAllAssrtlist(filtered);
        console.log(assetalllist, "assetalllist 1");
      } else {
        setAllAssrtlist(assetToListMap[activeAsset] || []);
        console.log(assetalllist, "assetalllist 2");
        setAddhighlightclass({ index: 0, show: true });
        hightlightref.current = { index: 0, show: true };
      }
    } else {
      if (searchTerm) {
        setSelectshowasset(true);

        const filtered = assetToListMap["all"].filter((asset) => {
          // safely handle missing properties
          const name = asset?.name?.toLowerCase() || "";
          const sortname = asset?.sortname?.toLowerCase() || "";
          const keyword = asset?.keyword?.toLowerCase() || "";
          const csymbol = asset?.csymbol?.toLowerCase() || "";

          return (
            name.includes(searchTerm.toLowerCase()) ||
            sortname.includes(searchTerm.toLowerCase()) ||
            keyword.includes(searchTerm.toLowerCase()) ||
            csymbol.includes(searchTerm.toLowerCase())
          );
        });

        setAssrtlist(filtered);
      } else {
        setSelectshowasset(false);
        setAssrtlist(assetToListMap[activeAsset] || []);
        setAddhighlightclass({ index: 0, show: true });
        hightlightref.current = { index: 0, show: true };
      }
    }
  }, [showasset, assetshowlist, searchTerm, assetlistpre, searchTermall]);
  const setfavs = (value, checkadd) => {
    let array = [...assetshowlist?.favorites];
    if (checkadd) {
      array.push(value);
      array.forEach((result) => {
        result.favorite = true;
      });
    } else {
      array = array.filter((item) => item.ticker !== value?.ticker);
    }
    setshowtradeasset(array, "favorites");
    // setAssetshowlist((state) => ({
    //   ...state,
    //   favorites: array,
    // }));
  };
  const generateOtcCandle = (
    prevClose,
    buyVolume,
    sellVolume,
    timestamp,
    fluctuationRate,
  ) => {
    const open = prevClose;
    const close = open * (1 + (Math.random() * 2 - 1) * fluctuationRate);
    const high = Math.max(open, close) * (1 + Math.random() * fluctuationRate);
    const low = Math.min(open, close) * (1 - Math.random() * fluctuationRate);
    return {
      time: Math.floor(timestamp / 1000), // Convert to seconds
      open,
      high,
      low,
      close,
    };
  };

  const generateOneMonthOtcData = (
    basePrice,
    buyVolume,
    sellVolume,
    fluctuationRate,
  ) => {
    const now = Date.now();
    const oneMonthAgo = now - 30 * 24 * 60 * 60 * 1000;
    const intervalMs = 60 * 1000; // 1-minute interval
    let data = [];
    let prevClose = basePrice;

    for (
      let timestamp = oneMonthAgo;
      timestamp <= now;
      timestamp += intervalMs
    ) {
      const candle = generateOtcCandle(
        prevClose,
        buyVolume,
        sellVolume,
        timestamp,
        fluctuationRate,
      );
      data.push(candle);
      prevClose = candle.close;
    }
    return data;
  };
  const setshowtradeasset = async (value, key) => {
    try {
      let array = [...assetshowlist?.favorites];
      let postdata;
      if (key === "favorites") {
        let array = value;
        // array.push(value);
        const updates = array.length
          ? array.reduce((acc, currId, index) => {
              acc[index] = JSON.stringify(currId);
              return acc;
            }, {})
          : {};
        postdata = {
          key: key,
          value: JSON.stringify(updates),
        };
      } else {
        postdata = {
          key: key,
          value: JSON.stringify(value),
        };
      }
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        if (key === "favorites") {
          showfeveasset();
        } else {
          showtradeasset();
          websoketrunning.current = false;
          websoketclose.current = false;
          fetchServerTime();
          buyMarkersref.current = [];
          websoketarrref.current = [];
          if (otcwebsoket.current) {
            otcwebsoket.current = false;
          }
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const showtradeasset = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=chartasset`,
        "GET",
      );
      if (res?.data?.success) {
        let parsedValue = JSON.parse(res?.data.value);

        const match =
          assetlistpre?.cryptocurrencieslist.find(
            (item) => item.name === parsedValue.name,
          ) ||
          assetlistpre?.currencieslist.find(
            (item) => item.name === parsedValue.name,
          );

        if (!match || match.status === "0") {
          const fallback = assetlistpre?.cryptocurrencieslist.find(
            (item) => item.status === "1",
          );
          if (fallback) {
            parsedValue = fallback;
          }
        }
        chnagetyperef.current = parsedValue;
      } else {
        const activeAssets = [
  ...assetlistpre?.cryptocurrencieslist,
  ...assetlistpre?.currencieslist,
].filter((item) => item.status === "1");

console.log(activeAssets);
        chnagetyperef.current = activeAssets[0];
        console.log(chnagetyperef.current, "chnagetyperef.current 1", activeAssets);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setPageloader((state) => ({
        ...state,
        chartasset: false,
      }));
    }
  };
  const showfeveasset = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=favorites`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        const parsedArray = Object.values(parsedValue).map((item) =>
          JSON.parse(item),
        );
        const filteredArr = parsedArray.filter((item1) => {
          const match = assetlistpre?.cryptocurrencieslist.find(
            (item2) => item2.sr === item1.sr,
          );

          if (match && match.status === "0") {
            return false; // ❌ remove this item
          }

          if (match && match.status === "1") {
            item1.status = "1"; // ✅ update status
          }

          return true; // ✅ keep the item
        });
        setAssetshowlist((state) => ({
          ...state,
          favorites: filteredArr,
        }));
      } else {
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setPageloader((state) => ({
        ...state,
        favorites: false,
      }));
    }
  };
  useEffect(() => {
    if (
      assetlistpre?.cryptocurrencieslist?.length ||
      assetlistpre?.currencieslist?.length
    ) {
      showtradeasset();
    }
    showfeveasset();
  }, [assetlistpre]);

  const updateCountRef = useRef(0);

  const indicatorfav = (key) => {
    let updateindicatorlist = [...indicatorlist];
    if (updateindicatorlist[key]?.fav) {
      updateindicatorlist[key].fav = false;
    } else {
      updateindicatorlist[key].fav = true;
    }
    setIndicatorlist(updateindicatorlist);
  };
  const deleteall = () => {
    deleteind("all");
    deletedrawing("all");
    const modalEl = modalRefs.current["deletemodel"];
    if (modalEl) {
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  };
  const deleteind = (key, result) => {
    if (key === "all") {
      // delete all
      setShowindicator([]);
      setupshowindicator(result, null, "delete-all");
    } else {
      let updateindicatorlist = [...showindicator];
      updateindicatorlist = updateindicatorlist.filter(
        (_, index) => index !== key,
      );
      setShowindicator(updateindicatorlist);
      setupshowindicator(result, key, "delete");
    }
  };
  const indicatorMap = {
    "Awesome Oscillator": {
      class: am5stock.AwesomeOscillator,
      options: {},
    },
    Aroon: {
      class: am5stock.Aroon,
      options: { shortPeriod: 12, longPeriod: 26 },
    },
    "Bears Power": {
      class: am5stock.BullBearPower,
      options: { type: "bear" },
    },
    "Bulls Power": {
      class: am5stock.BullBearPower,
      options: { type: "bull" },
    },
    MACD: {
      class: am5stock.MACD, // Substitute (not available directly)
      options: {},
    },
    DeMarker: {
      class: am5stock.CommodityChannelIndex, // Substitute (not available directly)
      options: { period: 14 },
    },
    "Rate of Change": {
      class: am5stock.Momentum, // Closest available option
      options: { period: 14 },
    },
    "Average True Range": {
      class: am5stock.AverageTrueRange,
      options: { period: 14 },
    },
    "Bollinger Bands": {
      class: am5stock.BollingerBands,
      options: { period: 20, deviation: 2 },
    },
    Momentum: {
      class: am5stock.Momentum,
      options: { period: 10 },
    },
    "Moving Average": {
      class: am5stock.MovingAverage,
      options: { period: 14 },
    },
    MACross: {
      class: am5stock.MACross,
      options: {
        deviation: 5, // Minimum % change required to draw a new line
        depth: 12, // Number of candles to consider for extremum
        backstep: 3, // Minimum number of candles between peaks/troughs
      },
    },
    ZigZag: {
      class: am5stock.ZigZag,
      options: {
        deviation: 5,
        depth: 12,
        backstep: 3,
      },
    },
    RSI: {
      class: am5stock.RelativeStrengthIndex,
      options: { period: 14 },
    },
    "Stochastic Oscillator": {
      class: am5stock.StochasticOscillator,
      options: { kPeriod: 14, dPeriod: 3 },
    },
    "Williams %R": {
      class: am5stock.WilliamsR,
      options: { period: 14 },
    },
    "Stochastic Momentum Index": {
      class: am5stock.StochasticMomentumIndex,
      options: { kPeriod: 14, dPeriod: 3 },
    },
    "Moving Average Deviation": {
      class: am5stock.MovingAverageDeviation,
      options: { period: 14 },
    },
    "Moving Average Envelope": {
      class: am5stock.MovingAverageEnvelope,
      options: { period: 20, shift: 2 },
    },
    "Acceleration Bands": {
      class: am5stock.AccelerationBands,
      options: { period: 20, deviation: 2 },
    },
    "Accumulation Distribution": {
      class: am5stock.AccumulationDistribution,
      options: {},
    },
    "Accumulative Swing Index": {
      class: am5stock.AccumulativeSwingIndex,
      options: {},
    },
  };

  const setupshowindicator = (result, _, check) => {
    if (!rootref.current || !stockChartref.current || !valueSeriesref.current)
      return;

    const root = rootref.current;
    const stockChart = stockChartref.current;
    const valueSeries = valueSeriesref.current;
    const config = indicatorMap[result?.name];
    if (check === "delete-all") {
      // reset all indicators
      setIndicatorlist((prev) =>
        prev.map((item) => ({ ...item, current: false })),
      );

      setShowindicator([]);

      // remove all indicator instances from chart
      Object.keys(indicatorInstancesRef.current).forEach((name) => {
        const instance = indicatorInstancesRef.current[name];
        if (instance) {
          stockChart.indicators.removeValue(instance);
          instance.dispose();
        }
        delete indicatorInstancesRef.current[name];
      });

      return;
    }
    const updatedIndicators = indicatorlist.map((item) =>
      item.name === result.name
        ? { ...item, current: check === "delete" ? false : !item.current }
        : item,
    );

    setIndicatorlist(updatedIndicators);

    if (check === "delete") {
      setShowindicator((prev) =>
        prev.filter((item) => item.name !== result.name),
      );

      const instance = indicatorInstancesRef.current[result.name];
      if (instance) {
        stockChart.indicators.removeValue(instance);
        instance.dispose();
        delete indicatorInstancesRef.current[result.name];
      }
      return;
    }

    // ADD mode
    const alreadyShown = showindicator.some(
      (item) => item.name === result.name,
    );
    if (!alreadyShown) {
      setShowindicator((prev) => [...prev, result]);
    }

    if (config?.class && !indicatorInstancesRef.current[result.name]) {
      const { class: IndicatorClass, options } = config;

      // Create indicator
      const indicator = IndicatorClass.new(root, {
        stockChart,
        stockSeries: valueSeries,
        ...options,
      });

      stockChart.indicators.push(indicator);
      indicatorInstancesRef.current[result.name] = indicator;

      // Access the series after creation to set labels
      const series = indicator.get("series");
      if (series) {
        series.set("valueYShow", "value");

        series.set("valueLabels", {
          fill: am5.color(0xffffff), // White color
          text: "{valueY}",
          fontSize: 10,
          fontWeight: "normal",
          paddingTop: 0,
          paddingBottom: 0,
          centerY: 0,
          centerX: 0,
          populateText: true,
        });

        // Force redraw
        series.appear(100);
      }

      // Watch for removal
      indicator.events.on("disposed", () => {
        delete indicatorInstancesRef.current[result.name];
        setShowindicator((prev) =>
          prev.filter((item) => item.name !== result.name),
        );
        setIndicatorlist((prev) =>
          prev.map((item) =>
            item.name === result.name ? { ...item, current: false } : item,
          ),
        );
      });
    }
  };

  const setidemodal = (result) => {
    setIdmodaldata(result);
    openindModal();
  };
  const setsoundbalancepre = async (value, checksound) => {
    try {
      let data;
      if (checksound) {
        data = value;
      } else {
        data = false;
      }

      let postdata = {
        key: "soundbalance",
        value: JSON.stringify(data),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getsoundbalance();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getsoundbalance = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=soundbalance`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        soundbalanceref.current = parsedValue;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsoundbalance();
  }, []);
  const setsettingprefrence = async (
    classNameicMode,
    soundEnabled,
    showtooltip,
  ) => {
    try {
      if (classNameicMode) {
        setSettingloader((state) => ({
          ...state,
          classic: true,
          default: false,
        }));
      } else {
        setSettingloader((state) => ({
          ...state,
          classic: false,
          default: true,
        }));
      }
      let value = {
        tradingbuttion: classNameicMode,
        soundcontrol: soundEnabled,
        tooltip: showtooltip,
      };
      let postdata = {
        key: "chartsetting",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getsettingprefrence();
        setsoundbalancepre(value?.soundcontrol, value?.soundcontrol);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsettingprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=chartsetting`,
        "GET",
      );
      if (res?.data?.success) {
        setSettingloader((state) => ({
          ...state,
          classic: false,
          default: false,
        }));
        const parsedValue = JSON.parse(res?.data.value);
        setClassNameicMode(parsedValue?.tradingbuttion);
        setSoundEnabled(parsedValue?.soundcontrol);
        setShowtooltip(parsedValue?.tooltip);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const fetchServerTimefordate = async () => {
    const timezonePref = await gettimezoneprefrence(); // { time: "+05:30", ... }

    if (timezonePref) {
      setUpdateTimezone(timezonePref);
    }
  };
  useEffect(() => {
    fetchServerTimefordate();
  }, []);
  const timefreamprefrence = async (value) => {
    try {
      let postdata = {
        key: "timefreams",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        gettimefreamprefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const gettimefreamprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=timefreams`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setCandletimer(parsedValue);
      } else {
        setCandletimer({
          type: "minute",
          value: "1",
          duration: "M1",
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gettimezoneprefrence();
    getsettingprefrence();
    gettimefreamprefrence();
  }, []);
  useEffect(() => {
    if (soketref.current) {
      soketref.current.close();
    }
    if (otcwebsoket.current) {
      seriesRef.current.setData([]);
      otcwebsoket.current = false;
    }
  }, []);

  const { t } = useTranslation();

  const svgeprefrence = async (value) => {
    try {
      let postdata = {
        key: "showsvggraph",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getsvgprefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsvgprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=showsvggraph`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setShowgraphsvg(parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsvgprefrence();
  }, []);

  const changecharttype = (changetype) => {
    let label = document.getElementById("floating-price-label");
    if (label && changetype === "3") {
      label.style.display = "none";
    }
    if (seriesRef.current) {
      seriesRef.current.setData([]);
    }
    setTradestyle(changetype);
    tradestyleref.current = changetype;
  };

  let isNextButtonClicked = false;
  const am5chartlayout = () => {
    if (!chartDiv.current) return;
    rootref.current = am5.Root.new(chartDiv.current);
    rootref.current.utc = true;
    const myTheme = am5.Theme.new(rootref.current);
    myTheme.rule("Grid", ["scrollbar", "minor"]).setAll({ visible: false });
    rootref.current.setThemes([
      am5themes_Animated.new(rootref.current),
      myTheme,
    ]);

    // Create stock chart
    stockChartref.current = rootref.current.container.children.push(
      am5stock.StockChart.new(rootref.current, {
        focusable: true,
        panX: false,
        panY: false,
        // wheelX: "panX",
        // wheelY: "none",
        wheelX: "none",
        wheelY: "none",
        // pinchZoomX: true,
        pinchZoomY: false,
        paddingLeft: 0,
      }),
    );
    // rootref.current.numberFormatter.set("numberFormat", "#,###.00");

    // Main panel
    mainPanelRef.current = stockChartref.current.panels.push(
      am5stock.StockPanel.new(rootref.current, {
        panX: true,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        // pinchZoomX: true,
        pinchZoomY: false,
      }),
    );

    // ⬇️ ADD THIS IMMEDIATELY AFTER
    mainPanelRef.current.events.on("pan", (ev) => {
      if (!isDragging) {
        ev.preventDefault();
        ev.stopPropagation();
        computeVisibleHighLow();
      }
    });
    mainPanelRef.current.events.on("panstart", (ev) => {
      if (!isDragging) {
        ev.preventDefault();
        ev.stopPropagation();
        computeVisibleHighLow();
      }
    });
    const handleTouchEvents = () => {
      if (!mainPanelRef.current || !chartDiv.current) return;

      let initialDistance = null;
      let initialRange = null;

      chartDiv.current.addEventListener(
        "touchstart",
        (e) => {
          if (momentumAnimFrame) {
            cancelAnimationFrame(momentumAnimFrame);
            momentumAnimFrame = null;
          }
          const dragDuration = Date.now() - dragStartTime;
          const speed = Math.abs(lastDeltaX) / Math.max(1, dragDuration);
          if (Math.abs(lastDeltaX) > 20 && speed > 0.00000001) {
            const velocity = lastDeltaX * 0.0009;
            startMomentumPan(velocity);
          }
          if (e.touches.length === 2) {
            // Two-finger touch detected (potential pinch gesture)
            initialDistance = Math.hypot(
              e.touches[0].clientX - e.touches[1].clientX,
              e.touches[0].clientY - e.touches[1].clientY,
            );

            // Store the initial visible range
            initialRange =
              dateAxisref.current.get("end") - dateAxisref.current.get("start");
            e.preventDefault();
          }
        },
        { passive: false },
      );

      chartDiv.current.addEventListener(
        "touchmove",
        (e) => {
          if (momentumAnimFrame) {
            cancelAnimationFrame(momentumAnimFrame);
            momentumAnimFrame = null;
          }
          if (e.touches.length === 1) {
            // One-finger drag (momentum)
            const dragDuration = Date.now() - dragStartTime;
            const speed = Math.abs(lastDeltaX) / Math.max(1, dragDuration);
            if (Math.abs(lastDeltaX) > 20 && speed > 0.00000001) {
              const velocity = lastDeltaX * 0.00009;
              startMomentumPan(velocity);
            }
          }

          if (e.touches.length === 2 && initialDistance !== null) {
            // Pinch zoom only (no momentum)
            const currentDistance = Math.hypot(
              e.touches[0].clientX - e.touches[1].clientX,
              e.touches[0].clientY - e.touches[1].clientY,
            );
            const scale = currentDistance / initialDistance;

            const data = valueSeriesref.current?.data?.values;
            if (!data || data.length < 2) return;

            const start = dateAxisref.current.get("start");
            const end = dateAxisref.current.get("end");
            const totalTime = data[data.length - 1].time - data[0].time;
            const candleTime = data[1].time - data[0].time;

            // Calculate new range
            let newRange = initialRange / scale;
            let minCandles = 30;
            // const maxCandles = isNextButtonVisible ? 45 : 45;
            // const maxCandles = isNextButtonVisible ? 150 : 150;

            let maxCandles;

            // Large screen > 1600px
            if (window.innerWidth > 1600) {
              maxCandles = isNextButtonVisible ? 175 : 175;
            }
            // Medium screen 1000px–1600px
            else if (window.innerWidth > 1000 && window.innerWidth > 1200) {
              maxCandles = isNextButtonVisible ? 160 : 160;
            } else if (window.innerWidth > 750 && window.innerWidth < 1000) {
              maxCandles = isNextButtonVisible ? 150 : 150;
            } else if (window.innerWidth > 600 && window.innerWidth < 800) {
              maxCandles = isNextButtonVisible ? 150 : 150;
              minCandles = 50;
            }
            // Small screen 500px–1000px
            else if (window.innerWidth > 500 && window.innerWidth < 600) {
              maxCandles = isNextButtonVisible ? 100 : 100; // 👈 adjust as you like
            }
            // Extra small screen < 500px
            else {
              maxCandles = isNextButtonVisible ? 75 : 75;
            }

            if ((newRange * totalTime) / candleTime < minCandles) {
              newRange = (minCandles * candleTime) / totalTime;
            } else if ((newRange * totalTime) / candleTime > maxCandles) {
              newRange = (maxCandles * candleTime) / totalTime;

              // ✅ When zoomed out to max → set 60% width
              if (valueSeriesref.current?.columns) {
                valueSeriesref.current.columns.template.setAll({
                  width: am5.percent(60),
                });
              }
            } else {
              // ✅ Otherwise apply your tradestyle condition
              if (
                tradestyleref.current !== "3" &&
                valueSeriesref.current?.columns
              ) {
                valueSeriesref.current.columns.template.setAll({
                  width: am5.percent(90),
                });
              }
            }

            // Pinch center
            const touch1 = e.touches[0];
            const touch2 = e.touches[1];
            const centerX = (touch1.clientX + touch2.clientX) / 2;
            const plotWidth = mainPanelRef.current.plotContainer.width();
            const cursorPos = dateAxisref.current.toAxisPosition(
              centerX / plotWidth,
            );

            const centerValue = start + (end - start) * cursorPos;
            const newStart = centerValue - newRange * cursorPos;
            const newEnd = centerValue + newRange * (1 - cursorPos);

            const clampedStart = Math.max(0, newStart);
            const clampedEnd = Math.min(1, newEnd);
            const finalRange = clampedEnd - clampedStart;

            // Apply zoom
            dateAxisref.current.setAll({
              start: clampedStart,
              end: clampedEnd,
            });

            // Adjust future spacing
            if (!isNextButtonVisible) {
              dateAxisref.current.set("extraMax", finalRange * 0.3);
            } else {
              dateAxisref.current.set("extraMax", 0);
            }

            e.preventDefault();
          }
        },
        { passive: false },
      );

      chartDiv.current.addEventListener("touchend", () => {
        if (momentumAnimFrame) {
          cancelAnimationFrame(momentumAnimFrame);
          momentumAnimFrame = null;
        }
        // const dragDuration = Date.now() - dragStartTime;
        // const speed = Math.abs(lastDeltaX) / Math.max(1, dragDuration);
        // if (Math.abs(lastDeltaX) > 20 && speed > 0.7) {
        //   const velocity = lastDeltaX * 0.0001;
        //   startMomentumPan(velocity);
        // }
        initialDistance = null;
        initialRange = null;
        computeVisibleHighLow();
      });
    };
    // Call this after your chart is initialized
    handleTouchEvents();
    // Value axis
    yAxisRef.current = mainPanelRef.current.yAxes.push(
      am5xy.ValueAxis.new(rootref.current, {
        renderer: am5xy.AxisRendererY.new(rootref.current, {
          pan: "none",
        }),
        tooltip: am5.Tooltip.new(rootref.current, {}),
        numberFormat: "#,###.00",
        extraTooltipPrecision: 2,
        extraMin: 0.1,
        extraMax: 0.1,
        strictMinMax: false,
      }),
    );

    // ✅ FIX: Make the Y-axis draw inside *and* allow candles to overlap
    yAxisRef.current.get("renderer").setAll({
      inside: true,
      drawOnAxis: false,
    });

    // Optional: Style the labels
    yAxisRef.current.get("renderer").labels.template.setAll({
      fill: am5.color(0xffffff),
      fillOpacity: 0.5,
      location: 1,
      centerX: am5.p100,
      dy: -10,
      // dx: -13,
    });
    // Existing styling
    yAxisRef.current.get("renderer").grid.template.setAll({
      stroke: am5.color(0xffffff),
      fontSize: 8,
    });

    yAxisRef.current.setAll({
      startLocation: 0,
      endLocation: 1,
      tooltipLocation: 0.5,
      zoomToCursor: true,
    });
    yAxisRef.current.get("renderer").labels.template.setAll({
      fill: am5.color(0xffffff),
      populateText: true, // Enables formatted text using numberFormat
      // fillOpacity: 1,
    });

    yAxisRef.current.setAll({
      numberFormat: "#,###.000", // Forces 3 decimal places
    });
    yAxisRef.current.get("renderer").grid.template.setAll({
      stroke: am5.color(0xffffff),
    });

    yAxisRef.current.setAll({
      startLocation: 0,
      endLocation: 1,
      tooltipLocation: 0.5,
      zoomToCursor: true,
    });

    // Date axis (X Axis)
    dateAxisref.current = mainPanelRef.current.xAxes.push(
      am5xy.GaplessDateAxis.new(rootref.current, {
        maxDeviation: 0,
        // minZoomCount: 10,
        // maxZoomCount: 350,
        // extraMax: 0.004,
        baseInterval: {
          timeUnit:
            tradestyleref.current === "3" ? "second" : candletimer?.type,
          count: 1,
        },
        timezoneOffset: 0,
        location: 0.5,
        renderer: am5xy.AxisRendererX.new(rootref.current, {
          pan: "none",
          minorGridEnabled: false,
          stroke: am5.color(0xffffff),
          groupData: true,
        }),
        tooltip: am5.Tooltip.new(rootref.current, {}),
      }),
    );

    let isDragging = false;
    let isZooming = false;
    let dragStartX = 0;
    let lastX = 0;
    let lastDeltaX = 0;
    let dragStartTime = 0;
    let momentumAnimFrame = null;

    // Pointer Down Handler (for general dragging)
    mainPanelRef.current.plotContainer.events.on("pointerdown", (ev) => {
      // Ignore if clicking on the next button (let button handler handle it)
      if (ev.originalEvent.target === nextButton) {
        return;
      }

      if (isZooming) return;

      // Standard drag initiation
      isDragging = true;
      dragStartX = ev.point.x;
      lastX = dragStartX;
      dragStartTime = Date.now();

      if (momentumAnimFrame) {
        cancelAnimationFrame(momentumAnimFrame);
        momentumAnimFrame = null;
      }

      lastDeltaX = 0;
      ev.originalEvent.preventDefault();
      computeVisibleHighLow();

      // Set future spacing based on button visibility state
      // if (dateAxisref.current) {
      //   const visibleRange =
      //     dateAxisref.current.get("end") - dateAxisref.current.get("start");
      //   const futureSpacingPercent = isNextButtonVisible ? 0.0 : 0.30;
      //   const futureSpacing = visibleRange * futureSpacingPercent;
      //   dateAxisref.current.set("extraMax", futureSpacing);
      //   console.log(
      //     `Set future spacing to ${
      //       futureSpacingPercent * 100
      //     }% based on button visibility`
      //   );
      // }
      if (!isNextButtonVisible && dateAxisref.current) {
        const visibleRange =
          dateAxisref.current.get("end") - dateAxisref.current.get("start");
        const futureSpacingPercent = isNextButtonVisible ? 0.0 : 0.3;
        const futureSpacing = visibleRange * futureSpacingPercent;
        console.log(
          `Set future spacing to ${
            futureSpacingPercent * 100
          }% based on button visibility`,
        );
        dateAxisref.current.set("extraMax", futureSpacing);
      }
    });

    mainPanelRef.current.plotContainer.events.on("globalpointerup", () => {
      if (isZooming) return; // Ignore drag end during zoom
      isDragging = false;

      const dragDuration = Date.now() - dragStartTime;
      const speed = Math.abs(lastDeltaX) / Math.max(1, dragDuration);

      // ✅ Only start momentum if it was fast enough
      if (Math.abs(lastDeltaX) > 30 && speed > 0.3) {
        const velocity = lastDeltaX * 0.000002;
        startMomentumPan(velocity);
      }

      lastDeltaX = 0;
      computeVisibleHighLow();
    });

    mainPanelRef.current.plotContainer.events.on("globalpointermove", (ev) => {
      if (!isDragging || isZooming) return; // Don't drag during zoom

      const currentX = ev.point.x;
      const deltaX = currentX - lastX; // ✅ only step difference
      lastX = currentX;

      if (Math.abs(deltaX) < 0.5) return; // ignore tiny jitters

      lastDeltaX = deltaX;

      // ✅ Apply per-step shift to current window
      const start = dateAxisref.current.get("start");
      const end = dateAxisref.current.get("end");
      const range = end - start;
      const shiftAmount = -deltaX * 0.000002; // adjust sensitivity as needed

      let newStart = start + shiftAmount;
      let newEnd = newStart + range;

      if (newEnd > 1) {
        newEnd = 1;
        newStart = newEnd - range;
      }
      if (newStart < 0) {
        newStart = 0;
        newEnd = newStart + range;
      }

      dateAxisref.current.setAll({
        start: newStart,
        end: newEnd,
      });

      computeVisibleHighLow();
    });

    function startMomentumPan(velocity) {
      const friction = 0.97;
      let start = dateAxisref.current.get("start");
      let end = dateAxisref.current.get("end");
      const range = end - start;

      if (momentumAnimFrame) {
        cancelAnimationFrame(momentumAnimFrame);
        momentumAnimFrame = null;
      }

      function animate() {
        start += -velocity;
        end = start + range;

        if (end > 1) {
          end = 1;
          start = end - range;
        }
        if (start < 0) {
          start = 0;
          end = start + range;
        }

        dateAxisref.current.setAll({ start, end });

        velocity *= friction;

        if (Math.abs(velocity) > 0.000002) {
          momentumAnimFrame = requestAnimationFrame(animate);
        } else {
          momentumAnimFrame = null;
        }
      }

      momentumAnimFrame = requestAnimationFrame(animate);
    }
    mainPanelRef.current.plotContainer.events.on("wheel", (ev) => {
      const dateAxis = dateAxisref.current;
      const valueSeries = valueSeriesref.current;
      const root = rootref.current;
      if (
        !mainPanelRef.current ||
        !dateAxis ||
        !valueSeries?.data?.values?.length >= 2
      )
        return;

      const data = valueSeries.data.values;
      if (isDragging) {
        isDragging = false;
        lastDeltaX = 0;
      }
      if (momentumAnimFrame) {
        cancelAnimationFrame(momentumAnimFrame);
        momentumAnimFrame = null;
      }

      isZooming = true;

      const start = dateAxis.get("start");
      const end = dateAxis.get("end");
      const visibleRange = end - start;
      const totalTime = data[data.length - 1].time - data[0].time;
      const candleTime = data[1].time - data[0].time;
      const visibleCandles = Math.round(
        (visibleRange * totalTime) / candleTime,
      );

      const rawDeltaX = ev.originalEvent.deltaX;
      const rawDeltaY = ev.originalEvent.deltaY;
      const absDeltaX = Math.abs(rawDeltaX);
      const absDeltaY = Math.abs(rawDeltaY);

      if (absDeltaY < 1) {
        isZooming = false;
        return;
      }
      if (absDeltaX > absDeltaY * 0.4) {
        ev.originalEvent.preventDefault();
        isZooming = false;
        return;
      }

      ev.originalEvent.preventDefault();
      const isZoomingOut = rawDeltaY > 0;
      const zoomFactor = 0.05 + Math.min(0.25, absDeltaY * 0.009);

      // ✅ Screen-size-based zoom limits
      const isLargeScreen = window.innerWidth > 2000;
      const minCandles = isLargeScreen ? 100 : 25;
      const maxCandles = isLargeScreen ? 540 : 175;

      // ✅ Enforce minimum zoom-in limit
      if (!isZoomingOut && visibleCandles <= minCandles) {
        isZooming = false;
        return;
      }

      // ✅ Enforce zoom-out limit
      const nextButtonVisible = nextButton.style.display === "block";
      if (isZoomingOut && visibleCandles >= maxCandles) {
        isZooming = false;
        return;
      }
      // 🔽 rest of your zoom code stays the same 🔽
      const plotWidth = mainPanelRef.current.plotContainer.width();
      const cursorX = ev.point?.x ?? plotWidth / 2;
      const cursorPos = dateAxis.toAxisPosition(cursorX / plotWidth);
      const targetTime = dateAxis.positionToValue(cursorPos);

      const range = end - start;
      const zoomStep = range * zoomFactor;

      let newStart = isZoomingOut
        ? start - zoomStep * cursorPos
        : start + zoomStep * cursorPos;
      let newEnd = isZoomingOut
        ? end + zoomStep * (1 - cursorPos)
        : end - zoomStep * (1 - cursorPos);

      newStart = Math.max(0, newStart);
      newEnd = Math.min(1, newEnd);

      if (isZoomingOut && newStart <= 0.0001 && newEnd >= 0.9999) {
        isZooming = false;
        return;
      }

      const futureSpacingPercent = 0.3;
      const newRange = newEnd - newStart;
      const futureSpacing = newRange * futureSpacingPercent;
      if (!isNextButtonVisible) {
        dateAxis.set("extraMax", futureSpacing);
      }

      const newCenterTime = dateAxis.positionToValue(
        newStart + (cursorX / plotWidth) * newRange,
      );
      const timeShift = targetTime - newCenterTime;
      const totalTimeRange = data[data.length - 1].time - data[0].time;
      const shiftPos = timeShift / totalTimeRange;
      newStart += shiftPos;
      newEnd += shiftPos;

      newStart = Math.max(0, Math.min(1 - newRange, newStart));
      newEnd = newStart + newRange;

      const zoomAnimation = dateAxis.zoom(newStart, newEnd, 500);
      if (zoomAnimation) {
        zoomAnimation.events.once("stopped", () => {});
      }

      root?.events.once("frameended", () => {
        checkIfAtRightEnd();
        checkIfNearLeftEdgeAndFetch();
        computeVisibleHighLow();
        isZooming = false;
      });

      const newZoomState = visibleCandles >= maxCandles;
      isFullyZoomedOutRef.current = newZoomState;
      setIsFullyZoomedOut(newZoomState);
    });
    const getVisibleCandleCount = () => {
      const data = valueSeriesref.current?.data?.values;
      if (!data || data.length < 2) return 0;

      const start = dateAxisref.current.get("start");
      const end = dateAxisref.current.get("end");
      const visibleRange = end - start;
      const totalTime = data[data.length - 1].time - data[0].time;
      const candleTime = data[1].time - data[0].time;

      return Math.round((visibleRange * totalTime) / candleTime);
    };
    const updatePinchZoom = () => {
      const visibleCandles = getVisibleCandleCount();
      const shouldEnablePinchZoom =
        visibleCandles >= 10 && visibleCandles <= 45;

      // Update StockChart & StockPanel settings
      // stockChartref.current?.set("pinchZoomX", shouldEnablePinchZoom);
      // mainPanelRef.current?.set("pinchZoomX", shouldEnablePinchZoom);
    };
    dateAxisref.current
      .get("renderer")
      .labels.template.adapters.add("text", (text, target) => {
        if (!text || typeof text !== "string" || !text.includes(":")) {
          return text; // fallback to original
        }

        const parts = text.split(":");
        let hours = parseInt(parts[0]);
        let minutes = parseInt(parts[1]);

        // Subtract 5 hours and 30 minutes to convert IST to UTC
        minutes += 0;
        hours += 0 + (minutes < 0 ? 1 : 0);
        minutes = (minutes + 60) % 60;
        hours = (hours + 24) % 24;

        // Format with leading zeros
        const newTime = `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;
        return newTime;
      });

    dateAxisref.current
      .get("renderer")
      .labels.template.adapters.add("text", (text, target) => {
        if (!text || typeof text !== "string" || !text.includes(":")) {
          return text; // fallback
        }

        const parts = text.split(":");
        let hours = parseInt(parts[0]);
        let minutes = parseInt(parts[1]);

        let offsetHours = parseInt(updatetimezone?.haur || "0");
        let offsetMinutes = parseInt(updatetimezone?.minute || "0");

        if (updatetimezone?.plus === "+") {
          minutes += offsetMinutes;
          hours += offsetHours;
        } else {
          minutes -= offsetMinutes;
          hours -= offsetHours;
        }

        // Normalize minutes and adjust hours accordingly
        if (minutes >= 60) {
          hours += Math.floor(minutes / 60);
          minutes = minutes % 60;
        } else if (minutes < 0) {
          let m = Math.ceil(Math.abs(minutes) / 60);
          hours -= m;
          minutes = (minutes + 60) % 60;
        }

        // Normalize hours
        hours = (hours + 24) % 24;

        // Format with leading zeros
        const newTime = `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}`;

        return newTime;
      });

    dateAxisref.current.get("renderer").labels.template.setAll({
      fill: am5.color(0xffffff),
    });

    dateAxisref.current.setAll({
      zoomToCursor: true,
      startLocation: 0,
      endLocation: 1,
    });

    dateAxisref.current.get("renderer").grid.template.setAll({
      stroke: am5.color(0xffffff),
      minGridDistance: 30,
    });

    dateAxisref.current.get("renderer").setAll({
      paddingRight: 0,
    });

    dateAxisref.current.setAll({
      extraMax: 0,
    });

    yAxisRef.current.get("renderer").setAll({
      minGridDistance: 100,
    });
    // Assuming you have your axis instance

    // Series setup
    const seriesOptions = {
      name: "BTC-USD",
      valueXField: "time",
      valueYField: "close",
      xAxis: dateAxisref.current,
      yAxis: yAxisRef.current,
      legendRangeValueText: "",
      clustered: false,
    };
    switch (tradestyleref.current) {
      case "1":
      case "5":
        valueSeriesref.current = mainPanelRef.current.series.push(
          am5xy.CandlestickSeries.new(rootref.current, {
            ...seriesOptions,
            highValueYField: "high",
            lowValueYField: "low",
            openValueYField: "open",
            locationX: 0.5,
          }),
        );
        break;

      case "2":
        valueSeriesref.current = mainPanelRef.current.series.push(
          am5xy.OHLCSeries.new(rootref.current, {
            ...seriesOptions,
            openValueYField: "open",
            highValueYField: "high",
            lowValueYField: "low",
          }),
        );
        break;

      case "3":
        valueSeriesref.current = mainPanelRef.current.series.push(
          am5xy.LineSeries.new(rootref.current, {
            ...seriesOptions,
            stroke: am5.color(0x00ff00),
            fill: am5.color(0x00ff00),
          }),
        );
        break;
    }
    if (!valueSeriesref.current) {
      return;
    }
    valueSeriesref.current.set("layer", 9);
    const isTouchDevice = () => {
      return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    };

    // 1. Initialize currentValueDataItemref for both touch and non-touch devices
    currentValueDataItemref.current = yAxisRef.current.createAxisRange(
      yAxisRef.current.makeDataItem({ value: 0 }),
    );

    // 2. Cursor and tooltips only for non-touch devices
    if (!isTouchDevice()) {
      const cursor = mainPanelRef.current.set(
        "cursor",
        am5xy.XYCursor.new(rootref.current, {
          behavior: "none",
          xAxis: dateAxisref.current,
          yAxis: yAxisRef.current,
          layer: 99,
          visible: true,
        }),
      );

      cursor.lineX.setAll({
        stroke: am5.color(0xcccccc),
        strokeWidth: 0.5,
        strokeOpacity: 1,
        strokeDasharray: [5, 5],
      });

      cursor.lineY.setAll({
        visible: true,
        stroke: am5.color(0xcccccc),
        strokeWidth: 0.5,
        strokeOpacity: 1,
        strokeDasharray: [5, 5],
      });

      const yAxisTooltip = yAxisRef.current.get("tooltip");
      if (yAxisTooltip) {
        yAxisTooltip.set("layer", 999);
        yAxisTooltip.label.setAll({
          layer: 999,
          fill: am5.color(0x000000),
          fontSize: 12,
          paddingLeft: 1,
          paddingRight: 1,
          paddingTop: 1,
          paddingBottom: 1,
        });
        yAxisTooltip.get("background").setAll({
          layer: 999,
          fill: am5.color(0x474451),
          fillOpacity: 1,
          stroke: am5.color(0x474451),
          strokeWidth: 1,
          strokeOpacity: 1,
          cornerRadius: 3,
        });
      }

      // Apply chart settings for non-touch
      stockChartref.current.set("stockSeries", valueSeriesref.current);
      stockChartref.current.setAll({
        paddingLeft: 0,
        paddingRight: 0,
      });
    }

    // 3. High/Low Labels for both touch and non-touch devices
    if (currentValueDataItemref.current) {
      createHighLowLabels();
      currentLabelref.current = currentValueDataItemref.current.get("label");

      if (currentLabelref.current) {
        const label = currentLabelref.current;

        label.adapters.remove("fill");
        label.adapters.remove("background.fill");
        label.adapters.remove("background.stroke");

        label.set(
          "background",
          am5.Rectangle.new(rootref.current, {
            fill: am5.color(0x000000),
            fillOpacity: 1,
            strokeOpacity: 0,
            cornerRadius: 3,
          }),
        );

        const bg = label.get("background");
        if (bg) {
          bg.adapters.remove("fill");
          bg.adapters.remove("stroke");
          bg.setAll({
            fill: am5.color(0x000000),
            fillOpacity: 1,
            strokeOpacity: 0,
          });
        }

        label.setAll({
          fill: am5.color(0xffffff),
          centerX: am5.p100,
          x: am5.p100,
          // dx: -10,
          paddingLeft: 6,
          paddingRight: 6,
          paddingTop: 3,
          paddingBottom: 3,
          layer: 200,
        });
      }

      const currentGrid = currentValueDataItemref.current.get("grid");
      if (currentGrid) {
        currentGrid.setAll({
          strokeOpacity: 0.3,
          strokeDasharray: [],
          stroke: am5.color(0xffffff),
          layer: 200,
        });
      }
    }

    mainPanelRef.current.setAll({
      paddingLeft: 0,
      paddingRight: 0,
    });

    dateAxisref.current.get("renderer").setAll({
      paddingRight: 0,
    });

    dateAxisref.current.setAll({
      extraMax: 0,
    });

    rootref.current.events.once("frameended", () => {
      setTimeout(() => {
        if (!stockChartref.current || !rootref.current) return;

        const customIndicatorIcon = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg",
        );
        customIndicatorIcon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        customIndicatorIcon.setAttribute("viewBox", "0 0 24 24");
        customIndicatorIcon.setAttribute("width", "18");
        customIndicatorIcon.setAttribute("height", "18");
        customIndicatorIcon.innerHTML = `
<path
d="M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071Z"
fill="white"
/>
`;
        // am5stock.StockToolbar.new(rootref.current, {
        //   container: document.getElementById("chartcontrols"),
        //   stockChart: stockChartref.current,
        //   controls: [
        //     am5stock.IndicatorControl.new(rootref.current, {
        //       stockChart: stockChartref.current,
        //       indicatorTypes: ["MovingAverage", "RSI", "MACD"],
        //       icon: customIndicatorIcon,
        //     }),
        //   ],
        // });
        setTimeout(() => {
          computeVisibleHighLow();
        }, 300);
      }, 200);
    });
    drawingcontrolref.current = am5stock.DrawingControl.new(rootref.current, {
      stockChart: stockChartref.current,
    });

    let isNextButtonVisible = false;
    let isNextButtonClicked = false;
    const nextButton = document.createElement("button");
    nextButton.innerHTML = "&#8250;";
    // Button styling (unchanged)
    nextButton.style.position = "absolute";
    nextButton.style.top = "50%";
    nextButton.style.transform = "translateY(-50%)";
    nextButton.style.right = "-3px";
    nextButton.style.zIndex = 1000;
    nextButton.style.width = "40px";
    nextButton.style.height = "70px";
    nextButton.style.background = "rgba(0, 0, 0, 0.6)";
    nextButton.style.color = "#fff";
    nextButton.style.fontSize = "40px";
    nextButton.style.border = "none";
    nextButton.style.borderRadius = "5px";
    nextButton.style.cursor = "pointer";
    nextButton.style.display = "none";
    nextButton.style.alignItems = "center";
    nextButton.style.justifyContent = "center";

    chartDiv.current.style.position = "relative";
    chartDiv.current.appendChild(nextButton);

    // Check visibility every frame
    rootref.current.events.on("frameended", checkIfAtRightEnd);

    function checkIfAtRightEnd() {
      const data = valueSeriesref.current?.data?._values;
      if (!data || data.length === 0) {
        nextButton.style.display = "none";
        isNextButtonVisible = false;
        return;
      }

      const lastCandleTime = data[data.length - 1].time;
      const lastPos = dateAxisref.current.valueToPosition(lastCandleTime);
      const viewEnd = dateAxisref.current.get("end");

      const shouldShow = lastPos > viewEnd + 0.0001;
      nextButton.style.display = shouldShow ? "flex" : "none";

      const isActuallyVisible =
        window.getComputedStyle(nextButton).display !== "none";
      isNextButtonVisible = isActuallyVisible;
    }
    function checkIfNearLeftEdgeAndFetch() {
      const data = valueSeriesref.current?.data?._values;
      const dateAxis = dateAxisref.current;
      if (!data || data.length < 2 || !dateAxis) return;
      const start = dateAxis.get("start");
      const firstVisibleTime = dateAxis.positionToValue(start);
      const firstDataTime = data[0].time;
      const candleTime = data[1].time - data[0].time;

      const visibleCandlesToLeftEdge = Math.floor(
        (firstVisibleTime - firstDataTime) / candleTime,
      );

      const isNearStart = visibleCandlesToLeftEdge <= 30; // ✅ Trigger when only 50 candles left

      if (isNearStart && !isLoadingHistoricalData) {
        console.log(
          "⏳ Near left edge (~50 candles left) — preloading history...",
        );

        isLoadingHistoricalData = true;

        // 🔁 Same logic for increasing future space
        const increaseExtraMaxZeros = () => {
          panTriggerCount += 1;
          if (panTriggerCount % 3 === 0) {
            extraZeroCount += 1;
          }
          const newExtraMax = 0.009 / Math.pow(10, extraZeroCount);
          dateAxis.set("extraMax", newExtraMax);
        };

        const isOtc = chnagetyperef.current?.csymbol === "OTC";

        if (!isFetchingHistory) {
          if (isOtc) {
            otcbackdata(firstDataTime).finally(() => {
              isLoadingHistoricalData = false;
              increaseExtraMaxZeros();
              console.log("✅ OTC history loaded.");
            });
          } else {
            onScrollToFirstData(firstDataTime).finally(() => {
              isLoadingHistoricalData = false;
              increaseExtraMaxZeros();
              console.log("✅ Other history loaded.");
            });
          }
        }

        if (isFetchingOtcHistory && isOtc) {
          otcbackdata(firstDataTime).finally(() => {
            isLoadingHistoricalData = false;
            console.log("🔓 Pan lock OFF (isFetchingOtcHistory path).");
          });
          console.log("⚡ this_is_first_console (isFetchingOtcHistory)");
        }
      }
    }
    let isLoadingHistoricalData = false;

    let extraZeroCount = 0;
    let panTriggerCount = 0;

    mainPanelRef.current.events.on("panended", function () {
      console.log("✅ panended_code");

      // Block if already loading
      if (isLoadingHistoricalData) {
        console.log("⏸️ Already loading, ignoring pan.");
        return;
      }

      const xStart = dateAxisref.current.get("start");
      const xEnd = dateAxisref.current.get("end");

      if (xStart < 0) {
        const range = xEnd - xStart;
        dateAxisref.current.setAll({
          start: 0,
          end: range,
        });

        const data = valueSeriesref.current.data;
        const firstDataTime = data?._values?.[0]?.time;

        // Lock loading flag
        isLoadingHistoricalData = true;

        // Helper to increment extraMax every second time
        const increaseExtraMaxZeros = () => {
          panTriggerCount += 1;

          // Only increase zeros every second trigger
          if (panTriggerCount % 3 === 0) {
            extraZeroCount += 1;
          }

          const newExtraMax = 0.009 / Math.pow(10, extraZeroCount);
          dateAxisref.current.set("extraMax", newExtraMax);
          console.log(
            `🌟 panTriggerCount: ${panTriggerCount}, extraZeroCount: ${extraZeroCount}, extraMax: ${newExtraMax}`,
          );
        };

        // Load history
        if (!isFetchingHistory) {
          if (chnagetyperef.current?.csymbol === "OTC") {
            otcbackdata(firstDataTime).finally(() => {
              isLoadingHistoricalData = false;
              increaseExtraMaxZeros();
              console.log("✅ OTC history loaded.");
            });
          } else {
            onScrollToFirstData(firstDataTime).finally(() => {
              isLoadingHistoricalData = false;
              increaseExtraMaxZeros();
              console.log("✅ Other history loaded.");
            });
          }
        }

        // Also handle if isFetchingOtcHistory was true
        if (isFetchingOtcHistory) {
          if (chnagetyperef.current?.csymbol === "OTC") {
            otcbackdata(firstDataTime).finally(() => {
              isLoadingHistoricalData = false;
              console.log("🔓 Pan lock OFF (isFetchingOtcHistory path).");
            });
            console.log("⚡ this_is_first_console (isFetchingOtcHistory)");
          }
        }
      }
    });
    // listeners
    mainPanelRef.current.events.on("panended", () => {
      // updatePinchZoom();
      computeVisibleHighLow();
      checkIfAtRightEnd();
      checkIfNearLeftEdgeAndFetch();
    });

    dateAxisref.current.events.on("rangechanged", () => {
      computeVisibleHighLow();
      checkIfAtRightEnd();
      checkIfNearLeftEdgeAndFetch();
    });

    // After your series creation
    // valueSeriesref.current.events.once("datavalidated", () => {
    //   rootref.current.events.once("frameended", () => {
    //     setTimeout(() => {
    //       computeVisibleHighLow();
    //     }, 100);
    //   });
    // });

    // valueSeriesref.current.events.once("datavalidated", () => {
    //   rootref.current.events.once("frameended", () => {
    //     setTimeout(() => {
    //       computeVisibleHighLow();

    //       // Start repeating every 3 seconds
    //       setInterval(() => {
    //         computeVisibleHighLow();
    //       }, 1000);
    //     }, 100);
    //   });
    // });

    let isUserZoomed = false; // 🚩 flag to track manual wheel zoom

    function applyZoomSettings(force = false) {
      updatePinchZoom();
      // ✅ If user already zoomed manually, block resize-triggered zoom
      if (!force && isUserZoomed) return;

      const width = window.innerWidth;

      let visibleCount;
      let extraMaxValue;

      if (width > 2700) {
        visibleCount = 100;
        extraMaxValue = isNextButtonClicked ? 0.12 : 0.12;
      } else if (width > 2000) {
        visibleCount = 80;
        extraMaxValue = isNextButtonClicked ? 0.12 : 0.12;
      } else if (width > 1800) {
        visibleCount = 50;
        extraMaxValue = isNextButtonClicked ? 0.09 : 0.09;
      } else if (width > 1500) {
        visibleCount = 30;
        extraMaxValue = isNextButtonClicked ? 0.05 : 0.05;
      } else if (width > 850 && width < 1000) {
        visibleCount = 50;
        extraMaxValue = isNextButtonClicked ? 0.07 : 0.07;
      } else if (width > 500 && width < 850) {
        visibleCount = 50;
        extraMaxValue = isNextButtonClicked ? 0.07 : 0.07;
      } else {
        visibleCount = 20;
        extraMaxValue = isNextButtonClicked ? 0.022 : 0.022;
      }

      // ✅ Apply directly to amCharts
      if (dateAxisref.current) {
        dateAxisref.current.setAll({
          extraMax: extraMaxValue,
          maxDeviation: 0,
        });

        const data = valueSeriesref.current?.data?.values;
        if (data && data.length > 10) {
          const totalCount = data.length;
          let end = 1;
          let start = (totalCount - visibleCount) / totalCount;

          if (start < 0) start = 0;
          if (start > 1) start = 0;

          dateAxisref.current.setAll({ start, end });
        }
      }
    }

    isNextButtonClicked = false;

    setInterval(() => {
      computeVisibleHighLow();
    }, 1000);
    function getPrecisionFromData(data) {
      let maxDecimals = 0;

      // calculate max decimals from OHLC
      data.forEach((d) => {
        ["open", "high", "low", "close"].forEach((k) => {
          const v = d[k];
          if (v !== undefined && v !== null) {
            const s = v.toString();
            if (s.includes(".")) {
              maxDecimals = Math.max(maxDecimals, s.split(".")[1].length);
            }
          }
        });
      });

      // calculate close gap (difference between last two closes)
      let closeGap = 0;
      if (data.length > 1) {
        const lastClose = Number(data[data.length - 1].close);
        const prevClose = Number(data[data.length - 2].close);
        closeGap = Math.abs(lastClose - prevClose);
        console.log(closeGap, "closeGap");
      }

      // precision rule
      if (closeGap > 1) {
        maxDecimals = 3;
      }

      return Math.min(maxDecimals, 8); // normal precision (≤ 1 gap)
    }

    function buildNumberFormat(decimals) {
      return decimals > 0 ? `#,###.${"0".repeat(decimals)}` : "#,###";
    }

    valueSeriesref.current.events.once("datavalidated", () => {
      rootref.current.events.once("frameended", () => {
        setTimeout(() => {
          applyZoomSettings(true); // force on first load
        }, 100);
      });
    });
    valueSeriesref.current.events.once("datavalidated", () => {
      const data = valueSeriesref.current.data.values;
      if (!data?.length) return;

      const precision = getPrecisionFromData(data);

      yAxisRef.current.setAll({
        numberFormat: buildNumberFormat(precision),
        extraTooltipPrecision: precision,
      });
      rootref.current.numberFormatter.set(
        "numberFormat",
        buildNumberFormat(precision),
      );
    });
    // ✅ Re-apply settings on window resize (only if user not zoomed)
    window.addEventListener("resize", () => applyZoomSettings());

    // ✅ Detect manual wheel zoom → lock default zoom
    mainPanelRef.current.plotContainer.events.on("wheel", () => {
      isUserZoomed = true; // user manually zoomed → stop overriding on resize
    });

    // Clicking Next zooms to latest candles
    nextButton.addEventListener("click", (ev) => {
      ev.stopPropagation();

      if (!dateAxisref.current) return;

      isNextButtonClicked = true;

      // Stop momentum animation if running
      if (momentumAnimFrame) {
        cancelAnimationFrame(momentumAnimFrame);
        momentumAnimFrame = null;
      }

      // ----------------------------------------------------
      // ❌ Disable animations for chart & axes
      // ----------------------------------------------------
      if (chartRef.current) chartRef.current.appear(0, 0);

      if (dateAxisref.current)
        dateAxisref.current.set("interpolationDuration", 0);

      if (yAxisRef.current) yAxisRef.current.set("interpolationDuration", 0);

      // ----------------------------------------------------
      // ⭐ KEEP candle animation ENABLED
      // ----------------------------------------------------
      if (valueSeriesref.current) {
        valueSeriesref.current.set("interpolationDuration", 500); // candle animation time
        valueSeriesref.current.appear(500); // animate series only
      }

      // ----------------------------------------------------
      // ⚡ Instantly zoom to latest candles
      // ----------------------------------------------------
      const visibleRange =
        dateAxisref.current.get("end") - dateAxisref.current.get("start");

      dateAxisref.current.zoom(1 - visibleRange, 1, 0);

      // ----------------------------------------------------
      // ➕ Add future spacing
      // ----------------------------------------------------
      const futureSpacingPercent = 0.3;
      const futureSpacing = visibleRange * futureSpacingPercent;
      dateAxisref.current.set("extraMax", futureSpacing);

      // ----------------------------------------------------
      // 🙈 Hide button
      // ----------------------------------------------------
      nextButton.style.display = "none";
      isNextButtonVisible = false;

      isNextButtonClicked = false;
    });

    if (tradestyleref.current !== "3") {
      valueSeriesref.current.columns.template.setAll({
        width: am5.percent(90),
      });
    }

    // Fetch initial data
    if (chnagetyperef.current?.csymbol === "OTC") {
      fatchotcdata(tradestyle, candletimer);
      computeVisibleHighLow();
      createHighLowAnnotationSeries();
    } else {
      // fetchInitialData();
      fetchKlineData();
      computeVisibleHighLow();
      createHighLowAnnotationSeries();
    }

    isReadyRef.current = true;
  };

  // <---------- showing the code of the heighest and lowest candles (starting )------------>
  function createHighLowLabels() {
    if (!rootref.current || !yAxisRef.current) return;

    // Highest wick label
    highestRangeRef.current = yAxisRef.current.createAxisRange(
      yAxisRef.current.makeDataItem({ value: 0 }),
    );

    const highestLabel = am5.Label.new(rootref.current, {
      text: "",
      isMeasured: false,
      background: am5.RoundedRectangle.new(rootref.current, {
        fill: am5.color(0x00ff00),
        cornerRadiusTL: 5,
        cornerRadiusTR: 5,
        cornerRadiusBL: 5,
        cornerRadiusBR: 5,
      }),
      fill: am5.color(0x000000),
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 2,
      paddingBottom: 2,
      centerY: am5.p50,
      centerX: am5.p100,
      fontSize: 12,
      fillOpacity: 0.5,
    });

    highestRangeRef.current.set("label", highestLabel);

    // Lowest wick label
    lowestRangeRef.current = yAxisRef.current.createAxisRange(
      yAxisRef.current.makeDataItem({ value: 0 }),
    );

    const lowestLabel = am5.Label.new(rootref.current, {
      text: "",
      isMeasured: false,
      background: am5.RoundedRectangle.new(rootref.current, {
        fill: am5.color(0xff0000),
        cornerRadiusTL: 5,
        cornerRadiusTR: 5,
        cornerRadiusBL: 5,
        cornerRadiusBR: 5,
      }),
      fill: am5.color(0xffffff),
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 2,
      paddingBottom: 2,
      centerY: am5.p50,
      centerX: am5.p100,
      fontSize: 12,
    });

    lowestRangeRef.current.set("label", lowestLabel);
  }

  function createHighLowAnnotationSeries() {
    if (!rootref.current || !mainPanelRef.current) {
      return;
    }

    // Clean up existing series if any
    if (highLowAnnotationSeriesRef.current) {
      mainPanelRef.current.series.removeValue(
        highLowAnnotationSeriesRef.current,
      );
    }

    // Create new annotation series
    highLowAnnotationSeriesRef.current = mainPanelRef.current.series.push(
      am5xy.LineSeries.new(rootref.current, {
        name: "High/Low Markers",
        xAxis: dateAxisref.current,
        yAxis: yAxisRef.current,
        valueXField: "time",
        valueYField: "price",
        stroke: undefined, // Remove line stroke
        strokeWidth: 0, // Set stroke width to 0
        visible: false,
        // ✅ These properties prevent zig-zag
        connect: false,
        tension: 0,
        autoGapCount: 0,
        minDistance: 0,
      }),
    );

    // Add bullets for markers with custom labels
    highLowAnnotationSeriesRef.current.bullets.push(
      function (root, series, dataItem) {
        // Create container
        const container = am5.Container.new(root, {});

        // Create label
        const label = am5.Label.new(root, {
          text: "{customText}",
          fill: am5.color(0xffffff),
          background: am5.RoundedRectangle.new(root, {
            // fill: am5.color(0x333333), // Light black background (#333)
            cornerRadius: 5,
            // stroke: am5.color(0x555555), // Optional: slightly darker border
            strokeWidth: 1,
          }),
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 4,
          paddingBottom: 4,
          centerX: am5.p0,
          y: am5.p50,
          dy: dataItem.dataContext?.isHigh ? -33 : -5, // Move high up, low down
          // centerY: am5.p50,
          fillOpacity: 0.5,
        });

        // Add data binding for custom text
        label.adapters.add("text", function (text, target) {
          const dataContext = dataItem.dataContext;
          if (dataContext) {
            return dataContext.customText || "";
          }
          return text;
        });

        // Add data binding for background color
        label.get("background").adapters.add("fill", function (fill, target) {
          const dataContext = dataItem.dataContext;
          if (dataContext && dataContext.bgColor) {
            return dataContext.bgColor;
          }
          return fill;
        });

        container.children.push(label);
        return am5.Bullet.new(root, {
          sprite: container,
        });
      },
    );
  }

  function clearHighLowAnnotations() {
    if (highLowAnnotationSeriesRef.current) {
      highLowAnnotationSeriesRef.current.data.clear();
    }
  }

  function computeVisibleHighLow() {
    try {
      if (!["1", "2", "5"].includes(tradestyleref.current)) {
        clearHighLowAnnotations();
        return;
      }

      // Validate required references
      const requiredRefs = [
        { ref: rootref.current, name: "rootref" },
        { ref: dateAxisref.current, name: "dateAxisref" },
        { ref: valueSeriesref.current, name: "valueSeriesref" },
        { ref: valueSeriesref.current?.data, name: "valueSeriesref.data" },
      ];
      for (const { ref } of requiredRefs) {
        if (!ref) return;
      }

      // Ensure annotation series exists
      if (!highLowAnnotationSeriesRef.current) {
        createHighLowAnnotationSeries();
        if (!highLowAnnotationSeriesRef.current) return;
      }

      // Get visible range
      const start = dateAxisref.current.get("start");
      const end = dateAxisref.current.get("end");
      if (start == null || end == null) return;

      // Get series data
      const data = valueSeriesref.current.data._values;
      if (!data || data.length === 0) {
        clearHighLowAnnotations();
        return;
      }

      // Get field mappings
      const xField = valueSeriesref.current.get("valueXField");
      const highField = valueSeriesref.current.get("highValueYField");
      const lowField = valueSeriesref.current.get("lowValueYField");
      if (!highField || !lowField) return;

      // Filter to visible data
      const visibleData = data.filter((item) => {
        const xValue = item[xField];
        const pos = dateAxisref.current.valueToPosition(xValue);
        return pos >= start && pos <= end;
      });

      if (visibleData.length === 0) {
        clearHighLowAnnotations();
        return;
      }

      // Find extremes
      let highest = -Infinity;
      let lowest = Infinity;
      let highestItem = null;
      let lowestItem = null;

      for (const item of visibleData) {
        const high = item[highField];
        const low = item[lowField];

        if (high > highest) {
          highest = high;
          highestItem = item;
        }
        if (low < lowest) {
          lowest = low;
          lowestItem = item;
        }
      }

      if (!highestItem || !lowestItem) {
        clearHighLowAnnotations();
        return;
      }

      // Format values
      const formattedHigh = rootref.current.numberFormatter.format(highest);
      const formattedLow = rootref.current.numberFormatter.format(lowest);

      // Device responsive padding
      const deviceWidth = window.innerWidth;
      let newMin, newMax;

      if (deviceWidth < 800) {
        // 📱 Mobile: push highest point more towards top
        const bottomPadding = (highest - lowest) * 0.42; // very little bottom padding
        const topPadding = (highest - lowest) * -0.05; // more top padding
        newMin = lowest - bottomPadding;
        newMax = highest + topPadding; // shift highest more up
      } else {
        // 💻 Desktop: balanced top & bottom padding
        const bottomPadding = (highest - lowest) * 0.003;
        const topPadding = (highest - lowest) * -0.009;
        newMin = lowest - bottomPadding;
        newMax = highest + topPadding;
      }

      // Update annotation markers
      highLowAnnotationSeriesRef.current.data.setAll([
        {
          time: highestItem[xField],
          price: highest, // stick label at high point
          customText: formattedHigh,
          isHigh: true,
        },
        {
          time: lowestItem[xField],
          price: lowest, // stick label at low point
          customText: formattedLow,
          isHigh: false,
        },
      ]);

      // Update y-axis range
      yAxisRef.current.setAll({
        min: newMin,
        max: newMax,
        strictMinMax: true,
      });

      // Animate axis for smoothness
      yAxisRef.current.animate({
        key: "min",
        to: newMin,
        duration: 600,
        easing: am5.ease.out(am5.ease.cubic),
      });
      yAxisRef.current.animate({
        key: "max",
        to: newMax,
        duration: 600,
        easing: am5.ease.out(am5.ease.cubic),
      });

      // Show annotations on top
      highLowAnnotationSeriesRef.current.show();
      highLowAnnotationSeriesRef.current.toFront();
    } catch (error) {
      console.error("Error in computeVisibleHighLow:", error);
    }
  }

  const handleHoverFromChild = (type) => {
    // setHoverType(type);
    // Here you can also immediately call chart code:
    if (type === "buy") showBuyArrow();
    else if (type === "sell") showSellArrow();
    else clearArrow();
  };
  const isTouchDevice = () => {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
  };

  const ensureHoverAnnotationSeries = () => {
    if (isTouchDevice()) return;
    if (hoverAnnotationSeriesRef.current) return;

    hoverAnnotationSeriesRef.current = mainPanelRef.current.series.push(
      am5xy.LineSeries.new(rootref.current, {
        name: "Hover Marker",
        xAxis: dateAxisref.current,
        yAxis: yAxisRef.current,
        valueXField: "time",
        valueYField: "price",
        stroke: undefined,
        strokeWidth: 0,
        visible: true,
      }),
    );

    hoverAnnotationSeriesRef.current.bullets.push((root, series, dataItem) => {
      return am5.Bullet.new(root, {
        sprite: am5.Label.new(root, {
          text: "",
          fill: am5.color(0xffffff),
          fontSize: 40,
          centerY: am5.p50,
          centerX: am5.p50,
        }),
      });
    });
  };

  const ensureHoverBackgroundRange = () => {
    if (isTouchDevice()) return;
    if (!hoverBackgroundRangeRef.current) {
      const range = yAxisRef.current.makeDataItem({
        value: 0,
        endValue: 0,
      });
      if (!range) return;
      hoverBackgroundRangeRef.current = range;
      yAxisRef.current.createAxisRange(range);
      range.get("grid").set("visible", false);
      range.get("label").set("visible", false);

      range.get("axisFill").setAll({
        fillOpacity: 0.2,
        visible: true,
        fill: am5.color("rgba(155, 185, 155, 0.3)"), // default green
      });
    }
  };

  const updateHoverBackgroundRange = (price) => {
    if (isTouchDevice()) return;
    if (!activeHoverTypeRef.current) return;
    if (!hoverBackgroundRangeRef.current) ensureHoverBackgroundRange();

    const yMin = yAxisRef.current.getPrivate("min");
    const yMax = yAxisRef.current.getPrivate("max");

    if (activeHoverTypeRef.current === "buy") {
      hoverBackgroundRangeRef.current.set("value", price);
      hoverBackgroundRangeRef.current.set("endValue", yMax);
      hoverBackgroundRangeRef.current
        .get("axisFill")
        .set("fill", am5.color("rgba(50, 80, 50, 0.5)"));

      // Add buy arrow
      if (hoverAnnotationSeriesRef.current) {
        hoverAnnotationSeriesRef.current.bullets.clear();
        hoverAnnotationSeriesRef.current.bullets.push(
          (root, series, dataItem) => {
            const arrowContainer = am5.Container.new(root, {
              layout: root.verticalLayout,
              centerX: am5.p0,
              centerY: am5.p0,
              width: 50,
              height: 40,
              dy: -40, // Position above the line
              dx: 80,
              paddingTop: 8,
              paddingBottom: 8,
              paddingLeft: 12,
              paddingRight: 12,
            });

            const arrowLabel = am5.Picture.new(root, {
              // text: "↗",
              src: arrowgreen,
              // fontSize: 40,
              // fontWeight: 900,
              // fill: am5.color(0x007a00),
              centerX: am5.p50,
              centerY: am5.p50,
            });

            arrowContainer.children.push(arrowLabel);

            return am5.Bullet.new(root, {
              locationX: 0.5,
              locationY: 0.5,
              sprite: arrowContainer,
              value: price,
              field: "value",
              dy: 80,
            });
          },
        );
      }
    } else if (activeHoverTypeRef.current === "sell") {
      hoverBackgroundRangeRef.current.set("value", yMin);
      hoverBackgroundRangeRef.current.set("endValue", price);
      hoverBackgroundRangeRef.current
        .get("axisFill")
        .set("fill", am5.color("rgba(58,28,28,0.5)"));

      // Add sell arrow
      if (hoverAnnotationSeriesRef.current) {
        hoverAnnotationSeriesRef.current.bullets.clear();
        hoverAnnotationSeriesRef.current.bullets.push(
          (root, series, dataItem) => {
            const arrowContainer = am5.Container.new(root, {
              layout: root.verticalLayout,
              centerX: am5.p0,
              centerY: am5.p0,
              width: 10,
              height: 10,
              dy: -10, // Position above the line
              dx: 80,
              paddingTop: 8,
              paddingBottom: 8,
              paddingLeft: 12,
              paddingRight: 12,
            });

            const arrowLabel = am5.Picture.new(root, {
              // text: "↘",
              src: redarrow,
              fontSize: 40,
              fontWeight: 900,
              fill: am5.color(0x990000),
              centerX: am5.p50,
              centerY: am5.p50,
            });

            arrowContainer.children.push(arrowLabel);

            return am5.Bullet.new(root, {
              locationX: 0.5,
              locationY: 0.5,
              sprite: arrowContainer,
              value: price,
              field: "value",
              dy: 60,
            });
          },
        );
      }
    }

    hoverBackgroundRangeRef.current.get("axisFill").set("visible", true);

    // Update the series data to show the arrow
    if (hoverAnnotationSeriesRef.current) {
      const data = valueSeriesref.current?.data?._values;
      if (data && data.length) {
        const lastCandle = data[data.length - 1];
        if (lastCandle) {
          hoverAnnotationSeriesRef.current.data.setAll([
            {
              time: lastCandle.time,
              price: price,
            },
          ]);
          hoverAnnotationSeriesRef.current.show();
        }
      }
    }
  };

  // 4️⃣ Helper: Set marker position
  const setMarkerPosition = (price) => {
    if (!activeHoverTypeRef.current) return;

    if (!hoverAnnotationSeriesRef.current) return;

    const data = valueSeriesref.current?.data?._values;
    if (!data || !data.length) return;

    const lastCandle = data[data.length - 1];
    if (!lastCandle) return;

    const time = lastCandle.time;

    // ✅ update arrow position
    hoverAnnotationSeriesRef.current.data.setAll([{ time, price }]);
    hoverAnnotationSeriesRef.current.show();

    // ✅ update background range
    updateHoverBackgroundRange(price);
  };

  // 5️⃣ Place marker immediately on buy/sell click
  const placeInitialMarker = () => {
    if (lastPrice?.close != null) {
      setMarkerPosition(lastPrice.close);
    }
  };

  // 6️⃣ User clicks BUY
  const showBuyArrow = () => {
    if (!mainPanelRef.current || !dateAxisref.current || !yAxisRef.current)
      return;
    activeHoverTypeRef.current = "buy";
    ensureHoverAnnotationSeries();
    placeInitialMarker();
    if (buyOverlayRef.current) buyOverlayRef.current.set("visible", true);
    if (sellOverlayRef.current) sellOverlayRef.current.set("visible", false);
  };

  // 7️⃣ User clicks SELL
  const showSellArrow = () => {
    if (!mainPanelRef.current || !dateAxisref.current || !yAxisRef.current)
      return;
    activeHoverTypeRef.current = "sell";
    ensureHoverAnnotationSeries();
    placeInitialMarker();
    if (sellOverlayRef.current) sellOverlayRef.current.set("visible", true);
    if (buyOverlayRef.current) buyOverlayRef.current.set("visible", false);
  };

  // 8️⃣ User clears
  const clearArrow = () => {
    activeHoverTypeRef.current = null;

    // Instead of clearing all bullets, only clear the hover-related ones
    if (hoverAnnotationSeriesRef.current) {
      hoverAnnotationSeriesRef.current.data.clear();
      hoverAnnotationSeriesRef.current.bullets.clear();
    }

    if (backgroundBarSeriesRef.current) {
      backgroundBarSeriesRef.current.data.clear();
    }

    if (hoverBackgroundRangeRef.current) {
      hoverBackgroundRangeRef.current.get("axisFill").set("visible", false);
    }

    buyOverlayRef.current?.set("visible", false);
    sellOverlayRef.current?.set("visible", false);
  };

  // ✅ 9️⃣ Helper to update reference price from last candle
  const updateReferencePrice = () => {
    const data = valueSeriesref.current?.data?._values;
    if (!data || !data.length) return;
    const lastCandle = data[data.length - 1];
    if (!lastCandle) return;
    referencePrice.current = lastCandle.close;
  };

  // ✅ 10️⃣ Hook to keep reference price in sync
  useEffect(() => {
    if (valueSeriesref.current) {
      valueSeriesref.current.events.on("datavalidated", updateReferencePrice);
      // initialize on mount
      updateReferencePrice();
    }
  }, []);

  // Simplified useEffect without arrow logic
  useEffect(() => {
    if (!valueSeriesref.current) return;

    if (combinedBulletFactoryRef.current) {
      valueSeriesref.current.bullets.removeValue(
        combinedBulletFactoryRef.current,
      );
    }

    const factory = (root, series, dataItem) => {
      const dataItems = series.dataItems;
      const lastDataItem = dataItems[dataItems.length - 1];
      if (dataItem !== lastDataItem) return undefined;
      let dxValue = window.innerWidth < 850 ? 30 : 50;

      let container = am5.Container.new(root, {
        layout: root.horizontalLayout,
        centerX: am5.p50,
        centerY: am5.p50,
        dx: dxValue,
        dy: 4,
      });

      // Always show timer (remove conditional check)
      const label = am5.Label.new(root, {
        // text: `${candletimer?.duration || ""}\n${time || ""}`,
        text: `${candletimer?.duration || ""}\n${candleTime || ""}`,
        fontSize: 12,
        fill: am5.color(0xffffff),
        centerX: am5.p50,
        textAlign: "end",
        fillOpacity: 0.5,
      });
      container.children.push(label);

      return am5.Bullet.new(root, {
        locationX: 0.5,
        locationY: 0.5,
        sprite: container,
        field: "value",
      });
    };

    combinedBulletFactoryRef.current = factory;
    valueSeriesref.current.bullets.push(factory);
  }, [
    lastPrice,
    stoptimmer,
    candletimer,
    candleTime,
    activeHoverTypeRef.current,
  ]);
  useEffect(() => {
    if (!stoptimmer || !activeHoverTypeRef.current || lastPrice?.close == null)
      return;

    // ⚡ Update background fill live
    updateHoverBackgroundRange(lastPrice.close);
  }, [lastPrice?.close, stoptimmer, activeHoverTypeRef.current]);

  const showLineAnimation = (type) => {
    if (!panelInfo) return;

    const { panel, yAxis, root } = panelInfo;
    // const lastDataItem = chartRef.current.series.get("dataItems");
    const currentData = [...valueSeriesref.current.data.values].slice(-1)[0];
    const lastPrice = currentData?.close;

    const topValue = yAxis.getPrivate("max");
    const bottomValue = yAxis.getPrivate("min");

    const topY = yAxis.valueToPosition(topValue) * panel.plotContainer.height();
    const midY =
      yAxis.valueToPosition(lastPrice) * panel.plotContainer.height();
    const bottomY =
      yAxis.valueToPosition(bottomValue) * panel.plotContainer.height();

    // Top green overlay
    const greenOverlay = am5.Container.new(root, {
      width: am5.percent(100),
      height: topY - midY,
      y: 0,
      fill: am5.color(0x00ff00),
      fillOpacity: 0.1,
      isMeasured: false,
    });

    // Bottom red overlay
    const redOverlay = am5.Container.new(root, {
      width: am5.percent(100),
      height: bottomY - midY,
      y: midY,
      fill: am5.color(0xff0000),
      fillOpacity: 0.1,
      isMeasured: false,
    });

    panel.plotContainer.children.push(greenOverlay);
    panel.plotContainer.children.push(redOverlay);

    // Store overlays for removal
    chartRef.current.greenOverlay = greenOverlay;
    chartRef.current.redOverlay = redOverlay;
  };

  const clearOverlay = () => {
    if (chartRef.current.greenOverlay) chartRef.current.greenOverlay.dispose();
    if (chartRef.current.redOverlay) chartRef.current.redOverlay.dispose();
  };

  useEffect(() => {
    const series = valueSeriesref.current;
    if (!series) return;

    const {
      upColor,
      downColor,
      borderUpColor,
      borderDownColor,
      wickUpColor,
      wickDownColor,
    } = customcaldle;

    // Clear and reset column adapters (Body and Border)
    const columnTemplate = series.columns?.template;
    if (columnTemplate) {
      columnTemplate.adapters.remove("fill");
      columnTemplate.adapters.remove("stroke");

      columnTemplate.adapters.add("fill", (fill, target) => {
        const dataItem = target.dataItem;
        if (!dataItem) return fill;
        const { open, close } = dataItem.dataContext;
        return close < open ? am5.color(downColor) : am5.color(upColor);
      });

      columnTemplate.adapters.add("stroke", (stroke, target) => {
        const dataItem = target.dataItem;
        if (!dataItem) return stroke;
        const { open, close } = dataItem.dataContext;
        return close < open
          ? am5.color(borderDownColor)
          : am5.color(borderUpColor);
      });
    }

    // Clear and reset wick stroke adapter
    const wickTemplate = series.wicks?.template;
    if (wickTemplate) {
      wickTemplate.adapters.remove("stroke");

      wickTemplate.adapters.add("stroke", (stroke, target) => {
        const dataItem = target.dataItem;
        if (!dataItem) return stroke;
        const { open, close } = dataItem.dataContext;
        return close < open ? am5.color(wickDownColor) : am5.color(wickUpColor);
      });
    }

    // Force repaint
    series.columns?.each?.((column) => column.markDirty());
    series.wicks?.each?.((wick) => wick.markDirty());
  }, [customcaldle]);
  const expirationLineRef = useRef(null);
  function formatWithTimezone(timestamp, tzData) {
    const { haur, minute, plus } = tzData;
    // Convert timestamp (seconds → ms if needed)
    let timeMs = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;

    // Apply offset manually
    const offsetMs =
      (parseInt(haur, 10) * 60 + parseInt(minute, 10)) *
      60 *
      1000 *
      (plus === "+" ? 1 : -1);

    const utcMs = timeMs + offsetMs;

    // Extract UTC-based time from adjusted timestamp
    const h = String(Math.floor((utcMs / (1000 * 60 * 60)) % 24)).padStart(
      2,
      "0",
    );
    const m = String(Math.floor((utcMs / (1000 * 60)) % 60)).padStart(2, "0");
    const s = String(Math.floor((utcMs / 1000) % 60)).padStart(2, "0");

    return `${h}.${m}.${s}`;
  }
  function applyTimezoneOffset12(timestampSec, timezone) {
    const baseDateMs = timestampSec * 1000; // Ensure ms
    const sign = timezone.plus === "+" ? 1 : -1;
    const offsetMs =
      (Number(timezone.haur) * 60 + Number(timezone.minute)) * 60 * 1000 * sign;

    return baseDateMs + offsetMs; // Return adjusted time in ms
  }

  useEffect(() => {
    const root = rootref.current;
    const dateAxis = dateAxisref.current;
    const mainPanel = mainPanelRef.current;

    if (
      !root ||
      !dateAxis ||
      !mainPanel ||
      !selecttime ||
      !valueSeriesref.current
    )
      return;

    const dynamicTime = selecttime;
    const durationInMs =
      parseInt(dynamicTime.hours || 0) * 3600 * 1000 +
      parseInt(dynamicTime.minutes || 0) * 60 * 1000 +
      parseInt(dynamicTime.secound || 0) * 1000;

    const computeExpiration = () =>
      (dynamicTime?.checktimmer
        ? dynamicTime?.currenttimestamp * 1000
        : currenttimeref?.current?.timestamp * 1000) + durationInMs;

    // --- Create/Reuse expiration line ---
    let range = expirationLineRef.current;
    const expirationTimestamp = computeExpiration();
    if (!range) {
      const di = dateAxis.makeDataItem({ value: expirationTimestamp });
      range = dateAxis.createAxisRange(di);
      expirationLineRef.current = range;

      const grid = range.get("grid");
      grid?.setAll({
        stroke: am5.color(0xffffff),
        strokeWidth: 1,
        strokeOpacity: 0.5,
        visible: true,
      });

      const label = range.get("label");
      label?.setAll({ visible: false });
    } else {
      range.set("value", expirationTimestamp);
    }

    // --- Overlay setup (only once) ---
    let overlay = overlayRef.current;
    if (!overlay) {
      overlay = mainPanel.plotContainer.children.push(
        am5.Container.new(root, {
          isMeasured: false,
          x: 0,
          y: 0,
          zIndex: 10000,
          interactive: false,
        }),
      );
      overlay.toFront();

      const flag = overlay.children.push(
        am5.Label.new(root, {
          text: "■",
          fill: am5.color(0xffffff),
          fontSize: 25,
          centerX: am5.p0,
          centerY: 0,
          y: -15,
          x: -11,
        }),
      );

      const topLabel = overlay.children.push(
        am5.Label.new(root, {
          text: "",
          fontSize: 12,
          fill: am5.color(0xffffff),
          centerX: am5.p0,
          // y: window.innerWidth > 650 ? 18 : -5,
          // x: window.innerWidth > 650 ? 0 : 10,
          y: window.innerWidth > 650 ? -7 : -5,
          x: window.innerWidth > 650 ? 9 : 10,
          fillOpacity: 0.5,
        }),
      );

      overlay.flag = flag;
      overlay.topLabel = topLabel;
      overlayRef.current = overlay;
    }

    // --- Sync per frame (no lag) ---
    const renderer = dateAxis.get("renderer");
    const updateFlagPosition = () => {
      const val = range.get("value");
      if (val == null) return;

      const pos = dateAxis.valueToPosition(val);
      const x = renderer.positionToCoordinate(pos);
      if (Number.isFinite(x)) overlay.setAll({ x });

      if (overlay.topLabel) {
        overlay.topLabel.set(
          "text",
          `Expiration Time\n${formatWithTimezone(val, updatetimezone)}`,
        );
      }
    };

    // Move instantly once
    updateFlagPosition();

    // Attach to amCharts render loop (perfect sync)
    const frameHandler = root.events.on("frameended", updateFlagPosition);

    // Also update timestamp periodically (to refresh expiration)
    const interval = setInterval(() => {
      const newExp = computeExpiration();
      range.set("value", newExp);
    }, 500);

    return () => {
      clearInterval(interval);
      root.events.off(frameHandler);
      try {
        overlayRef.current?.dispose();
        overlayRef.current = null;
      } catch {}
      try {
        expirationLineRef.current?.dispose?.();
        expirationLineRef.current = null;
      } catch {}
    };
  }, [
    selecttime,
    rootref.current,
    valueSeriesref.current,
    serverTime,
    chnagetyperef.current,
    candletimer,
    tradestyleref.current,
    updatetimezone,
    currenttimeref?.current?.timestamp,
  ]);

  useEffect(() => {
    if (chnagetyperef.current && navigator.onLine && serverTime) {
      am5chartlayout();
      setChartLoader(true);
    } else {
      setChartLoader(true);
    }
    return () => {
      if (rootref.current) {
        isReadyRef.current = false;
        rootref.current.dispose(); // dispose of the root to prevent duplicate initialization
      }
    };
  }, [
    // chnagetyperef.current,
    candletimer,
    tradestyleref.current,
    updatetimezone,
    navigator.onLine,
    serverTime,
  ]);
  let starttime = "";
  let endtimetime = "";
  useEffect(() => {
    const handleFocus = async () => {
      if (websoketrunning.current) {
        return;
      }

      setClosetradeapi(false);
      if (!document.hidden) {
            closetradeapirun.current = true;
        setClosetradeapi(true);
        buyMarkersref.current = [];
        clearTimeout(timeoutRef.current);
        if (rootref.current) {
          rootref.current.dispose();
          rootref.current = null;
        }
        setChartLoader(true);
        websoketrunning.current = false;
        websoketarrref.current = [];
        if (soketref.current) {
          soketref.current.onclose = null;
          soketref.current.onmessage = null;
          soketref.current.onerror = null;
          soketref.current.close();
          soketref.current = null;
        }

        websoketclose.current = false;
        valueSeriesref.current.data.setAll([]);
        //  am5chartlayout();

        fetchServerTime();
        // timewebsoket(updatetimezone?.time);
        assetapi(true);
        // gettimezoneprefrence()
      }
    };

    window.addEventListener("visibilitychange", handleFocus);

    return () => {
      window.removeEventListener("visibilitychange", handleFocus);

      // cleanup root on unmount
      if (rootref.current) {
        rootref.current.dispose();
        rootref.current = null;
      }
    };
  }, []);
  const setlastdissconnect = async (value) => {
    try {
      let postdata = {
        key: "lastdissconnect",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getlastdissconnecttime = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=lastdissconnect`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        return parsedValue;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  //   useEffect(() => {
  //   const handleHide = async () => {
  //     starttime = await getServerTime();
  //     soketref.current.close();
  //     websoketclose.current = false;
  //     websoketrunning.current = false;
  //     websoketarrref.current = [];
  //     runningcandledataref.current = [];
  //     // setlastdissconnect(starttime)
  //   };

  //   const handleShow = async () => {
  //     endtimetime = await getServerTime();
  //     starttime = await getlastdissconnecttime()
  //     // upadtedata(starttime, endtimetime);
  //   };

  //   // Fires when user switches tab, minimizes browser, or hides page
  //   const handleVisibility = () => {
  //     if (document.hidden) {
  //       handleHide();
  //     } else {
  //       handleShow();
  //     }
  //   };

  //   // Attach listeners
  //   document.addEventListener("visibilitychange", handleVisibility);
  //   window.addEventListener("pagehide", handleHide);
  //   window.addEventListener("pageshow", handleShow);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibility);
  //     window.removeEventListener("pagehide", handleHide);
  //     window.removeEventListener("pageshow", handleShow);
  //   };
  // }, []);
  const upadtedata = async (starttime, endtimetime) => {
    try {
      let postdata = {};
      const currentTimestamp = Math.floor(endtimetime?.server_time / 1000);
      const fromTimestamp = Math.floor(starttime?.server_time / 1000);
      const flooredTimestamp = fromTimestamp - (fromTimestamp % 60);

      let res = await callApi(
        postdata,
        `api/get-ohlc-data/${chnagetyperef.current?.ticker}/${
          candletimer?.value
        }/${candletimer?.type}/${
          flooredTimestamp - 60
        }/${currentTimestamp}?adjusted=true&sort=asc`,
        "GET",
      );
      if (res?.data?.success) {
        let data = res?.data?.data.map((item) => ({
          open: parseFloat(parseFloat(item?.o).toFixed(4)),
          close: parseFloat(parseFloat(item?.c).toFixed(4)),
          high: parseFloat(parseFloat(item?.h).toFixed(4)),
          low: parseFloat(parseFloat(item?.l).toFixed(4)),
          time: item?.t * 1000,
        }));
        if (data?.length) {
          const newData = data.slice(1);
          const lastIndex = valueSeriesref.current.data?._values?.length - 1;
          const lastTime = valueSeriesref.current.data?._values[lastIndex].time;
          const firstTime = newData[0].time;
          if (firstTime === lastTime) {
            valueSeriesref.current.data.setIndex(lastIndex, newData[0]);
            for (let i = 1; i < newData.length; i++) {
              valueSeriesref.current.data.push(newData[i]);
            }
          } else {
            for (let i = 0; i < newData.length; i++) {
              valueSeriesref.current.data.push(newData[i]);
            }
          }
          runningcandledataref.current.push(newData[newData?.length - 1]);
          // userdetails();
          // timewebsoket(updatetimezone?.time);

          setupwebsoket(
            newData,
            parseInt(candletimer?.value),
            candletimer?.type,
          );
        }
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    const handleOnline = () => {
      setChartLoader(true);
      window.location.reload(); // auto refresh when internet comes back
    };

    const handleOffline = () => {
      setChartLoader(true);
    };

    window.addEventListener("online", handleOnline);
    // window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      // window.removeEventListener("offline", handleOffline);
    };
  }, []);
  const modalRef = useRef();
  const inputRef = useRef();
  const [addhighlightclass, setAddhighlightclass] = useState({
    index: 0,
    show: false,
  });

  const hightlightref = useRef({
    index: 0,
    show: false,
  });

  const keyBufferRef = useRef(""); // persistent buffer for keys
  const modalOpeningRef = useRef(false); // flag for modal opening
  useEffect(() => {
    const handleKeyPress = (e) => {
      const key = e.key;
      const isLetter = /^[a-zA-Z]$/.test(key);
      const activeTag = document.activeElement.tagName.toLowerCase();
      const activeEl = document.activeElement;
      const isTyping =
        activeTag === "input" ||
        activeTag === "textarea" ||
        document.activeElement.isContentEditable;
      console.log(inputRef.current, "inputRef", activeEl);

      if (isTyping && activeEl !== inputRef.current) {
        return;
      }

      if (e.ctrlKey || e.altKey || e.metaKey || e.shiftKey || key === "Tab")
        return;

      const collapseElement = document.getElementById("symbolSearchCollapse");

      if (key === "Escape") {
        if (collapseElement && collapseElement.classList.contains("show")) {
          new window.bootstrap.Collapse(collapseElement, { toggle: true });
          showassetactive("cryptocurrency");
          setSearchTermall("");
        }
        return;
      }

      if (isLetter) {
        if (!searchpopup) return;

        const isModalOpen = collapseElement?.classList.contains("show");

        // If modal is not open and not opening → start opening and buffer the key
        if (!isModalOpen && !modalOpeningRef.current) {
          modalOpeningRef.current = true;
          keyBufferRef.current = key;

          new window.bootstrap.Collapse(collapseElement, { toggle: true });
          showassetactive("all");

          // Poll until input is ready, then flush buffer
          const interval = setInterval(() => {
            if (inputRef.current) {
              inputRef.current.focus();
              setSearchTermall(keyBufferRef.current);
              keyBufferRef.current = "";
              modalOpeningRef.current = false;
              clearInterval(interval);

              // Highlight first result
              setTimeout(() => {
                const results = document.querySelectorAll(
                  ".search-result-item",
                );
                if (results.length > 0) {
                  results.forEach((el) => el.classList.remove("highlighted"));
                  results[0].classList.add("highlighted");
                  results[0].scrollIntoView({ block: "nearest" });
                }
              }, 100);
            }
          }, 100);
        } else if (modalOpeningRef.current) {
          // Modal is opening → keep buffering keys
          keyBufferRef.current += key;
        } else {
          // Modal is open → append normally
          setSearchTermall((prev) => prev + key);
          if (inputRef.current) inputRef.current.focus();

          setTimeout(() => {
            const results = document.querySelectorAll(".search-result-item");
            if (results.length > 0) {
              results.forEach((el) => el.classList.remove("highlighted"));
              results[0].classList.add("highlighted");
              results[0].scrollIntoView({ block: "nearest" });
            }
          }, 50);
        }

        e.preventDefault();
        return;
      }

      // Handle Arrow navigation and Enter
      if (["ArrowDown", "ArrowUp", "Enter"].includes(key)) {
        const results = document.querySelectorAll(".search-result-item");
        if (!results.length) return;

        e.preventDefault();

        let currentIndex = -1;
        results.forEach((el, index) => {
          if (el.classList.contains("highlighted")) currentIndex = index;
          el.classList.remove("highlighted");
        });

        let newIndex = currentIndex;

        if (key === "ArrowDown") {
          newIndex = (currentIndex + 1) % results.length;
        } else if (key === "ArrowUp") {
          newIndex = (currentIndex - 1 + results.length) % results.length;
        }

        if (key === "Enter") {
          if (assetalllist?.length) {
            const arr = assetalllist.filter((item) => item?.status);
            if (arr.length && hightlightref.current?.index >= 0) {
              setshowtradeasset(arr[hightlightref.current.index], "chartasset");
              setChartLoader(true);
            }
          }

          if (collapseElement && collapseElement.classList.contains("show")) {
            new window.bootstrap.Collapse(collapseElement, { toggle: true });
          }
          return;
        }

        results[newIndex]?.classList.add("highlighted");
        results[newIndex]?.scrollIntoView({ block: "nearest" });
        hightlightref.current = { index: newIndex, show: true };
        setAddhighlightclass({ index: newIndex, show: true });
      }
    };

    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        const collapseElement = document.getElementById("symbolSearchCollapse");
        if (collapseElement && collapseElement.classList.contains("show")) {
          new window.bootstrap.Collapse(collapseElement, { toggle: true });
          showassetactive("cryptocurrency");
          setSearchTermall("");
        }
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [searchpopup, assetalllist]);

  useEffect(() => {
    if (assetalllist?.length) {
      setAddhighlightclass({ index: 0, show: true });
      hightlightref.current = { index: 0, show: true };
    }
  }, [searchTermall]);
  const [notifications, setNotifications] = useState([]);

  const addNotification = (data, checkopen) => {
    const newNotification = {
      id: data?.id || Date.now(),
      title: checkopen === "open" ? "Trade order placed" : "Trade Closed",
      asset: `${data?.pair_from}/${data?.pair_to}`,
      type: data?.type,
      forecast: data?.forecast,
      amount: data?.amount,
      payout: data?.payout,
      profit_loss: data?.profit_loss,
      check: checkopen,
      removing: false,
      ...data,
    };

    setNotifications((prev) => {
      // Remove the oldest if already 4 notifications
      const trimmed = prev.length >= 4 ? prev.slice(0, -1) : prev;
      return [newNotification, ...trimmed]; // Add new at the beginning
    });

    setTimeout(() => {
      setNotifications((prev) =>
        prev.map((n) =>
          n.id === newNotification.id ? { ...n, removing: true } : n,
        ),
      );

      setTimeout(() => {
        setNotifications((prev) =>
          prev.filter((n) => n.id !== newNotification.id),
        );
      }, 500);
    }, 3000);
  };
  useEffect(() => {
    if (notifications?.length >= 5) {
      setNotifications([]);
    }
  }, [notifications?.length]);
  const getsearchprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=searchpopup`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setSearchpopup(parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsearchprefrence();
  }, []);
  const userdetails = async () => {
    try {
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        if (updatetimezone) {
          tradewebsoket(res?.data?.data?.user?.id);
          tradewebsoketclose(res?.data?.data?.user?.id);
        }

        setUserDetails(res?.data?.data?.user);
      } else {
        console.error("API error:", res.error);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };
  useEffect(() => {
    if (updatetimezone && serverTime) {
      userdetails();
    }
  }, [updatetimezone, serverTime, showcopytrades]);

  const enterFullScreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
    setIsFullScreen(true);
  };
  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape" && isFullScreen) {
      exitFullScreen();
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isFullScreen]);
  useEffect(() => {
    if (message?.data) {
      let stringifymsg = message?.data;
      if (stringifymsg?.itemupdated?.length) {
        let assetlist = { ...assetlistpre };
        stringifymsg.itemupdated.forEach((updatedItem) => {
          Object.keys(assetlist).forEach((listKey) => {
            assetlist[listKey] = assetlist[listKey].map((item) =>
              item.sr === updatedItem.sr ? { ...updatedItem } : item,
            );
          });
        });
        const match =
          assetlist?.cryptocurrencieslist.find(
            (item) => item.name === chnagetyperef.current.name,
          ) ||
          assetlist?.currencieslist.find(
            (item) => item.name === chnagetyperef.current.name,
          );

        if (!match || match.status === "0") {
          const fallback = assetlist?.cryptocurrencieslist.find(
            (item) => item.status === "1",
          );
          if (fallback) {
            chnagetyperef.current = fallback;
            setshowtradeasset(chnagetyperef.current, "chartasset");
          }
        }
        setAssetlistpre({
          cryptocurrencieslist: assetlist?.cryptocurrencieslist?.sort(
            (a, b) => Number(b.payout) - Number(a.payout),
          ),
          currencieslist: assetlist?.currencieslist?.sort(
            (a, b) => Number(b.payout) - Number(a.payout),
          ),
        });
      }
    }
  }, [message]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menupopupref.current &&
        !menupopupref.current.contains(event.target) &&
        menubuttonref.current &&
        !menubuttonref.current.contains(event.target)
      ) {
        setShowChartSetting(false); // close popup
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);
  return (
    <React.Fragment>
      {/* <div
        className={`preloader candle-loader-wrapper ${
          pageloader?.chartasset && pageloader?.favorites ? "" : "d-none"
        }`}
      >
        <div className="candle-loader loading-container">
          <div className="candle"></div>
          <div className="candle"></div>
          <div className="candle"></div>
          <div className="candle"></div>
          <div className="candle"></div>
        </div>
      </div> */}

      <Dashboardmenus
        seriesRef={seriesRef}
        walletupdate={walletupdate}
        favorites={assetshowlist?.favorites}
        setshowtradeasset={setshowtradeasset}
        setfavs={setfavs}
        setCheckliveaccount={setCheckliveaccount}
        showassetactive={showassetactive}
      />
      {/* <div className="main-dashboard collapse" id="maindashboardCollapse"> */}
      <div className="main-dashboard">
        <div
          className={`preloader ${
            pageloader?.chartasset && pageloader?.favorites ? "" : "d-none"
          }`}
        >
          <div className="loading-container">
            {/* <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div> */}
            <svg
              className="ajax-loader-v2__icon"
              width="64"
              height="64"
              xmlns="http://www.w3.org/2000/svg"
              shapeRendering="geometricPrecision"
              textRendering="geometricPrecision"
              viewBox="0 0 64 64"
              style={{ whiteSpace: "pre" }}
            >
              <style>
                {`
        @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
        @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
        @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
        @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
        @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
        @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
        @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
      `}
              </style>

              <rect
                width="2"
                height="37"
                fill="#0099fa"
                opacity="0"
                transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                style={{
                  animation:
                    "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                }}
              />
              <rect
                width="10"
                height="19.5"
                fill="#0099fa"
                rx="1"
                opacity="0"
                transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                style={{
                  animation:
                    "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                }}
              />
              <rect
                width="2"
                height="42"
                fill="#0099fa"
                opacity="0"
                transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                style={{
                  animation:
                    "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                }}
              />
              <rect
                width="10"
                height="21"
                fill="#0099fa"
                rx="1"
                opacity="0"
                transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                style={{
                  animation:
                    "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                }}
              />
              <rect
                width="2"
                height="28"
                fill="#0099fa"
                opacity="0"
                transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                style={{
                  animation:
                    "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                }}
              />
              <rect
                width="10"
                height="16"
                fill="#0099fa"
                rx="1"
                opacity="0"
                transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                style={{
                  animation:
                    "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                }}
              />
              <rect
                width="2"
                height="40"
                fill="#0099fa"
                opacity="0"
                transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                style={{
                  animation:
                    "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                }}
              />
              <rect
                width="10"
                height="23"
                fill="#0099fa"
                rx="1"
                opacity="0"
                transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                style={{
                  animation:
                    "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                }}
              />
            </svg>
          </div>
        </div>
        <div
          className="center_part"
          style={{
            paddingLeft: "80px",
          }}
        >
          <section className="tradesetingSec ">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-12">
                  <div className="itemTradesbody">
                    <div className="position-relative">
                      <div
                        className="collapsePop collapse"
                        id="selecttradeCollapse"
                      >
                        <div
                          onClick={() => {
                            handleToggleCollapse(
                              "selecttradeCollapse",
                              {},
                              false,
                              null,
                              false,
                              false,
                            );
                          }}
                          className="btn-close"
                          data-bs-toggle="collapse"
                          role="button"
                          aria-expanded="false"
                          aria-controls="selecttradeCollapse"
                        ></div>
                        <div className="searchoption">
                          <button
                            onClick={(e) => {
                              showassetactive("currency");
                            }}
                            type="button"
                            className={`btn grayBtn ${
                              showasset?.currency ? "active" : ""
                            }`}
                          >
                            <img src={CurrencyDollarSimple} alt="" />
                            <span className="toolTip01">Currencies</span>
                          </button>
                          <button
                            onClick={(e) => {
                              showassetactive("cryptocurrency");
                            }}
                            type="button"
                            className={`btn grayBtn ${
                              showasset?.cryptocurrency && !selectshowasset
                                ? "active"
                                : ""
                            }`}
                          >
                            <img src={CurrencyBtc} alt="" />
                            <span className="toolTip01">Cryptocurrencies</span>
                          </button>
                          <button
                            onClick={(e) => {
                              showassetactive("commodities");
                            }}
                            type="button"
                            className={`btn grayBtn ${
                              showasset?.commodities && !selectshowasset
                                ? "active"
                                : ""
                            }`}
                          >
                            <img src={DropHalfBottom} alt="" />
                            <span className="toolTip01">Commodities</span>
                          </button>
                          <button
                            onClick={(e) => {
                              showassetactive("stocks");
                            }}
                            type="button"
                            className={`btn grayBtn ${
                              showasset?.stocks && !selectshowasset
                                ? "active"
                                : ""
                            }`}
                          >
                            <img src={Files} alt="" />
                            <span className="toolTip01">Stocks</span>
                          </button>
                          <button
                            onClick={(e) => {
                              showassetactive("indices");
                            }}
                            type="button"
                            className={`btn grayBtn ${
                              showasset?.indices && !selectshowasset
                                ? "active"
                                : ""
                            }`}
                          >
                            <img src={TrendUp} alt="" />
                            <span className="toolTip01">Indices</span>
                          </button>
                          <button
                            type="button"
                            className="btn grayBtn searchbar"
                          >
                            <img src={searchnormal} alt="" />
                            <input
                              type="search"
                              className="searchinput"
                              // placeholder="Search assets..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </button>
                          <button
                            onClick={(e) => {
                              showassetactive("favorites");
                            }}
                            type="button"
                            className={`btn grayBtn ${
                              showasset?.favorites && !selectshowasset
                                ? "active"
                                : ""
                            }`}
                          >
                            <img src={Star2} alt="" />
                            <span className="toolTip01">Favorites</span>
                          </button>
                          {/* <button type="button" className="btn grayBtn">
                            <img src={CalendarBlank} alt="" />
                          </button> */}
                        </div>

                        <ul className="selectFavorite">
                          <li className="titleline">
                            <div className="currenciesOption">
                              <h6 className="title">{t("Asset")}</h6>
                            </div>
                            <div className="payoutOption">
                              <h6 className="title">{t("Payout")}</h6>
                            </div>
                          </li>
                          {assetlist?.length !== 0 &&
                            assetlist.map((result, key) => {
                              return (
                                <li
                                  key={key}
                                  style={{ cursor: "pointer" }}
                                  className={`${
                                    chnagetyperef.current?.ticker ===
                                    result?.ticker
                                      ? "active"
                                      : ""
                                  } ${
                                    !parseInt(result?.status) ? "d-none" : ""
                                  }`}
                                >
                                  <div
                                    className="onclickfullli"
                                    onClick={() => {
                                      setSearchTerm("");
                                      setshowtradeasset(result, "chartasset");
                                      setChartLoader(true);
                                      if (window.innerWidth <= 1402) {
                                        handleToggleCollapse(
                                          "selecttradeCollapse",
                                          {},
                                          false,
                                          null,
                                          false,
                                          false,
                                        );
                                      }
                                    }}
                                  ></div>
                                  <div className="currenciesOption">
                                    {result?.favorite ? (
                                      <i
                                        onClick={() => setfavs(result, false)}
                                        style={{
                                          color: "#ff9706",
                                        }}
                                        className="fa-solid fa-star del starSelect"
                                      ></i>
                                    ) : (
                                      <img
                                        onClick={() => setfavs(result, true)}
                                        src={star}
                                        className="starSelect"
                                        alt=""
                                      />
                                    )}
                                    <img
                                      src={
                                        process.env.REACT_APP_BASE_IMAGE_URL +
                                        result?.image
                                      }
                                      alt=""
                                    />

                                    <div>
                                      <h5
                                        className="title"
                                        onClick={() => {
                                          setshowtradeasset(
                                            result,
                                            "chartasset",
                                          );
                                          setSearchTerm("");
                                          setChartLoader(true);
                                          if (window.innerWidth <= 1402) {
                                            handleToggleCollapse(
                                              "selecttradeCollapse",
                                              {},
                                              false,
                                              null,
                                              false,
                                              false,
                                            );
                                          }
                                        }}
                                      >
                                        {result?.name}{" "}
                                        {/* <small>{result?.sortname}</small> */}
                                      </h5>
                                    </div>
                                  </div>
                                  <div className="payoutOption">
                                    <h5 className="title">
                                      +{result?.payout}%
                                    </h5>
                                  </div>
                                </li>
                              );
                            })}
                          {!assetlist?.length && (
                            <div
                              style={{
                                color: "#fff",
                                textAlign: "center",
                              }}
                            >
                              {t("Assets Not Available")}
                            </div>
                          )}
                        </ul>
                      </div>
                      <div
                        className="popBeforeOverlay"
                        style={{ backgroundColor: "#0000" }}
                      ></div>
                      <div
                        onClick={() => {
                          // setOpenmodal(!openmodal);
                          handleToggleCollapse(
                            "selecttradeCollapse",
                            {},
                            false,
                            null,
                            false,
                            false,
                          );
                        }}
                        className="itemList onclicksearch"
                        data-bs-toggle="collapse"
                        // href="#selecttradeCollapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="selecttradeCollapse"
                      >
                        <Link to="" onClick={(e) => e.preventDefault()}>
                          <img
                            src={
                              chnagetyperef.current?.image
                                ? process.env.REACT_APP_BASE_IMAGE_URL +
                                  chnagetyperef.current?.image
                                : Bitcoin
                            }
                            alt=""
                          />
                          <h5>
                            {chnagetyperef.current?.name}{" "}
                            <small>
                              FT • +{chnagetyperef.current?.payout}%
                            </small>
                          </h5>
                          <i className="fa-solid fa-chevron-down"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="position-relative impt">
                      <div className="mobileshow01">
                        <button
                          ref={menubuttonref}
                          className="mobile-btn-tab alltabnav01"
                          type="button"
                          onClick={() => setShowChartSetting(!showchartsetting)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 32 32"
                            xmlSpace="preserve"
                            enableBackground="new 0 0 32 32"
                            id="Glyph"
                            version="1.1"
                          >
                            <path
                              d="M13,16c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,14.346,13,16z"
                              id="XMLID_294_"
                            />
                            <path
                              d="M13,26c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,24.346,13,26z"
                              id="XMLID_295_"
                            />
                            <path
                              d="M13,6c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,4.346,13,6z"
                              id="XMLID_297_"
                            />
                          </svg>
                        </button>
                        <button
                          onClick={() => openModal("deletemodel")}
                          className={`mobile-btn-tab delete-noti ${
                            !showindicator?.length && !drawings?.length
                              ? "d-none"
                              : ""
                          }`}
                          type="button"
                          aria-label="Full Screen"
                        >
                          <svg
                            viewBox="0 0 448 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M432 80h-82.38l-34-56.75C306.1 8.827 291.4 0 274.6 0H173.4C156.6 0 141 8.827 132.4 23.25L98.38 80H16C7.125 80 0 87.13 0 96v16C0 120.9 7.125 128 16 128H32v320c0 35.35 28.65 64 64 64h256c35.35 0 64-28.65 64-64V128h16C440.9 128 448 120.9 448 112V96C448 87.13 440.9 80 432 80zM171.9 50.88C172.9 49.13 174.9 48 177 48h94c2.125 0 4.125 1.125 5.125 2.875L293.6 80H154.4L171.9 50.88zM352 464H96c-8.837 0-16-7.163-16-16V128h288v320C368 456.8 360.8 464 352 464zM224 416c8.844 0 16-7.156 16-16V192c0-8.844-7.156-16-16-16S208 183.2 208 192v208C208 408.8 215.2 416 224 416zM144 416C152.8 416 160 408.8 160 400V192c0-8.844-7.156-16-16-16S128 183.2 128 192v208C128 408.8 135.2 416 144 416zM304 416c8.844 0 16-7.156 16-16V192c0-8.844-7.156-16-16-16S288 183.2 288 192v208C288 408.8 295.2 416 304 416z" />
                          </svg>
                          <span className="count01">
                            {showindicator?.length + drawings?.length}
                          </span>
                        </button>
                        <button
                          onClick={() => {
                            isFullScreen ? exitFullScreen() : enterFullScreen();
                          }}
                          className="mobile-btn-tab full-screen"
                          type="button"
                          aria-label="Full Screen"
                        >
                          <i className="fa-solid fa-expand"></i>
                        </button>
                      </div>
                      <div
                        ref={menupopupref}
                        className={`tradeseting ${showchartsetting && "show"}`}
                      >
                        <div className="position-relative">
                          <div
                            className="collapsePop collapse"
                            id="indicatorsCollapse"
                          >
                            <ul
                              className="favoritesTablist nav nav-tabs"
                              id="myTab"
                              role="tablist"
                            >
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link"
                                  id="Current-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#Current"
                                  type="button"
                                  role="tab"
                                  aria-controls="Current"
                                  aria-selected="false"
                                >
                                  {t("Current")}
                                </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link active"
                                  id="allFavorite-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#allFavorite"
                                  type="button"
                                  role="tab"
                                  aria-controls="allFavorite"
                                  aria-selected="true"
                                >
                                  {t("All")}
                                </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                <button
                                  className="nav-link"
                                  id="favorites-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#favorites"
                                  type="button"
                                  role="tab"
                                  aria-controls="favorites"
                                  aria-selected="false"
                                >
                                  <i className="fa-solid fa-star del"></i>{" "}
                                  {t("Favorites")}
                                </button>
                              </li>
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade"
                                id="Current"
                                role="tabpanel"
                                aria-labelledby="Current-tab"
                              >
                                <div className="all indicators-list">
                                  {showindicator?.length
                                    ? showindicator.map((result, key) => {
                                        return (
                                          <>
                                            <div
                                              className="list-item has-favorites"
                                              style={{
                                                maxWidth: "50%",
                                              }}
                                              key={key}
                                            >
                                              <Link
                                                to=""
                                                className="fav"
                                                onClick={(e) =>
                                                  e.preventDefault()
                                                }
                                              >
                                                {result?.fav ? (
                                                  <i
                                                    onClick={() =>
                                                      indicatorfav(key)
                                                    }
                                                    className="fa-solid fa-star add"
                                                  ></i>
                                                ) : (
                                                  <i
                                                    onClick={() =>
                                                      indicatorfav(key)
                                                    }
                                                    className="fa-star del fa-regular"
                                                  ></i>
                                                )}
                                              </Link>
                                              <Link
                                                to=""
                                                onClick={(e) =>
                                                  e.preventDefault()
                                                }
                                                className="list-item-block crop-text"
                                              >
                                                <span
                                                  className="asset-label"
                                                  onClick={() =>
                                                    setidemodal(result)
                                                  }
                                                >
                                                  {result?.name}
                                                </span>
                                              </Link>
                                              <i
                                                onClick={() =>
                                                  deleteind(key, result)
                                                }
                                                className="fa-solid fa-trash active"
                                                style={{
                                                  color: "red",
                                                  marginLeft: "80px",
                                                }}
                                              ></i>
                                            </div>
                                          </>
                                        );
                                      })
                                    : ""}
                                </div>
                              </div>
                              <div
                                className="tab-pane fade show active"
                                id="allFavorite"
                                role="tabpanel"
                                aria-labelledby="allFavorite-tab"
                              >
                                <div className="all indicators-list">
                                  {indicatorlist?.length
                                    ? indicatorlist.map((result, key) => {
                                        return (
                                          <div
                                            className="list-item has-favorites"
                                            key={key}
                                          >
                                            <Link
                                              to=""
                                              className="fav"
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                            >
                                              {result?.fav ? (
                                                <i
                                                  onClick={() =>
                                                    indicatorfav(key)
                                                  }
                                                  className="fa-solid fa-star add"
                                                ></i>
                                              ) : (
                                                <i
                                                  onClick={() =>
                                                    indicatorfav(key)
                                                  }
                                                  className="fa-star del fa-regular"
                                                ></i>
                                              )}
                                            </Link>
                                            <Link
                                              to=""
                                              onClick={(e) =>
                                                e.preventDefault()
                                              }
                                              className="list-item-block crop-text"
                                            >
                                              <span
                                                className="asset-label"
                                                onClick={() =>
                                                  setupshowindicator(
                                                    result,
                                                    key,
                                                  )
                                                }
                                              >
                                                {result?.name}
                                              </span>
                                            </Link>
                                          </div>
                                        );
                                      })
                                    : ""}
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="favorites"
                                role="tabpanel"
                                aria-labelledby="favorites-tab"
                              >
                                <div className="all indicators-list">
                                  {indicatorlist?.length
                                    ? indicatorlist.map((result, key) => {
                                        return (
                                          <>
                                            {result?.fav ? (
                                              <div className="list-item has-favorites">
                                                <Link
                                                  to=""
                                                  className="fav"
                                                  onClick={(e) =>
                                                    e.preventDefault()
                                                  }
                                                >
                                                  <i
                                                    onClick={() =>
                                                      indicatorfav(key)
                                                    }
                                                    className="fa-solid fa-star add"
                                                  ></i>
                                                </Link>
                                                <Link
                                                  to=""
                                                  onClick={(e) =>
                                                    e.preventDefault()
                                                  }
                                                  className="list-item-block crop-text"
                                                >
                                                  <span
                                                    className="asset-label"
                                                    onClick={() =>
                                                      setupshowindicator(
                                                        result,
                                                        key,
                                                      )
                                                    }
                                                  >
                                                    {result?.name}
                                                  </span>
                                                </Link>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        );
                                      })
                                    : ""}
                                  {/* <div className="list-item has-favorites">
                                    <Link to="" className="fav">
                                      <i className="fa-solid fa-star del"></i>
                                    </Link>
                                    <Link
                                      to=""
                                      className="list-item-block crop-text"
                                    >
                                      <span className="asset-label">
                                        Accelerator Oscillator
                                      </span>
                                    </Link>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="popBeforeOverlay"></div>
                          {/* <Indmodal
                            showModal={showindModal}
                            closeModal={closeindModal}
                            idmodaldata={idmodaldata}
                            getindmodaldata={getindmodaldata}
                          /> */}
                          {/* <div
                            id="chartcontrols"
                            style={{ marginBottom: "10px", color: "white" }}
                          ></div> */}
                          <button
                            data-bs-toggle="collapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="indicatorsCollapse"
                            onClick={() =>
                              handleToggleCollapse("indicatorsCollapse")
                            }
                          >
                            <svg
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              data-bs-original-title="Indicators"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18"
                              height="18"
                              fill="rgba(255,255,255,1)"
                            >
                              <path d="M6.17071 18C6.58254 16.8348 7.69378 16 9 16C10.3062 16 11.4175 16.8348 11.8293 18H22V20H11.8293C11.4175 21.1652 10.3062 22 9 22C7.69378 22 6.58254 21.1652 6.17071 20H2V18H6.17071ZM12.1707 11C12.5825 9.83481 13.6938 9 15 9C16.3062 9 17.4175 9.83481 17.8293 11H22V13H17.8293C17.4175 14.1652 16.3062 15 15 15C13.6938 15 12.5825 14.1652 12.1707 13H2V11H12.1707ZM6.17071 4C6.58254 2.83481 7.69378 2 9 2C10.3062 2 11.4175 2.83481 11.8293 4H22V6H11.8293C11.4175 7.16519 10.3062 8 9 8C7.69378 8 6.58254 7.16519 6.17071 6H2V4H6.17071Z"></path>
                            </svg>
                          </button>
                        </div>
                        <div className="position-relative">
                          <div
                            className="collapsePop collapse"
                            id="stocklinesCollapse"
                          >
                            <div className="borderlines">
                              {drawings?.length ? (
                                <button className="justify-content-center gap-5 active">
                                  <div
                                    className="p-2"
                                    onClick={() => setCurrentdrawingshow(true)}
                                  >
                                    {t("Current")}
                                  </div>
                                  <div
                                    className="p-2"
                                    onClick={() => setCurrentdrawingshow(false)}
                                  >
                                    {t("All")}
                                  </div>
                                </button>
                              ) : (
                                ""
                              )}
                              {currentdrawingshow ? (
                                drawings?.length ? (
                                  drawings.map((result, key) => {
                                    return (
                                      <div className="align-items-center d-flex">
                                        <button className="active" key={key}>
                                          {result?.image} {result?.type}
                                        </button>
                                        <div
                                          className="p-2"
                                          onClick={() => {
                                            deletedrawing(result?.type, key);
                                          }}
                                        >
                                          <i
                                            className="fa-solid fa-trash active"
                                            style={{ color: "red" }}
                                          ></i>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  ""
                                )
                              ) : (
                                <>
                                  <button
                                    className="active"
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Vertical Line",
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <mask
                                            id="mask0_2545_5607"
                                            style={{ maskType: "luminance" }}
                                            maskUnits="userSpaceOnUse"
                                            x="9"
                                            y="0"
                                            width="3"
                                            height="20"
                                          >
                                            <path
                                              d="M9.271 0H11.146V20H9.271V0Z"
                                              fill="white"
                                            />
                                          </mask>
                                          <g mask="url(#mask0_2545_5607)">
                                            <path
                                              d="M10.146 20C9.646 20 9.271 19.625 9.271 19.125V0.875C9.271 0.375 9.646 0 10.146 0C10.646 0 11.021 0.375 11.021 0.875V19.125C11.021 19.625 10.646 20 10.146 20Z"
                                              fill="white"
                                            />
                                          </g>
                                        </svg>,
                                        "verticalLine",
                                      );
                                      // handleToolSelect("verticalLine");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <mask
                                        id="mask0_2545_5607"
                                        style={{ maskType: "luminance" }}
                                        maskUnits="userSpaceOnUse"
                                        x="9"
                                        y="0"
                                        width="3"
                                        height="20"
                                      >
                                        <path
                                          d="M9.271 0H11.146V20H9.271V0Z"
                                          fill="white"
                                        />
                                      </mask>
                                      <g mask="url(#mask0_2545_5607)">
                                        <path
                                          d="M10.146 20C9.646 20 9.271 19.625 9.271 19.125V0.875C9.271 0.375 9.646 0 10.146 0C10.646 0 11.021 0.375 11.021 0.875V19.125C11.021 19.625 10.646 20 10.146 20Z"
                                          fill="white"
                                        />
                                      </g>
                                    </svg>{" "}
                                    {t("Vertical line")}
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Parallel Channel",
                                        // seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clip-path="url(#clip0_2545_5612)">
                                            <mask
                                              id="mask0_2545_5612"
                                              style={{ maskType: "luminance" }}
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="20"
                                              height="20"
                                            >
                                              <path
                                                d="M0 0.587402H20V19.4124H0V0.587402Z"
                                                fill="white"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_2545_5612)">
                                              <path
                                                d="M15.5876 0.883301C15.2334 0.529134 14.5876 0.529134 14.2334 0.883301L0.295898 14.825C-0.0582682 15.1791 -0.0582682 15.825 0.295898 16.1791C0.470898 16.3541 0.708398 16.475 0.941732 16.475C1.17507 16.475 1.41257 16.4166 1.6459 16.1791L15.5876 2.17497C16.0001 1.8208 16.0001 1.2333 15.5876 0.879134V0.883301ZM19.5292 3.82497C19.1751 3.4708 18.5292 3.4708 18.1751 3.82497L4.17507 17.7666C3.8209 18.1208 3.8209 18.7666 4.17507 19.1208C4.35007 19.2958 4.58756 19.4166 4.87923 19.4166C5.1709 19.4166 5.35006 19.3 5.5834 19.1208L19.5876 5.11663C19.9417 4.76247 19.9417 4.17497 19.5292 3.8208V3.82497Z"
                                                fill="white"
                                              />
                                            </g>
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_2545_5612">
                                              <rect
                                                width="20"
                                                height="20"
                                                fill="white"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>,
                                        "channel",
                                      );
                                      // handleToolSelect("channel");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_2545_5612)">
                                        <mask
                                          id="mask0_2545_5612"
                                          style={{ maskType: "luminance" }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="20"
                                          height="20"
                                        >
                                          <path
                                            d="M0 0.587402H20V19.4124H0V0.587402Z"
                                            fill="white"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_2545_5612)">
                                          <path
                                            d="M15.5876 0.883301C15.2334 0.529134 14.5876 0.529134 14.2334 0.883301L0.295898 14.825C-0.0582682 15.1791 -0.0582682 15.825 0.295898 16.1791C0.470898 16.3541 0.708398 16.475 0.941732 16.475C1.17507 16.475 1.41257 16.4166 1.6459 16.1791L15.5876 2.17497C16.0001 1.8208 16.0001 1.2333 15.5876 0.879134V0.883301ZM19.5292 3.82497C19.1751 3.4708 18.5292 3.4708 18.1751 3.82497L4.17507 17.7666C3.8209 18.1208 3.8209 18.7666 4.17507 19.1208C4.35007 19.2958 4.58756 19.4166 4.87923 19.4166C5.1709 19.4166 5.35006 19.3 5.5834 19.1208L19.5876 5.11663C19.9417 4.76247 19.9417 4.17497 19.5292 3.8208V3.82497Z"
                                            fill="white"
                                          />
                                        </g>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_2545_5612">
                                          <rect
                                            width="20"
                                            height="20"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>{" "}
                                    {t("Channel")}
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Horizontal Line",
                                        // seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M19.1125 10.8209H0.8875C0.3875 10.8209 0 10.375 0 9.87503C0 9.37503 0.3875 8.9292 0.8875 8.9292H19.1083C19.6083 8.9292 19.9958 9.3167 19.9958 9.87503C19.9958 10.4334 19.6083 10.8209 19.1083 10.8209H19.1125Z"
                                            fill="white"
                                          />
                                        </svg>,
                                        "horizontalLine",
                                      );
                                      // handleToolSelect("horizontalLine");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M19.1125 10.8209H0.8875C0.3875 10.8209 0 10.375 0 9.87503C0 9.37503 0.3875 8.9292 0.8875 8.9292H19.1083C19.6083 8.9292 19.9958 9.3167 19.9958 9.87503C19.9958 10.4334 19.6083 10.8209 19.1083 10.8209H19.1125Z"
                                        fill="white"
                                      />
                                    </svg>{" "}
                                    {t("Horizontal line")}
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Trend Line",
                                        // seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clip-path="url(#clip0_2545_5620)">
                                            <mask
                                              id="mask0_2545_5620"
                                              style={{ maskType: "luminance" }}
                                              maskUnits="userSpaceOnUse"
                                              x="0"
                                              y="0"
                                              width="20"
                                              height="20"
                                            >
                                              <path
                                                d="M0 0H20V20H0V0Z"
                                                fill="white"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_2545_5620)">
                                              <path
                                                d="M1.1875 20C0.875 20 0.5625 19.875 0.3125 19.625C-0.1875 19.125 -0.1875 18.375 0.3125 17.9375L17.9375 0.375C18.4375 -0.125 19.1875 -0.125 19.625 0.375C20.125 0.875 20.125 1.625 19.625 2.0625L2.0625 19.625C1.8125 19.875 1.5 20 1.1875 20Z"
                                                fill="white"
                                              />
                                            </g>
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_2545_5620">
                                              <rect
                                                width="20"
                                                height="20"
                                                fill="white"
                                              />
                                            </clipPath>
                                          </defs>
                                        </svg>,
                                        "trendLine",
                                      );
                                      // handleToolSelect("trendLine");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_2545_5620)">
                                        <mask
                                          id="mask0_2545_5620"
                                          style={{ maskType: "luminance" }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="20"
                                          height="20"
                                        >
                                          <path
                                            d="M0 0H20V20H0V0Z"
                                            fill="white"
                                          />
                                        </mask>
                                        <g mask="url(#mask0_2545_5620)">
                                          <path
                                            d="M1.1875 20C0.875 20 0.5625 19.875 0.3125 19.625C-0.1875 19.125 -0.1875 18.375 0.3125 17.9375L17.9375 0.375C18.4375 -0.125 19.1875 -0.125 19.625 0.375C20.125 0.875 20.125 1.625 19.625 2.0625L2.0625 19.625C1.8125 19.875 1.5 20 1.1875 20Z"
                                            fill="white"
                                          />
                                        </g>
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_2545_5620">
                                          <rect
                                            width="20"
                                            height="20"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>{" "}
                                    {t("Trend line")}
                                  </button>

                                  <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Horizontal Ray",
                                        // seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <circle
                                            cx="4.19355"
                                            cy="15.8063"
                                            r="2.19355"
                                            fill="white"
                                          />
                                          <path
                                            d="M7.20996 13.0645L19.0003 1"
                                            stroke="white"
                                            stroke-width="1.64516"
                                            stroke-linecap="round"
                                          />
                                        </svg>,
                                        "ray",
                                      );
                                      // handleToolSelect("ray");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="4.19355"
                                        cy="15.8063"
                                        r="2.19355"
                                        fill="white"
                                      />
                                      <path
                                        d="M7.20996 13.0645L19.0003 1"
                                        stroke="white"
                                        stroke-width="1.64516"
                                        stroke-linecap="round"
                                      />
                                    </svg>{" "}
                                    {t("Ray")}
                                  </button>
                                  <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Fibonacci",
                                        // seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M11.75 8.25L12.5 7.5"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M9.75049 10.25L10.5005 9.5"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M7.50049 12.5L8.25049 11.75"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M8 14.5H18"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M2 14.5H3"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M18 10L12.5 10"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M2 5.5H12"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M18 5.5H17"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M2 10H7.75"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                          />
                                          <circle
                                            cx="14.5"
                                            cy="5.5"
                                            r="1.5"
                                            fill="white"
                                          />
                                          <circle
                                            cx="5.5"
                                            cy="14.5"
                                            r="1.5"
                                            fill="white"
                                          />
                                        </svg>,
                                        "fibonacciRetracement",
                                      );
                                      // handleToolSelect("fibonacciRetracement");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.75 8.25L12.5 7.5"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M9.75049 10.25L10.5005 9.5"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M7.50049 12.5L8.25049 11.75"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M8 14.5H18"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M2 14.5H3"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M18 10L12.5 10"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M2 5.5H12"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M18 5.5H17"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M2 10H7.75"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                      />
                                      <circle
                                        cx="14.5"
                                        cy="5.5"
                                        r="1.5"
                                        fill="white"
                                      />
                                      <circle
                                        cx="5.5"
                                        cy="14.5"
                                        r="1.5"
                                        fill="white"
                                      />
                                    </svg>{" "}
                                    {t("Fibonacci Retraceent")}
                                  </button>
                                  {/* <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Fibonacci Fan",
                                        seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M11.2565 4.32671C11.4544 3.97037 11.326 3.52102 10.9697 3.32305C10.6134 3.12508 10.164 3.25347 9.96603 3.60981L11.2565 4.32671ZM5.10566 15.3981L11.2565 4.32671L9.96603 3.60981L3.81524 14.6812L5.10566 15.3981Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M16.1253 10.2782C16.485 10.0864 16.6211 9.6393 16.4292 9.27961C16.2374 8.91993 15.7903 8.78386 15.4306 8.97569L16.1253 10.2782ZM5.05388 16.183L16.1253 10.2782L15.4306 8.97569L4.3592 14.8805L5.05388 16.183Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M17.5002 16.7618C17.9078 16.7618 18.2383 16.4313 18.2383 16.0237C18.2383 15.616 17.9078 15.2856 17.5002 15.2856V16.7618ZM4.70654 16.7618H17.5002V15.2856H4.70654V16.7618Z"
                                            fill="white"
                                          />
                                          <path
                                            d="M4.46026 2C4.46026 1.59236 4.12981 1.2619 3.72217 1.2619C3.31453 1.2619 2.98407 1.59236 2.98407 2H4.46026ZM4.46026 14.7937V2H2.98407V14.7937H4.46026Z"
                                            fill="white"
                                          />
                                          <circle
                                            cx="3.72222"
                                            cy="16.0237"
                                            r="1.72222"
                                            fill="white"
                                          />
                                        </svg>,
                                        "fibonacciFan"
                                      );
                                      // handleToolSelect("fibonacciFan");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.2565 4.32671C11.4544 3.97037 11.326 3.52102 10.9697 3.32305C10.6134 3.12508 10.164 3.25347 9.96603 3.60981L11.2565 4.32671ZM5.10566 15.3981L11.2565 4.32671L9.96603 3.60981L3.81524 14.6812L5.10566 15.3981Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M16.1253 10.2782C16.485 10.0864 16.6211 9.6393 16.4292 9.27961C16.2374 8.91993 15.7903 8.78386 15.4306 8.97569L16.1253 10.2782ZM5.05388 16.183L16.1253 10.2782L15.4306 8.97569L4.3592 14.8805L5.05388 16.183Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M17.5002 16.7618C17.9078 16.7618 18.2383 16.4313 18.2383 16.0237C18.2383 15.616 17.9078 15.2856 17.5002 15.2856V16.7618ZM4.70654 16.7618H17.5002V15.2856H4.70654V16.7618Z"
                                        fill="white"
                                      />
                                      <path
                                        d="M4.46026 2C4.46026 1.59236 4.12981 1.2619 3.72217 1.2619C3.31453 1.2619 2.98407 1.59236 2.98407 2H4.46026ZM4.46026 14.7937V2H2.98407V14.7937H4.46026Z"
                                        fill="white"
                                      />
                                      <circle
                                        cx="3.72222"
                                        cy="16.0237"
                                        r="1.72222"
                                        fill="white"
                                      />
                                    </svg>{" "}
                                    Fibonacci Fan
                                  </button> */}
                                  <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Rectangle",
                                        // seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M13.5254 12.2477L18.3647 9.40112"
                                            stroke="white"
                                            stroke-width="1.70797"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M1 18.7951L7.54724 15.0945"
                                            stroke="white"
                                            stroke-width="1.70797"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M5.83936 9.68595L13.5252 5.41602"
                                            stroke="white"
                                            stroke-width="1.70797"
                                            stroke-linecap="round"
                                          />
                                          <circle
                                            cx="2.70797"
                                            cy="11.1091"
                                            r="1.70797"
                                            fill="white"
                                          />
                                          <circle
                                            cx="10.6787"
                                            cy="13.3864"
                                            r="1.70797"
                                            fill="white"
                                          />
                                          <circle
                                            cx="16.372"
                                            cy="3.70797"
                                            r="1.70797"
                                            fill="white"
                                          />
                                        </svg>,
                                        "rectangle",
                                      );
                                      // handleToolSelect("rectangle");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.5254 12.2477L18.3647 9.40112"
                                        stroke="white"
                                        stroke-width="1.70797"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M1 18.7951L7.54724 15.0945"
                                        stroke="white"
                                        stroke-width="1.70797"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M5.83936 9.68595L13.5252 5.41602"
                                        stroke="white"
                                        stroke-width="1.70797"
                                        stroke-linecap="round"
                                      />
                                      <circle
                                        cx="2.70797"
                                        cy="11.1091"
                                        r="1.70797"
                                        fill="white"
                                      />
                                      <circle
                                        cx="10.6787"
                                        cy="13.3864"
                                        r="1.70797"
                                        fill="white"
                                      />
                                      <circle
                                        cx="16.372"
                                        cy="3.70797"
                                        r="1.70797"
                                        fill="white"
                                      />
                                    </svg>{" "}
                                    {t("Rectangle")}
                                  </button>
                                  {/* <button
                                    onClick={(e) => {
                                      setupdrawings(
                                        "Andrew’s Pitchfork",
                                        seriesRef.current.data(),
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M6.90625 16.75H16.75V7.1875"
                                            stroke="white"
                                            stroke-width="1.6875"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M3.25 12.8125V3.25H13.0938"
                                            stroke="white"
                                            stroke-width="1.6875"
                                            stroke-linecap="round"
                                          />
                                          <circle
                                            cx="16.75"
                                            cy="3.25"
                                            r="2.25"
                                            fill="white"
                                          />
                                          <circle
                                            cx="3.25"
                                            cy="16.75"
                                            r="2.25"
                                            fill="white"
                                          />
                                        </svg>,
                                        "andrewsPitchfork"
                                      );
                                      // handleToolSelect("andrewsPitchfork");
                                    }}
                                  >
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M6.90625 16.75H16.75V7.1875"
                                        stroke="white"
                                        stroke-width="1.6875"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M3.25 12.8125V3.25H13.0938"
                                        stroke="white"
                                        stroke-width="1.6875"
                                        stroke-linecap="round"
                                      />
                                      <circle
                                        cx="16.75"
                                        cy="3.25"
                                        r="2.25"
                                        fill="white"
                                      />
                                      <circle
                                        cx="3.25"
                                        cy="16.75"
                                        r="2.25"
                                        fill="white"
                                      />
                                    </svg>{" "}
                                    Andrew’s Pitchfork
                                  </button> */}
                                </>
                              )}

                              {drawings?.length ? (
                                <button
                                  className="justify-content-center text-danger"
                                  onClick={() => {
                                    deletedrawing("all");
                                  }}
                                >
                                  {t("Delete ALL")} ({drawings?.length})
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="popBeforeOverlay"></div>
                          <button
                            data-bs-toggle="collapse"
                            // href="#stocklinesCollapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="stocklinesCollapse"
                            onClick={() =>
                              handleToggleCollapse("stocklinesCollapse")
                            }
                          >
                            <svg
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              data-bs-original-title="Drawings"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.39427 3.3333L12.7683 6.70664L12.1269 7.34797C11.4995 7.29583 10.8683 7.38103 10.2771 7.59765C9.68596 7.81427 9.14911 8.1571 8.70392 8.60228C8.25873 9.04747 7.9159 9.58432 7.69928 10.1755C7.48267 10.7666 7.39746 11.3979 7.4496 12.0253L6.14294 13.332C5.95818 13.5167 5.72838 13.65 5.47627 13.7186L2.06627 14.6486C1.98133 14.6716 1.89183 14.6718 1.8068 14.6492C1.72176 14.6265 1.64422 14.5818 1.58199 14.5196C1.51977 14.4574 1.47507 14.3798 1.45241 14.2948C1.42975 14.2097 1.42993 14.1202 1.45294 14.0353L2.38227 10.6246C2.4509 10.3725 2.58419 10.1427 2.76894 9.95797L9.39427 3.3333ZM14.1216 1.97997C14.5688 2.42739 14.82 3.03407 14.82 3.66664C14.82 4.2992 14.5688 4.90588 14.1216 5.3533L13.4749 5.99997L10.1009 2.62664L10.7476 1.97997C10.9691 1.75838 11.2321 1.58259 11.5216 1.46266C11.811 1.34273 12.1213 1.28101 12.4346 1.28101C12.7479 1.28101 13.0582 1.34273 13.3476 1.46266C13.6371 1.58259 13.9001 1.75838 14.1216 1.97997ZM9.62094 9.31597C9.67079 9.48837 9.68532 9.66907 9.66366 9.84722C9.642 10.0254 9.58461 10.1973 9.4949 10.3528C9.4052 10.5082 9.28504 10.6439 9.14162 10.7518C8.99821 10.8597 8.83449 10.9375 8.66027 10.9806L8.27094 11.0766C8.20854 11.4759 8.20989 11.8825 8.27494 12.2813L8.63494 12.368C8.81066 12.4103 8.97594 12.4879 9.12073 12.5961C9.26553 12.7043 9.38682 12.8408 9.47723 12.9973C9.56765 13.1538 9.62529 13.327 9.64668 13.5065C9.66806 13.686 9.65272 13.8679 9.60161 14.0413L9.47694 14.4626C9.77027 14.72 10.1036 14.9286 10.4663 15.0766L10.7956 14.7313C10.9202 14.6003 11.07 14.496 11.2362 14.4247C11.4023 14.3534 11.5812 14.3167 11.7619 14.3167C11.9427 14.3167 12.1216 14.3534 12.2877 14.4247C12.4538 14.496 12.6037 14.6003 12.7283 14.7313L13.0603 15.0813C13.4212 14.9345 13.7553 14.7288 14.0489 14.4726L13.9169 14.0153C13.8672 13.8429 13.8528 13.6622 13.8745 13.4841C13.8963 13.306 13.9538 13.1341 14.0435 12.9787C14.1333 12.8234 14.2535 12.6877 14.3969 12.5799C14.5403 12.4721 14.7041 12.3943 14.8783 12.3513L15.2669 12.2553C15.3294 11.8558 15.3281 11.449 15.2629 11.05L14.9029 10.9633C14.7272 10.921 14.5619 10.8434 14.4171 10.7352C14.2723 10.627 14.1511 10.4905 14.0606 10.334C13.9702 10.1775 13.9126 10.0042 13.8912 9.82476C13.8698 9.64529 13.8852 9.46334 13.9363 9.28997L14.0609 8.86997C13.7676 8.61133 13.4333 8.40337 13.0716 8.25463L12.7429 8.60064C12.6184 8.73175 12.4684 8.83616 12.3023 8.9075C12.1361 8.97885 11.9571 9.01564 11.7763 9.01564C11.5954 9.01564 11.4165 8.97885 11.2503 8.9075C11.0841 8.83616 10.9342 8.73175 10.8096 8.60064L10.4776 8.25064C10.1149 8.3973 9.7816 8.60397 9.48894 8.85863L9.62094 9.31597ZM11.7683 12.6666C11.2349 12.6666 10.8016 12.2186 10.8016 11.6666C10.8016 11.114 11.2349 10.6666 11.7683 10.6666C12.3016 10.6666 12.7349 11.114 12.7349 11.6666C12.7349 12.2186 12.3016 12.6666 11.7683 12.6666Z"
                                fill="white"
                              />
                            </svg>
                            {drawings?.length ? (
                              <span class="alertShow">{drawings?.length}</span>
                            ) : (
                              ""
                            )}
                          </button>
                        </div>
                        <div className="position-relative">
                          <div
                            className="collapsePop collapse"
                            id="stocktradeCollapse"
                          >
                            <ul
                              className="maintabs nav nav-tabs"
                              id="myTab"
                              role="tablist"
                            >
                              <li
                                className="nav-item"
                                role="presentation"
                                // onClick={() => {
                                //   changecharttype("3");
                                // }}
                              >
                                <button
                                  className={`nav-link ${
                                    tradestyle === "3" ? "active" : ""
                                  }`}
                                  id="linetab-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#linetab"
                                  type="button"
                                  role="tab"
                                  aria-controls="linetab"
                                  aria-selected="false"
                                >
                                  <img
                                    src={lineup}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    data-bs-original-title="Line"
                                    alt=""
                                  />
                                  <span className="toolTip01">Line</span>
                                </button>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => {
                                  changecharttype("1");
                                }}
                              >
                                <button
                                  className={`nav-link ${
                                    tradestyle === "1" ? "active" : ""
                                  }`}
                                  id="candlestab-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#candlestab"
                                  type="button"
                                  role="tab"
                                  aria-controls="candlestab"
                                  aria-selected="true"
                                >
                                  <img
                                    src={candles}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    data-bs-original-title="Candles"
                                    alt=""
                                  />
                                  <span className="toolTip01">Candles</span>
                                </button>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => {
                                  changecharttype("2");
                                }}
                              >
                                <button
                                  className={`nav-link ${
                                    tradestyle === "2" ? "active" : ""
                                  }`}
                                  type="button"
                                  id="candlestab-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#candlestab"
                                  role="tab"
                                  aria-selected="true"
                                  aria-controls="candlestab"
                                >
                                  <img
                                    src={bars}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    data-bs-original-title="Bars"
                                    alt=""
                                  />
                                  <span className="toolTip01">Bars</span>
                                </button>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                // onClick={() => {
                                //   changecharttype("5");
                                // }}
                              >
                                <button
                                  className={`nav-link ${
                                    tradestyle === "5" ? "active" : ""
                                  }`}
                                  type="button"
                                  id="candlestab-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#candlestab"
                                  role="tab"
                                  aria-selected="true"
                                  aria-controls="candlestab"
                                >
                                  <img
                                    src={chain}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    data-bs-original-title="Heiken Ashi"
                                    alt=""
                                  />
                                  <span className="toolTip01">Heiken Ashi</span>
                                </button>
                              </li>
                              {/* <!-- <li className="nav-item" role="presentation">
                                          <button className="nav-link" id="barstab-tab" data-bs-toggle="tab" data-bs-target="#barstab" type="button" role="tab" aria-controls="barstab" aria-selected="false"><img src="images/bars.svg"></button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                          <button className="nav-link" id="heikenashitab-tab" data-bs-toggle="tab" data-bs-target="#heikenashitab" type="button" role="tab" aria-controls="heikenashitab" aria-selected="false"><img src="images/chain.svg"></button>
                                        </li> --> */}
                            </ul>
                            <div className="tab-content" id="myTabContent">
                              <div
                                className="tab-pane fade"
                                id="linetab"
                                role="tabpanel"
                                aria-labelledby="linetab-tab"
                              >
                                <h5 className="smalltitle">{t("Settings")}</h5>
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={linesettings?.showarea}
                                      onChange={(e) =>
                                        setLinesettings((state) => ({
                                          ...state,
                                          showarea: e.target.checked,
                                        }))
                                      }
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    {t("Show Area")}
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={linesettings?.autoscroll}
                                      onChange={(e) =>
                                        setLinesettings((state) => ({
                                          ...state,
                                          autoscroll: e.target.checked,
                                        }))
                                      }
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    {t("Enable Autoscroll")}
                                  </label>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade show active"
                                id="candlestab"
                                role="tabpanel"
                                aria-labelledby="candlestab-tab"
                              >
                                <h5 className="smalltitle pb-0">
                                  {t("Time Frames")}
                                </h5>
                                <ul className="timeframes">
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "second",
                                        value: "5",
                                        duration: "S5",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "second" &&
                                        candletimer?.value === "5"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      S5
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "second",
                                        value: "10",
                                        duration: "S10",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "second" &&
                                        candletimer?.value === "10"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      S10
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "second",
                                        value: "15",
                                        duration: "S15",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "second" &&
                                        candletimer?.value === "15"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      S15
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "second",
                                        value: "30",
                                        duration: "S30",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "second" &&
                                        candletimer?.value === "30"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      S30
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "1",
                                        duration: "M1",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "1"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M1
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "2",
                                        duration: "M2",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "2"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M2
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "3",
                                        duration: "M3",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "3"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M3
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "5",
                                        duration: "M5",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "5"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M5
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "10",
                                        duration: "M10",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "10"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M10
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "15",
                                        duration: "M15",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "15"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M15
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "minute",
                                        value: "30",
                                        duration: "M30",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "minute" &&
                                        candletimer?.value === "30"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      M30
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "hour",
                                        value: "1",
                                        duration: "H1",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "hour" &&
                                        candletimer?.value === "1"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      H1
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "hour",
                                        value: "4",
                                        duration: "H4",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "hour" &&
                                        candletimer?.value === "4"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      H4
                                    </button>
                                  </li>
                                  <li
                                    onClick={() =>
                                      timefreamprefrence({
                                        type: "day",
                                        value: "1",
                                        duration: "D1",
                                      })
                                    }
                                  >
                                    <button
                                      type="button"
                                      className={`btn ${
                                        candletimer?.type === "day" &&
                                        candletimer?.value === "1"
                                          ? "active"
                                          : ""
                                      }`}
                                    >
                                      D1
                                    </button>
                                  </li>
                                </ul>
                                <h5 className="smalltitle">{t("Settings")}</h5>
                                <div>
                                  <div className="form-check form-switch form-switch-left">
                                    <div className="check-input-div">
                                      <input
                                        onChange={(e) =>
                                          setStoptimmer(!stoptimmer)
                                        }
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={stoptimmer}
                                      />
                                    </div>
                                    <label className="form-check-label">
                                      {t("Enable timer")}
                                    </label>
                                  </div>
                                  <div className="form-check form-switch form-switch-left">
                                    <div className="check-input-div">
                                      <input
                                        onChange={(e) =>
                                          toggleAutoScroll(e.target.checked)
                                        }
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                    </div>
                                    <label className="form-check-label">
                                      {t("Enable autoscroll")}
                                    </label>
                                  </div>
                                  {/*  <div className="form-check form-switch form-switch-left">
                                    <div className="check-input-div">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked
                                      />
                                    </div>
                                    <label className="form-check-label">
                                      {t("Enable grid snap")}
                                    </label>
                                  </div>*/}
                                  <div className="tablinkcol">
                                    <button
                                      onClick={() =>
                                        openModal("chartThemeColor")
                                      }
                                      className="link"
                                      // data-bs-toggle="modal"
                                      // data-bs-target="#chartThemeColor"
                                    >
                                      {t("Settings")}
                                    </button>
                                  </div>
                                </div>
                              </div>
                              {/* <!-- <div className="tab-pane fade" id="barstab" role="tabpanel" aria-labelledby="barstab-tab">
                                        <h5 className="smalltitle">...</h5>
                                        </div>
                                        <div className="tab-pane fade" id="heikenashitab" role="tabpanel" aria-labelledby="heikenashitab-tab">
                                        <h5 className="smalltitle">...</h5>
                                        </div> --> */}
                            </div>
                          </div>
                          <div className="popBeforeOverlay"></div>
                          <button
                            data-bs-toggle="collapse"
                            // href="#stocktradeCollapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="stocktradeCollapse"
                            onClick={() =>
                              handleToggleCollapse("stocktradeCollapse")
                            }
                          >
                            {tradestyle === "3" ? (
                              <img
                                src={lineup}
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                data-bs-original-title="Line"
                                alt=""
                              />
                            ) : tradestyle === "2" ? (
                              <img
                                src={bars}
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                data-bs-original-title="Bars"
                                alt=""
                              />
                            ) : tradestyle === "5" ? (
                              <img
                                src={chain}
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                data-bs-original-title="Heiken Ashi"
                                alt=""
                              />
                            ) : (
                              <svg
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                data-bs-original-title="Chart type: Line"
                                width="17"
                                height="16"
                                viewBox="0 0 17 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.43685 3.33521H7.43686V9.3352H5.43685V11.3352H4.10352V9.3352H2.10352V3.33521H4.10352V1.33521H5.43685V3.33521ZM12.1035 6.66853H14.1035V12.6685H12.1035V14.6685H10.7702V12.6685H8.7702V6.66853H10.7702V4.66854H12.1035V6.66853Z"
                                  fill="white"
                                />
                              </svg>
                            )}

                            <span className="alertShow">
                              {candletimer?.duration}
                            </span>
                          </button>
                        </div>
                        {/* <div className="position-relative">
                          <div
                            className="collapsePop collapse"
                            id="stockotherCollapse"
                          >
                            <div className="otherOption">
                              <div className="position-relative">
                                <button
                                  data-bs-toggle="collapse"
                                  // href="#stockelementCollapse"
                                  role="button"
                                  aria-expanded="false"
                                  aria-controls="stockelementCollapse"
                                  onClick={() =>
                                    handleToggleCollapse("stockelementCollapse")
                                  }
                                >
                                  <svg
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="bottom"
                                    data-bs-original-title="Multi Chart"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M14.6667 7.26659V2.73325C14.6667 1.73325 14.24 1.33325 13.18 1.33325H10.4867C9.42667 1.33325 9 1.73325 9 2.73325V7.26659C9 8.26659 9.42667 8.66659 10.4867 8.66659H13.18C14.24 8.66659 14.6667 8.26659 14.6667 7.26659Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M14.6667 13.2667V12.0667C14.6667 11.0667 14.24 10.6667 13.18 10.6667H10.4867C9.42667 10.6667 9 11.0667 9 12.0667V13.2667C9 14.2667 9.42667 14.6667 10.4867 14.6667H13.18C14.24 14.6667 14.6667 14.2667 14.6667 13.2667Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M6.99967 8.73325V13.2666C6.99967 14.2666 6.57301 14.6666 5.51301 14.6666H2.81967C1.75967 14.6666 1.33301 14.2666 1.33301 13.2666V8.73325C1.33301 7.73325 1.75967 7.33325 2.81967 7.33325H5.51301C6.57301 7.33325 6.99967 7.73325 6.99967 8.73325Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M6.99967 2.73325V3.93325C6.99967 4.93325 6.57301 5.33325 5.51301 5.33325H2.81967C1.75967 5.33325 1.33301 4.93325 1.33301 3.93325V2.73325C1.33301 1.73325 1.75967 1.33325 2.81967 1.33325H5.51301C6.57301 1.33325 6.99967 1.73325 6.99967 2.73325Z"
                                      fill="white"
                                    />
                                  </svg>
                                </button>
                                <div
                                  className="collapsePop sub-collapsePop collapse"
                                  id="stockelementCollapse"
                                >
                                  <div className="elementCollapsebox">
                                    <div className="p-3 mboderbottom">
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            width="24"
                                            height="24"
                                            rx="2"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                    <div className="p-3 mboderbottom">
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            width="24"
                                            height="10"
                                            rx="2"
                                            fill="white"
                                          />
                                          <rect
                                            y="14"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="22"
                                          height="24"
                                          viewBox="0 0 22 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 0 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="12"
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 12 24)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                    <div className="p-3 mboderbottom">
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            width="24"
                                            height="10"
                                            rx="2"
                                            fill="white"
                                          />
                                          <rect
                                            y="14"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            fill="white"
                                          />
                                          <rect
                                            x="14"
                                            y="14"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="24"
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 24 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="24"
                                            y="10"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 24 10)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            y="10"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 10 10)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(90 24 0)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(90 10 0)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            y="14"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(90 10 14)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 0 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="14"
                                            y="24"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 14 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="14"
                                            y="10"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 14 10)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="38"
                                          height="24"
                                          viewBox="0 0 38 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 0 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="14"
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 14 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="28"
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 28 24)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                    <div className="p-3">
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="24"
                                            y="10"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 24 10)"
                                            fill="white"
                                          />
                                          <rect
                                            x="24"
                                            y="24"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 24 24)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            y="10"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 10 10)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            y="24"
                                            width="10"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 10 24)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="14.7695"
                                            y="10"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(-180 14.7695 10)"
                                            fill="white"
                                          />
                                          <rect
                                            x="24"
                                            y="10"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(-180 24 10)"
                                            fill="white"
                                          />
                                          <rect
                                            x="5.53809"
                                            y="10"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(-180 5.53809 10)"
                                            fill="white"
                                          />
                                          <rect
                                            x="24"
                                            y="24"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-180 24 24)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="14"
                                            y="14.7697"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(-90 14 14.7697)"
                                            fill="white"
                                          />
                                          <rect
                                            x="14"
                                            y="24.0001"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(-90 14 24.0001)"
                                            fill="white"
                                          />
                                          <rect
                                            x="14"
                                            y="5.53821"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(-90 14 5.53821)"
                                            fill="white"
                                          />
                                          <rect
                                            y="24.0001"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(-90 0 24.0001)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="9.23047"
                                            y="14"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            fill="white"
                                          />
                                          <rect
                                            y="14"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            fill="white"
                                          />
                                          <rect
                                            x="18.4619"
                                            y="14"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            fill="white"
                                          />
                                          <rect
                                            width="24"
                                            height="10"
                                            rx="2"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                      <button>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <rect
                                            x="10"
                                            y="9.23022"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(90 10 9.23022)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            y="-0.000244141"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(90 10 -0.000244141)"
                                            fill="white"
                                          />
                                          <rect
                                            x="10"
                                            y="18.4617"
                                            width="5.53846"
                                            height="10"
                                            rx="1.84615"
                                            transform="rotate(90 10 18.4617)"
                                            fill="white"
                                          />
                                          <rect
                                            x="24"
                                            y="-0.000244141"
                                            width="24"
                                            height="10"
                                            rx="2"
                                            transform="rotate(90 24 -0.000244141)"
                                            fill="white"
                                          />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <button
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                data-bs-original-title="Social Trading"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.9997 2.00004L9.99967 2.00004M13.9997 4.66671L9.99967 4.66671M13.9997 7.33337L9.99967 7.33337M3.66634 9.17189V3.00004C3.66634 2.07957 4.41253 1.33337 5.33301 1.33337C6.25348 1.33337 6.99967 2.07957 6.99967 3.00004V9.17189C7.80367 9.71006 8.33301 10.6266 8.33301 11.6667C8.33301 13.3236 6.98986 14.6667 5.33301 14.6667C3.67615 14.6667 2.33301 13.3236 2.33301 11.6667C2.33301 10.6266 2.86235 9.71006 3.66634 9.17189ZM5.99967 11.6667C5.99967 12.0349 5.7012 12.3334 5.33301 12.3334C4.96482 12.3334 4.66634 12.0349 4.66634 11.6667C4.66634 11.2985 4.96482 11 5.33301 11C5.7012 11 5.99967 11.2985 5.99967 11.6667Z"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                              <button
                                data-bs-toggle="tooltip"
                                data-bs-placement="bottom"
                                data-bs-original-title="Market Watch"
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.10671 7.24659C6.04004 7.23992 5.96004 7.23992 5.88671 7.24659C4.30004 7.19325 3.04004 5.89325 3.04004 4.29325C3.04004 2.65992 4.36004 1.33325 6.00004 1.33325C7.63337 1.33325 8.96004 2.65992 8.96004 4.29325C8.95337 5.89325 7.69337 7.19325 6.10671 7.24659Z"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.9402 2.66675C12.2335 2.66675 13.2735 3.71341 13.2735 5.00008C13.2735 6.26008 12.2735 7.28675 11.0268 7.33341C10.9735 7.32675 10.9135 7.32675 10.8535 7.33341"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M2.77348 9.70675C1.16014 10.7867 1.16014 12.5467 2.77348 13.6201C4.60681 14.8467 7.61348 14.8467 9.44681 13.6201C11.0601 12.5401 11.0601 10.7801 9.44681 9.70675C7.62014 8.48675 4.61348 8.48675 2.77348 9.70675Z"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M12.2266 13.3333C12.7066 13.2333 13.1599 13.0399 13.5332 12.7533C14.5732 11.9733 14.5732 10.6866 13.5332 9.90659C13.1666 9.62659 12.7199 9.43992 12.2466 9.33325"
                                    stroke="white"
                                    stroke-width="1.2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <button
                            data-bs-toggle="collapse"
                            // href="#stockotherCollapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="stockotherCollapse"
                            onClick={() =>
                              handleToggleCollapse("stockotherCollapse")
                            }
                          >
                            <svg
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M8.10026 8.66663C8.46845 8.66663 8.76693 8.36815 8.76693 7.99996C8.76693 7.63177 8.46845 7.33329 8.10026 7.33329C7.73207 7.33329 7.43359 7.63177 7.43359 7.99996C7.43359 8.36815 7.73207 8.66663 8.10026 8.66663Z"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.10026 3.99996C8.46845 3.99996 8.76693 3.70148 8.76693 3.33329C8.76693 2.9651 8.46845 2.66663 8.10026 2.66663C7.73207 2.66663 7.43359 2.9651 7.43359 3.33329C7.43359 3.70148 7.73207 3.99996 8.10026 3.99996Z"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.10026 13.3333C8.46845 13.3333 8.76693 13.0348 8.76693 12.6666C8.76693 12.2984 8.46845 12 8.10026 12C7.73207 12 7.43359 12.2984 7.43359 12.6666C7.43359 13.0348 7.73207 13.3333 8.10026 13.3333Z"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div> */}
                        <div className="position-relative">
                          <div
                            className="collapsePop collapse"
                            id="stocksettingCollapse"
                          >
                            <div className="leftviewtabs">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className={`nav-link ${
                                      !opentimezon && "active"
                                    }`}
                                    id="tradingmode-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#tradingmode"
                                    type="button"
                                    role="tab"
                                    aria-controls="tradingmode"
                                    aria-selected="true"
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M2 2V19C2 20.66 3.34 22 5 22H22"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M5 17L9.59 11.64C10.35 10.76 11.7 10.7 12.52 11.53L13.47 12.48C14.29 13.3 15.64 13.25 16.4 12.37L21 7"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    {t("Trading Button")}
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="Languages-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#Languages"
                                    type="button"
                                    role="tab"
                                    aria-controls="Languages"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="25"
                                      height="24"
                                      viewBox="0 0 25 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.3982 17H20.4564M13.3982 17L11.516 21M13.3982 17L16.2172 11.009C16.4444 10.5263 16.5579 10.2849 16.7133 10.2086C16.8485 10.1423 17.006 10.1423 17.1412 10.2086C17.2966 10.2849 17.4102 10.5263 17.6373 11.009L20.4564 17M20.4564 17L22.3386 21M2.66113 5H8.56436M8.56436 5H12.0079M8.56436 5V3M12.0079 5H14.4676M12.0079 5C11.5198 7.95729 10.3871 10.6362 8.72724 12.8844M10.5321 14C9.92945 13.7248 9.31471 13.3421 8.72724 12.8844M8.72724 12.8844C7.39652 11.8478 6.20579 10.4266 5.61275 9M8.72724 12.8844C7.14843 15.0229 5.09271 16.7718 2.66113 18"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    {t("Languages")}
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="soundcontrol-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#soundcontrol"
                                    type="button"
                                    role="tab"
                                    aria-controls="soundcontrol"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="25"
                                      height="24"
                                      viewBox="0 0 25 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.34961 8.25V15.75"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.9248 5.75V18.25"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M12.5 3.25V20.75"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M17.0752 5.75V18.25"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M21.6494 8.25V15.75"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    {t("Sound control")}
                                  </button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="theme-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#theme"
                                    type="button"
                                    role="tab"
                                    aria-controls="theme"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="25"
                                      height="24"
                                      viewBox="0 0 25 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M9.54823 22H15.4515C20.3708 22 22.3386 20 22.3386 15V9C22.3386 4 20.3708 2 15.4515 2H9.54823C4.62887 2 2.66113 4 2.66113 9V15C2.66113 20 4.62887 22 9.54823 22Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M12.5 2V22"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M2.66113 12H22.3386"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    Theme
                                  </button>
                                </li> */}
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="tooltips-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#tooltips"
                                    type="button"
                                    role="tab"
                                    aria-controls="tooltips"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    {t("Tooltips")}
                                  </button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="indicators-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#indicators"
                                    type="button"
                                    role="tab"
                                    aria-controls="indicators"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="25"
                                      height="24"
                                      viewBox="0 0 25 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M16.4353 2H8.56436C4.62887 2 2.66113 4 2.66113 8V21C2.66113 21.55 3.10387 22 3.645 22H16.4353C20.3708 22 22.3386 20 22.3386 16V8C22.3386 4 20.3708 2 16.4353 2Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M13.3955 7.83991L8.28919 13.0299C8.09241 13.2299 7.90549 13.6199 7.86613 13.8999L7.59065 15.8799C7.49226 16.5999 7.98419 17.0999 8.69258 16.9999L10.6406 16.7199C10.9161 16.6799 11.2998 16.4899 11.4966 16.2899L16.6029 11.0999C17.4786 10.2099 17.9016 9.16991 16.6029 7.84991C15.3042 6.51991 14.281 6.93991 13.3955 7.83991Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M12.667 8.57983C13.0999 10.1498 14.3101 11.3898 15.8646 11.8298"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-miterlimit="10"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    Indicators
                                  </button>
                                </li> */}
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="chart-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#chart"
                                    type="button"
                                    role="tab"
                                    aria-controls="chart"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="25"
                                      height="24"
                                      viewBox="0 0 25 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_2619_1928)">
                                        <path
                                          d="M11.1273 9.29999C11.1273 9.67999 10.985 10.04 10.7512 10.3C10.4665 10.66 10.0293 10.88 9.52098 10.88C8.96181 10.88 8.48399 10.61 8.19932 10.19C8.01632 9.93999 7.9248 9.62998 7.9248 9.30998C7.9248 8.43998 8.63649 7.73999 9.53115 7.73999C10.4258 7.73999 11.1273 8.43998 11.1273 9.30998V9.29999Z"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M17.0746 14.6999C17.0746 15.5699 16.3629 16.2699 15.4682 16.2699C14.5736 16.2699 13.8721 15.5699 13.8721 14.6999C13.8721 14.3499 13.9941 14.0299 14.1974 13.7699C14.4821 13.3799 14.9396 13.1299 15.4784 13.1299C16.0173 13.1299 16.5154 13.3999 16.8001 13.8199C16.9831 14.0699 17.0746 14.3799 17.0746 14.6999V14.6999Z"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M14.0549 13.5799L10.8828 10.4199"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M21.6502 8.97998L17.0752 13.48"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M3.34961 15.0099L8.0466 10.3899"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M17.5829 3H7.41628C5.17032 3 3.34961 4.79086 3.34961 7V17C3.34961 19.2091 5.17032 21 7.41628 21H17.5829C19.8289 21 21.6496 19.2091 21.6496 17V7C21.6496 4.79086 19.8289 3 17.5829 3Z"
                                          stroke="white"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_2619_1928">
                                          <rect
                                            width="24.4"
                                            height="24"
                                            fill="white"
                                            transform="translate(0.299805)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>{" "}
                                    {t("Chart")}
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className={`nav-link ${
                                      opentimezon && "active"
                                    }`}
                                    id="timezone-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#timezone"
                                    type="button"
                                    role="tab"
                                    aria-controls="timezone"
                                    aria-selected="false"
                                  >
                                    <svg
                                      width="25"
                                      height="24"
                                      viewBox="0 0 25 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M22.3386 12C22.3386 6.48 17.9308 2 12.4998 2C7.06887 2 2.66113 6.48 2.66113 12C2.66113 17.52 7.06887 22 12.4998 22"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M8.56442 3H9.54829C7.62974 8.84 7.62974 15.16 9.54829 21H8.56442"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M15.4512 3C16.4055 5.92 16.8876 8.96 16.8876 12"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M3.64551 16V15C6.51841 15.97 9.50938 16.46 12.5003 16.46"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M3.64551 9.0001C9.39131 7.0501 15.6094 7.0501 21.3552 9.0001"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M21.2139 17.74C21.2139 19.4604 19.8401 20.8566 18.1475 20.8566C16.4548 20.8566 15.0811 19.4604 15.0811 17.74C15.0811 16.0196 16.4548 14.6233 18.1475 14.6233C19.8401 14.6233 21.2139 16.0196 21.2139 17.74Z"
                                        stroke="white"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M19.2853 18.7311L18.3347 18.1545C18.1691 18.0547 18.0342 17.8148 18.0342 17.6184V16.3406"
                                        stroke="white"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    {t("Timezone")}
                                  </button>
                                </li>

                                {/* <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="islamicaccount-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#islamicaccount"
                                    type="button"
                                    role="tab"
                                    aria-controls="islamicaccount"
                                    aria-selected="false"
                                  >
                                    <img src={islamicaccount} alt="" /> Islamic
                                    account
                                  </button>
                                </li> */}
                              </ul>
                              <div className="tab-content" id="myTabContent">
                                <div
                                  className={`tab-pane fade${
                                    !opentimezon && " show active"
                                  }`}
                                  id="tradingmode"
                                  role="tabpanel"
                                  aria-labelledby="tradingmode-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t("Your Preferred Trading mode")}
                                  </h5>
                                  <div
                                    className={`position-relative trading_mode_body boxbg mb-3 ${
                                      classNameicMode && "active"
                                    }`}
                                    onClick={() =>
                                      setsettingprefrence(
                                        true,
                                        soundEnabled,
                                        showtooltip,
                                      )
                                    }
                                    style={{
                                      border: classNameicMode
                                        ? "1px dashed #fff"
                                        : "1px dashed #0000",
                                    }}
                                  >
                                    <div
                                      className={`d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 ${
                                        !settingloader?.classic && "d-none"
                                      }`}
                                      style={{
                                        zIndex: 1,
                                        backgroundColor: "rgb(0 0 0)",
                                        borderRadius: "10px",
                                        height: "100%",
                                      }}
                                    >
                                      <svg
                                        className="ajax-loader-v2__icon"
                                        width="64"
                                        height="64"
                                        xmlns="http://www.w3.org/2000/svg"
                                        shapeRendering="geometricPrecision"
                                        textRendering="geometricPrecision"
                                        viewBox="0 0 64 64"
                                        style={{ whiteSpace: "pre" }}
                                      >
                                        <style>
                                          {`
          @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
          @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
          @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
          @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
          @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
          @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
          @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
          @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
          @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
          @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
        `}
                                        </style>

                                        <rect
                                          width="2"
                                          height="37"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="19.5"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                                          }}
                                        />
                                        <rect
                                          width="2"
                                          height="42"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="21"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                                          }}
                                        />
                                        <rect
                                          width="2"
                                          height="28"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="16"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                                          }}
                                        />
                                        <rect
                                          width="2"
                                          height="40"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="23"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                                          }}
                                        />
                                      </svg>
                                    </div>
                                    <div className="content-col">
                                      <label>{t("Classic Mode")}</label>
                                      <p>
                                        {t("Trade Using Two Buttons:")}{" "}
                                        <span>{t("“Buy” or “Sell”")}</span>
                                      </p>
                                    </div>
                                    <div className="pop_btn">
                                      <Link
                                        className="btn bg_btn butBtn"
                                        to="#"
                                      >
                                        <img src={buyicon} alt="Buy" />{" "}
                                        {t("Buy")}
                                      </Link>
                                      <Link
                                        className="btn bg_btn sellBtn"
                                        to="#"
                                      >
                                        <img src={sellicon} alt="Sell" />{" "}
                                        {t("Sell")}
                                      </Link>
                                    </div>
                                  </div>
                                  <div
                                    onClick={() =>
                                      setsettingprefrence(
                                        false,
                                        soundEnabled,
                                        showtooltip,
                                      )
                                    }
                                    className={`position-relative trading_mode_body boxbg ${
                                      !classNameicMode && "active"
                                    }`}
                                    style={{
                                      border: !classNameicMode
                                        ? "1px dashed #fff"
                                        : "1px dashed #0000",
                                    }}
                                  >
                                    <div
                                      className={`d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 ${
                                        !settingloader?.default && "d-none"
                                      }`}
                                      style={{
                                        zIndex: 1,
                                        backgroundColor: "rgb(0 0 0)",
                                        borderRadius: "10px",
                                        height: "100%",
                                      }}
                                    >
                                      <svg
                                        className="ajax-loader-v2__icon"
                                        width="64"
                                        height="64"
                                        xmlns="http://www.w3.org/2000/svg"
                                        shapeRendering="geometricPrecision"
                                        textRendering="geometricPrecision"
                                        viewBox="0 0 64 64"
                                        style={{ whiteSpace: "pre" }}
                                      >
                                        <style>
                                          {`
          @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
          @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
          @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
          @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
          @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
          @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
          @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
          @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
          @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
          @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
          @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
        `}
                                        </style>

                                        <rect
                                          width="2"
                                          height="37"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="19.5"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                                          }}
                                        />
                                        <rect
                                          width="2"
                                          height="42"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="21"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                                          }}
                                        />
                                        <rect
                                          width="2"
                                          height="28"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="16"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                                          }}
                                        />
                                        <rect
                                          width="2"
                                          height="40"
                                          fill="#fff"
                                          opacity="0"
                                          transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                                          }}
                                        />
                                        <rect
                                          width="10"
                                          height="23"
                                          fill="#fff"
                                          rx="1"
                                          opacity="0"
                                          transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                                          style={{
                                            animation:
                                              "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                                          }}
                                        />
                                      </svg>
                                    </div>
                                    <div className="content-col">
                                      <label>{t("Default Mode")}</label>
                                      <p>
                                        {t("Trade Using Two Buttons:")}{" "}
                                        <span>{t("“Buy” or “Sell”")}</span>
                                      </p>
                                    </div>
                                    <div className="defaultmode_btn pop_btn">
                                      <Link
                                        className="btn bg_btn butBtn"
                                        to=""
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <img src={buyicon} alt="Buy" />{" "}
                                        {t("Buy")}
                                      </Link>
                                      <Link
                                        className="btn bg_btn sellBtn"
                                        to=""
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <img src={sellicon} alt="Sell" />{" "}
                                        {t("Sell")}
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="Languages"
                                  role="tabpanel"
                                  aria-labelledby="Languages-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t("Select interface language.")}
                                  </h5>
                                  <form action="#" className="boxbg">
                                    <label>Language</label>
                                    <LanguageSelector />
                                  </form>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="soundcontrol"
                                  role="tabpanel"
                                  aria-labelledby="soundcontrol-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t(
                                      "Use the sound control settings to enable or disable sound notification for your trading orders.",
                                    )}
                                  </h5>
                                  <div className="boxbg formCheckinput011 pb-0">
                                    <Settings
                                      text={"Sound Control"}
                                      checked={soundEnabled}
                                      setsettingprefrence={setsettingprefrence}
                                      classNameicMode={classNameicMode}
                                      showtooltip={showtooltip}
                                      soundEnabled={soundEnabled}
                                    />

                                    <div className="form-check form-switch">
                                      <input
                                        onChange={(e) =>
                                          setsoundbalancepre(
                                            e.target.checked,
                                            soundEnabled,
                                          )
                                        }
                                        checked={soundbalanceref.current}
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                      <label className="form-check-label">
                                        {t("Balance")}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="theme"
                                  role="tabpanel"
                                  aria-labelledby="theme-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t(
                                      "Use the theme control settings to switch between the light and dark themes of the website.",
                                    )}
                                  </h5>
                                  <div
                                    className="btn-group"
                                    role="group"
                                    aria-label="Basic mixed styles example"
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-dark active"
                                    >
                                      Light theme
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-dark"
                                    >
                                      Blue theme
                                    </button>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="tooltips"
                                  role="tabpanel"
                                  aria-labelledby="tooltips-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t(
                                      "Use the Tooltips control settings to enable or disable the trade order results rendering on the trading interface",
                                    )}
                                  </h5>
                                  <div className="boxbg formCheckinput011 pb-0">
                                    <Settings
                                      text={"Tooltips"}
                                      checked={showtooltip}
                                      setsettingprefrence={setsettingprefrence}
                                      classNameicMode={classNameicMode}
                                      showtooltip={showtooltip}
                                      soundEnabled={soundEnabled}
                                    />
                                    {/* <div className="form-check form-switch">
                                      <div className="check-input-div">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={showtooltip}
                                          onChange={(e) =>
                                            setsettingprefrence(
                                              classNameicMode,
                                              soundEnabled,
                                              e.target.checked
                                            )
                                          }
                                        />
                                      </div>
                                      <label className="form-check-label">
                                        {t("Tooltips")}
                                      </label>
                                    </div> */}
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="indicators"
                                  role="tabpanel"
                                  aria-labelledby="indicators-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t(
                                      "Use the indicators control settings to enable or disable the appropriate indicator icon rendering on the trading interface.",
                                    )}
                                  </h5>
                                  <div className="boxbg pb-0">
                                    <div className="form-check form-switch">
                                      <div className="check-input-div">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          // checked
                                        />
                                      </div>
                                      <label className="form-check-label">
                                        Signals
                                      </label>
                                    </div>
                                    <div className="form-check form-switch">
                                      <div className="check-input-div">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          // checked
                                        />
                                      </div>
                                      <label className="form-check-label">
                                        Analytics
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="chart"
                                  role="tabpanel"
                                  aria-labelledby="chart-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t(
                                      "Use the chart settings to tune the rendering preferences. The page will be reloaded automatically.",
                                    )}
                                  </h5>
                                  <div className="boxbg pb-0">
                                    <div className="form-check form-switch">
                                      <div className="check-input-div">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          onChange={(e) =>
                                            svgeprefrence(e.target.checked)
                                          }
                                          checked={showgraphsvg}
                                        />
                                      </div>
                                      <label className="form-check-label">
                                        Chart Info
                                      </label>
                                    </div>
                                  </div>

                                  <ul
                                    className="nav nav-tabs horizTab"
                                    id="myTab"
                                    role="tablist"
                                  >
                                    <li
                                      className="nav-item"
                                      role="presentation"
                                    >
                                      <button
                                        className="nav-link active"
                                        id="candle-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#candle"
                                        type="button"
                                        role="tab"
                                        aria-controls="candle"
                                        aria-selected="true"
                                      >
                                        {t("Candle")}
                                      </button>
                                    </li>
                                    {/* <li className="nav-item" role="presentation">
                                      <button
                                        className="nav-link"
                                        id="canvas-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#canvas"
                                        type="button"
                                        role="tab"
                                        aria-controls="canvas"
                                        aria-selected="false"
                                      >
                                        {t("Canvas")}
                                      </button>
                                    </li> */}
                                  </ul>
                                  <div
                                    className="tab-content horizTabcontent"
                                    id="myTabContent"
                                  >
                                    <div
                                      className="tab-pane fade show active"
                                      id="candle"
                                      role="tabpanel"
                                      aria-labelledby="candle-tab"
                                    >
                                      {/* <div className="form-check d-flex p-0 mb-3">
                                        <input
                                          className="check-form-input"
                                          type="checkbox"
                                          value=""
                                          id="colorBars"
                                        />
                                        <label
                                          className="check-form-label"
                                          for="colorBars"
                                        >
                                          {t(
                                            "Color Bars Based on previous Close"
                                          )}
                                        </label>
                                      </div> */}

                                      <div className="colorOption">
                                        <div>
                                          <label>{t("Body")}</label>
                                          <div className="inpuBox">
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value={
                                                customcaldle?.upColor
                                                  ? customcaldle?.upColor
                                                  : "#4CAF50"
                                              }
                                              onChange={(e) =>
                                                setCustomcaldle((state) => ({
                                                  ...state,
                                                  upColor: e.target.value,
                                                }))
                                              }
                                            />
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value={customcaldle?.downColor}
                                              onChange={(e) =>
                                                setCustomcaldle((state) => ({
                                                  ...state,
                                                  downColor: e.target.value,
                                                }))
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div>
                                          <label>{t("Borders")}</label>
                                          <div className="inpuBox">
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value={
                                                customcaldle?.borderUpColor
                                              }
                                              onChange={(e) =>
                                                setCustomcaldle((state) => ({
                                                  ...state,
                                                  borderUpColor: e.target.value,
                                                }))
                                              }
                                            />
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value={
                                                customcaldle?.borderDownColor
                                              }
                                              onChange={(e) =>
                                                setCustomcaldle((state) => ({
                                                  ...state,
                                                  borderDownColor:
                                                    e.target.value,
                                                }))
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div>
                                          <label>{t("Wick")}</label>
                                          <div className="inpuBox">
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value={customcaldle?.wickUpColor}
                                              onChange={(e) =>
                                                setCustomcaldle((state) => ({
                                                  ...state,
                                                  wickUpColor: e.target.value,
                                                }))
                                              }
                                            />
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value={
                                                customcaldle?.wickDownColor
                                              }
                                              onChange={(e) =>
                                                setCustomcaldle((state) => ({
                                                  ...state,
                                                  wickDownColor: e.target.value,
                                                }))
                                              }
                                            />
                                          </div>
                                        </div>
                                        {/* <div>
                                          <label>{t("Themes Effect")}</label>
                                          <div className="inpuBox">
                                            <input
                                              type="color"
                                              id="favcolor"
                                              name="favcolor"
                                              value="#8FF8FC"
                                            />
                                          </div>
                                        </div> */}
                                      </div>
                                    </div>
                                    <div
                                      className="tab-pane fade"
                                      id="canvas"
                                      role="tabpanel"
                                      aria-labelledby="canvas-tab"
                                    >
                                      <div className="mboderbottom mb-3 pb-3">
                                        <h5 className="smalltitle p-0 mb-2">
                                          {t("Chart Styles")}
                                        </h5>
                                        <div className="colorOption">
                                          <div>
                                            <label>{t("Background")}</label>
                                            <div className="inpuBox">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                onChange={(e) =>
                                                  setupUpdatecanvas(
                                                    "Background",
                                                    "type",
                                                    e.target.value,
                                                  )
                                                }
                                              >
                                                <option
                                                  value="Solid"
                                                  selected=""
                                                >
                                                  {t("Solid")}
                                                </option>
                                                <option value="Dashed">
                                                  {t("Dashed")}
                                                </option>
                                                <option value="Dotted">
                                                  {t("Dotted")}
                                                </option>
                                                <option value="Unset">
                                                  {t("Unset")}
                                                </option>
                                              </select>
                                              <input
                                                type="color"
                                                id="favcolor"
                                                name="favcolor"
                                                value={
                                                  updatecanvas?.Background
                                                    ?.color
                                                }
                                                onChange={(e) =>
                                                  setupUpdatecanvas(
                                                    "Background",
                                                    "color",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>

                                          <div>
                                            <label>{t("Grid Lines")}</label>
                                            <div className="inpuBox">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                              >
                                                <option
                                                  value="None"
                                                  selected=""
                                                >
                                                  {t("None")}
                                                </option>
                                                <option value="Block">
                                                  {t("Block")}
                                                </option>
                                              </select>
                                              <input
                                                type="color"
                                                id="favcolor"
                                                name="favcolor"
                                                value={
                                                  updatecanvas?.GridLines?.color
                                                }
                                                onChange={(e) =>
                                                  setupUpdatecanvas(
                                                    "GridLines",
                                                    "color",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div>
                                            <label>{t("Crosshair")}</label>
                                            <div className="inpuBox">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                              >
                                                <option
                                                  value="------"
                                                  selected=""
                                                >
                                                  -------
                                                </option>
                                                <option value="......">
                                                  .......
                                                </option>
                                                <option value="=======">
                                                  =======
                                                </option>
                                              </select>
                                              <input
                                                type="color"
                                                id="favcolor"
                                                name="favcolor"
                                                value="#8FF8FC"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mboderbottom mb-3 pb-3">
                                        <h5 className="smalltitle p-0 mb-2 mt-3">
                                          {t("Scales")}
                                        </h5>
                                        <div className="colorOption">
                                          <div>
                                            <label>{t("Text")}</label>
                                            <div className="inpuBox">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                              >
                                                <option value="10" selected="">
                                                  10
                                                </option>
                                                <option value="12">12</option>
                                                <option value="14">14</option>
                                                <option value="16">16</option>
                                                <option value="18">18</option>
                                                <option value="20">20</option>
                                              </select>
                                              <input
                                                type="color"
                                                id="favcolor"
                                                name="favcolor"
                                                value="#8FF8FC"
                                              />
                                            </div>
                                          </div>
                                          <div>
                                            <label>{t("Lines")}</label>
                                            <div className="inpuBox">
                                              <input
                                                type="color"
                                                id="favcolor"
                                                name="favcolor"
                                                value="#0000"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {/*  <div className="mboderbottom mb-3 pb-3">
                                        <h5 className="smalltitle p-0 mb-2 mt-3">
                                          {t("Scales")}
                                        </h5>
                                        <div className="selectinputOption">
                                          <div>
                                            <label>{t("Navigation")}</label>
                                            <div className="selectOption">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                              >
                                                <option
                                                  value="Visible on Mouse Over"
                                                  selected=""
                                                >
                                                  {t("Visible on Mouse Over")}
                                                </option>
                                                <option value="Hidden on Mouse Over">
                                                  {t("Hidden on Mouse Over")}
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                          <div>
                                            <label>Pane</label>
                                            <div className="selectOption">
                                              <select
                                                className="form-select"
                                                aria-label="Default select example"
                                              >
                                                <option
                                                  value="Visible on Mouse Over"
                                                  selected=""
                                                >
                                                  {t("Visible on Mouse Over")}
                                                </option>
                                                <option value="Hidden on Mouse Over">
                                                  {t("Hidden on Mouse Over")}
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="">
                                        <h5 className="smalltitle p-0 mb-2">
                                          {t("Margins")}
                                        </h5>
                                        <div className="selectinputOption">
                                          <div>
                                            <label>{t("Top")}</label>
                                            <div className="inputOption">
                                              <div className="input-group">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="0"
                                                  value="10%"
                                                />
                                                <span className="input-group-text">
                                                  %
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <label>{t("Bottom")}</label>
                                            <div className="inputOption">
                                              <div className="input-group">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="0"
                                                  value="8%"
                                                />
                                                <span className="input-group-text">
                                                  %
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div>
                                            <label>{t("Right")}</label>
                                            <div className="inputOption">
                                              <div className="input-group">
                                                <input
                                                  type="number"
                                                  className="form-control"
                                                  placeholder="0"
                                                  value="10%"
                                                />
                                                <span className="input-group-text">
                                                  %
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div> */}
                                      <div className="btngroup mt-3">
                                        <button
                                          type="button"
                                          className="btn grayBtn"
                                        >
                                          {t("Cancel")}
                                        </button>
                                        <button
                                          onClick={() => saveupdatecanvas()}
                                          type="button"
                                          className="btn bgBtn"
                                        >
                                          {t("Save")}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`tab-pane fade${
                                    opentimezon && "show active"
                                  }`}
                                  id="timezone"
                                  role="tabpanel"
                                  aria-labelledby="timezone-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    {t(
                                      "Use the Timezone settings to set the desired timezone for the charts and Platform in general. Daily statements are still calculated by the server time",
                                    )}{" "}
                                    (UTC+2).
                                    <span>
                                      {"Your location:"}{" "}
                                      {updatetimezone?.timezone}{" "}
                                      {updatetimezone?.value}
                                    </span>
                                  </h5>
                                  <form action="#" className="boxbg">
                                    <label>Timezone</label>
                                    <TimezoneSelector
                                      setUpdateTimezone={setUpdateTimezone}
                                      updatetimezone={updatetimezone}
                                    />
                                  </form>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="islamicaccount"
                                  role="tabpanel"
                                  aria-labelledby="islamicaccount-tab"
                                >
                                  <h5 className="smallwhitetitle">
                                    Activating an Islamic halal account allows
                                    you to trade on the platform in compliance
                                    with Islamic finance principles.
                                  </h5>
                                  <div className="boxbg pb-0">
                                    <div className="form-check form-switch">
                                      <div className="check-input-div">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked=""
                                        />
                                      </div>
                                      <label className="form-check-label">
                                        Islamic halal account
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="popBeforeOverlay"></div>
                          <button
                            data-bs-toggle="collapse"
                            // href="#stocksettingCollapse"
                            role="button"
                            aria-expanded="false"
                            aria-controls="stocksettingCollapse"
                            onClick={() => {
                              handleToggleCollapse("stocksettingCollapse");
                              setOpentimezone(false);
                            }}
                          >
                            <svg
                              data-bs-toggle="tooltip"
                              data-bs-placement="bottom"
                              data-bs-original-title="Settings"
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.59824 8C5.59824 6.61799 6.71857 5.49766 8.10058 5.49766C9.48258 5.49766 10.6029 6.61799 10.6029 8C10.6029 9.382 9.48258 10.5023 8.10058 10.5023C6.71857 10.5023 5.59824 9.382 5.59824 8Z"
                                fill="white"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.68536 0.17615C7.91236 -0.0587168 8.28881 -0.0587168 8.51581 0.17615L10.4964 2.22536H13.2978C13.6167 2.22536 13.8752 2.4839 13.8752 2.80283V5.60422L15.9244 7.58477C16.1593 7.81177 16.1593 8.18823 15.9244 8.41523L13.8752 10.3958V13.1972C13.8752 13.5161 13.6167 13.7746 13.2978 13.7746H10.4964L8.51581 15.8238C8.28881 16.0587 7.91236 16.0587 7.68536 15.8238L5.70479 13.7746H2.90341C2.58449 13.7746 2.32595 13.5161 2.32595 13.1972V10.3958L0.276736 8.41522C0.0418695 8.18823 0.0418691 7.81177 0.276736 7.58477L2.32595 5.60421V2.80283C2.32595 2.4839 2.58449 2.22536 2.90341 2.22536H5.7048L7.68536 0.17615ZM8.10058 4.34273C6.08073 4.34273 4.44331 5.98015 4.44331 8C4.44331 10.0199 6.08073 11.6573 8.10058 11.6573C10.1204 11.6573 11.7578 10.0199 11.7578 8C11.7578 5.98015 10.1204 4.34273 8.10058 4.34273Z"
                                fill="white"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="tradeViewSec">
            <div className="container-fluid">
              <div className="row">
                <div className="col-xl-12  p-0">
                  {/* <!-- Symbol Search Modal start--> */}
                  <div className="symbolSearchModal">
                    {/* {searchpopup ?
                          <button
                      className="searchbtnpop"
                      data-bs-toggle="collapse"
                      // href="#symbolSearchCollapse"
                      role="button"
                      aria-expanded="false"
                      aria-controls="symbolSearchCollapse"
                      onClick={() =>
                        handleToggleCollapse("symbolSearchCollapse")
                      }
                    >
                      Search Popup
                    </button> :"" } */}

                    <div
                      className="collapsePop collapse"
                      id="symbolSearchCollapse"
                      ref={modalRef}
                    >
                      <div className="searchoption symbolsinput">
                        <button type="button" className="btn grayBtn searchbar">
                          <img src={searchnormal} alt="" />
                          <input
                            type="search"
                            className="searchinput"
                            value={searchTermall}
                            onChange={(e) => setSearchTermall(e.target.value)}
                            ref={inputRef}
                          />
                        </button>
                      </div>
                      <div
                        className="searchoption_body"
                        // style={{ display: "none" }}
                      >
                        <div className="searchoption searchoptionlist"></div>
                        <ul className="selectFavorite">
                          <li className="titleline">
                            <div className="currenciesOption">
                              <h6 className="title">Currencies</h6>
                            </div>
                            <div className="payoutOption">
                              <h6 className="title">Payout</h6>
                            </div>
                          </li>
                          {assetalllist?.length ? (
                            assetalllist.map((result, key) => {
                              return (
                                <li
                                  key={key}
                                  style={{ cursor: "pointer" }}
                                  className={`search-result-item ${
                                    !parseInt(result?.status) ? "d-none" : ""
                                  } ${
                                    hightlightref.current.index == key &&
                                    hightlightref.current?.show
                                      ? "highlighted"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    // 1. Set selected asset
                                    setshowtradeasset(result, "chartasset");
                                    setChartLoader(true);
                                    // 2. Close modal
                                    const collapseElement =
                                      document.getElementById(
                                        "symbolSearchCollapse",
                                      );
                                    if (
                                      collapseElement &&
                                      collapseElement.classList.contains("show")
                                    ) {
                                      new window.bootstrap.Collapse(
                                        collapseElement,
                                        { toggle: true },
                                      );
                                    }

                                    // 3. Reset search UI state
                                    showassetactive("cryptocurrency");
                                    setSearchTermall("");
                                  }}
                                >
                                  <div className="currenciesOption">
                                    {result?.favorite ? (
                                      <i
                                        onClick={(e) => {
                                          e.stopPropagation(); // Prevent item click from firing
                                          setfavs(result, false);
                                        }}
                                        style={{ color: "#ff9706" }}
                                        className="fa-solid fa-star del starSelect"
                                      ></i>
                                    ) : (
                                      <img
                                        onClick={(e) => {
                                          e.stopPropagation(); // Prevent item click from firing
                                          setfavs(result, true);
                                        }}
                                        src={star}
                                        className="starSelect"
                                        alt=""
                                      />
                                    )}
                                    <img
                                      src={
                                        process.env.REACT_APP_BASE_IMAGE_URL +
                                        result?.image
                                      }
                                      alt=""
                                    />
                                    <h5 className="title">
                                      {result?.name}{" "}
                                      <small>{result?.sortname}</small>
                                    </h5>
                                  </div>
                                  <div className="payoutOption">
                                    <h5 className="title">
                                      +{result?.payout}%
                                    </h5>
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            <div style={{ color: "#fff", textAlign: "center" }}>
                              {t("Assets Not Available")}
                            </div>
                          )}

                          {/* <li>
                            <div className="currenciesOption">
                              <img src={star} className="starSelect" alt="" />
                              <img src={tether} alt="" />
                              <h5 className="title">
                                Tether <small>USDT</small>
                              </h5>
                            </div>
                            <div className="payoutOption">
                              <h5 className="title">+90%</h5>
                            </div>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Symbol Search Modal end--> */}

                  <div className="tradeView">
                    <div className="timezonejs-Selector">
                      <div>{currentTime}</div>
                      <button
                        onClick={() => {
                          handleToggleCollapse("stocksettingCollapse");
                          setOpentimezone(true);
                        }}
                        data-bs-toggle="collapse"
                        // href="#timezonejsCollapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls="timezonejsCollapse"
                        className="collapsed"
                      >
                        <svg
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.59824 8C5.59824 6.61799 6.71857 5.49766 8.10058 5.49766C9.48258 5.49766 10.6029 6.61799 10.6029 8C10.6029 9.382 9.48258 10.5023 8.10058 10.5023C6.71857 10.5023 5.59824 9.382 5.59824 8Z"
                            fill="white"
                          ></path>
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.68536 0.17615C7.91236 -0.0587168 8.28881 -0.0587168 8.51581 0.17615L10.4964 2.22536H13.2978C13.6167 2.22536 13.8752 2.4839 13.8752 2.80283V5.60422L15.9244 7.58477C16.1593 7.81177 16.1593 8.18823 15.9244 8.41523L13.8752 10.3958V13.1972C13.8752 13.5161 13.6167 13.7746 13.2978 13.7746H10.4964L8.51581 15.8238C8.28881 16.0587 7.91236 16.0587 7.68536 15.8238L5.70479 13.7746H2.90341C2.58449 13.7746 2.32595 13.5161 2.32595 13.1972V10.3958L0.276736 8.41522C0.0418695 8.18823 0.0418691 7.81177 0.276736 7.58477L2.32595 5.60421V2.80283C2.32595 2.4839 2.58449 2.22536 2.90341 2.22536H5.7048L7.68536 0.17615ZM8.10058 4.34273C6.08073 4.34273 4.44331 5.98015 4.44331 8C4.44331 10.0199 6.08073 11.6573 8.10058 11.6573C10.1204 11.6573 11.7578 10.0199 11.7578 8C11.7578 5.98015 10.1204 4.34273 8.10058 4.34273Z"
                            fill="white"
                          ></path>
                        </svg>
                      </button>
                    </div>

                    {/* <!-- <img src="images/trade.png"> --> */}
                    <div className="tradingview-widget-container position-relative">
                      {chertloader && (
                        <div
                          className="chartinnerLoader d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100"
                          style={{
                            zIndex: 1,
                            height: "calc(100vh - 63px)",
                            backgroundColor: "#1b1a1f",
                          }}
                        >
                          <svg
                            className="ajax-loader-v2__icon"
                            width="64"
                            height="64"
                            xmlns="http://www.w3.org/2000/svg"
                            shapeRendering="geometricPrecision"
                            textRendering="geometricPrecision"
                            viewBox="0 0 64 64"
                            style={{ whiteSpace: "pre" }}
                          >
                            <style>
                              {`
        @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
        @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
        @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
        @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
        @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
        @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
        @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
        @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
        @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
      `}
                            </style>

                            <rect
                              width="2"
                              height="37"
                              fill="#fff"
                              opacity="0"
                              transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                              }}
                            />
                            <rect
                              width="10"
                              height="19.5"
                              fill="#fff"
                              rx="1"
                              opacity="0"
                              transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                              }}
                            />
                            <rect
                              width="2"
                              height="42"
                              fill="#fff"
                              opacity="0"
                              transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                              }}
                            />
                            <rect
                              width="10"
                              height="21"
                              fill="#fff"
                              rx="1"
                              opacity="0"
                              transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                              }}
                            />
                            <rect
                              width="2"
                              height="28"
                              fill="#fff"
                              opacity="0"
                              transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                              }}
                            />
                            <rect
                              width="10"
                              height="16"
                              fill="#fff"
                              rx="1"
                              opacity="0"
                              transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                              }}
                            />
                            <rect
                              width="2"
                              height="40"
                              fill="#fff"
                              opacity="0"
                              transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                              }}
                            />
                            <rect
                              width="10"
                              height="23"
                              fill="#fff"
                              rx="1"
                              opacity="0"
                              transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                              style={{
                                animation:
                                  "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                              }}
                            />
                          </svg>
                        </div>
                      )}

                      <div
                        ref={chartDiv}
                        id="tradingview-widget"
                        style={{
                          // zIndex: "9",
                          width: "100%",
                          float: "inline-end",
                          height: "calc(100vh - 63px)",
                          position: "relative",
                          opacity: chertloader ? 0.5 : 1, // Dim the chart when loading
                          pointerEvents: chertloader ? "none" : "auto", // Prevent interaction during loading
                        }}
                      ></div>

                      {tooltipData && showtooltip && (
                        <div
                          style={{
                            position: "absolute",
                            top: "622px",
                            left: "10px",
                            color: "white",
                            padding: "5px",
                            borderRadius: "4px",
                            zIndex: "9",
                          }}
                        >
                          <p>
                            {t("Open")}: {tooltipData.open}
                          </p>
                          <p>
                            {"High"}: {tooltipData.high}
                          </p>
                          <p>
                            {t("Low")}: {tooltipData.low}
                          </p>
                          <p>
                            {t("Close")}: {tooltipData.close}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="notification-container">
                  {notifications?.length ? (
                    <>
                      <div className="notification-pop">
                        {notifications.map((n) => (
                          <Notification key={n.id} {...n} />
                        ))}
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
        {/* <!-- -----------right sidebar start------------ --> */}
        <Dashboardrightsidemenus
          handleBuy={handleBuy}
          setDefaultwidth={setDefaultwidth}
          defaultwith={defaultwith}
          seriesRef={seriesRef}
          opentrade={opentrade}
          checkclosetrade={checkclosetrade}
          closelimit={closelimit}
          tradestyle={tradestyle}
          getsocialwatch={getsocialwatch}
          setWallupdate={setWallupdate}
          chnagetype={chnagetyperef.current}
          cryptocurrencieslist={assetlistpre?.cryptocurrencieslist}
          currencieslist={assetlistpre?.currencieslist}
          opentradedata={opentradedata}
          classNameicMode={classNameicMode}
          chnagetyperef={chnagetyperef}
          checkliveaccount={checkliveaccount}
          showgraphsvg={showgraphsvg}
          valueSeriesref={valueSeriesref}
          setSearchpopup={setSearchpopup}
          searchpopup={searchpopup}
          showLineAnimation={showLineAnimation}
          getFutureTimestamp={getFutureTimestamp}
          onHoverType={handleHoverFromChild}
          websoketrunning={websoketrunning.current}
          userDetails={userDetails}
          currenttimecheck={currenttimeref.current}
          updatetimezone={updatetimezone}
          serverTime={serverTime}
          peandingtrade={peandingtrade}
          showindicator={showindicator}
          callclosetradeapi={callclosetradeapi}
          assetlist={assetlistpre}
          setshowtradeasset={setshowtradeasset}
          setChartLoader={setChartLoader}
          soundEnabled={soundEnabled}
          setSoundEnabled={setSoundEnabled}
            closetradeapirun={closetradeapirun}
              setShowcopytrades={setShowcopytrades}
        />
        {/* <!-- -----------right sidebar end-------------- --> */}
        {/* <!-- -----------Delete model Start-------------- --> */}
      </div>
      <div
        ref={(el) => (modalRefs.current["deletemodel"] = el)}
        className="modal fade"
        id="deletemodel"
        tabindex="-1"
        aria-labelledby="deletemodelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <p>
                Are you sure you want to remove all indicators and drawings from
                your trading interface?
              </p>
              <div class="sidebar_btn">
                <div class="btn bg_btn butBtn" data-bs-dismiss="modal">
                  Cancel
                </div>
                <div
                  class="btn bg_btn butBtn afterbuyeffect"
                  onClick={() => deleteall()}
                >
                  {" "}
                  OK
                </div>
              </div>
              <div className="btnsGroup">
                <div>
                  {/* <Link
                         className="btn dark_btn facebookbtn"
                         to="https://www.facebook.com/equlixofficial/"
                         target="_blank"
                       >
                         <img src={facebook} alt="facebook.png" />
                         {t("Facebook")}
                       </Link>
                       <Link
                         onClick={() => handleClearData()}
                         className="btn dark_btn instagrambtn"
                         to="https://www.instagram.com/equlixofficial/"
                         target="_blank"
                       >
                         <img src={instagram} alt="instagram.png" />
                         {t("Instagram")}
                       </Link>
                       <Link
                         onClick={() => handleClearData()}
                         className="btn dark_btn telegrambtn"
                         to="https://t.me/EqulixOfficial"
                         target="_blank"
                       >
                         <img src={telegram} alt="telegram.png" />
                         {t("Telegram")}
                       </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- -----------Delete Model end-------------- --> */}
      <div
        className="modal fade"
        ref={(el) => (modalRefs.current["chartThemeColor"] = el)}
        id="chartThemeColor"
        tabindex="-1"
        aria-labelledby="stocktradeLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content darkBackground">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <ul className="nav nav-tabs horizTab" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="candlepop-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#candlepop"
                    type="button"
                    role="tab"
                    aria-controls="candlepop"
                    aria-selected="true"
                  >
                    Candle
                  </button>
                </li>
                {/* <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="canvaspop-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#canvaspop"
                    type="button"
                    role="tab"
                    aria-controls="canvaspop"
                    aria-selected="false"
                  >
                    Canvas
                  </button>
                </li> */}
              </ul>
              <div className="tab-content horizTabcontent" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="candlepop"
                  role="tabpanel"
                  aria-labelledby="candlepop-tab"
                >
                  {/* <div className="form-check d-flex p-0 mb-3">
                    <input
                      className="check-form-input"
                      type="checkbox"
                      value=""
                      id="colorBars"
                    />
                    <label className="check-form-label" for="colorBars">
                      Color Bars Based on previous Close
                    </label>
                  </div> */}

                  <div className="colorOption">
                    <div>
                      <label>Body</label>
                      <div className="inpuBox">
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value={
                            customcaldle?.upColor
                              ? customcaldle?.upColor
                              : "#4CAF50"
                          }
                          onChange={(e) =>
                            setCustomcaldle((state) => ({
                              ...state,
                              upColor: e.target.value,
                            }))
                          }
                        />
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value={customcaldle?.downColor}
                          onChange={(e) =>
                            setCustomcaldle((state) => ({
                              ...state,
                              downColor: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <label>Borders</label>
                      <div className="inpuBox">
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value={customcaldle?.borderUpColor}
                          onChange={(e) =>
                            setCustomcaldle((state) => ({
                              ...state,
                              borderUpColor: e.target.value,
                            }))
                          }
                        />
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value={customcaldle?.borderDownColor}
                          onChange={(e) =>
                            setCustomcaldle((state) => ({
                              ...state,
                              borderDownColor: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <label>Wick</label>
                      <div className="inpuBox">
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value={customcaldle?.wickUpColor}
                          onChange={(e) =>
                            setCustomcaldle((state) => ({
                              ...state,
                              wickUpColor: e.target.value,
                            }))
                          }
                        />
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value={customcaldle?.wickDownColor}
                          onChange={(e) =>
                            setCustomcaldle((state) => ({
                              ...state,
                              wickDownColor: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                    {/* <div>
                      <label>Themes Effect</label>
                      <div className="inpuBox">
                        <input
                          type="color"
                          id="favcolor"
                          name="favcolor"
                          value="#8FF8FC"
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="canvaspop"
                  role="tabpanel"
                  aria-labelledby="canvaspop-tab"
                >
                  <div className="mboderbottom mb-3 pb-3">
                    <h5 className="smalltitle p-0 mb-2">Chart Styles</h5>
                    <div className="colorOption">
                      <div>
                        <label>Background</label>
                        <div className="inpuBox">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="Solid" selected="">
                              Solid
                            </option>
                            <option value="Dashed">Dashed</option>
                            <option value="Dotted">Dotted</option>
                            <option value="Unset">Unset</option>
                          </select>
                          <input
                            type="color"
                            id="favcolor"
                            name="favcolor"
                            value="#8FF8FC"
                          />
                        </div>
                      </div>
                      <div>
                        <label>Grid Lines</label>
                        <div className="inpuBox">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="None" selected="">
                              None
                            </option>
                            <option value="Block">Block</option>
                          </select>
                          <input
                            type="color"
                            id="favcolor"
                            name="favcolor"
                            value="#8FF8FC"
                          />
                        </div>
                      </div>
                      <div>
                        <label>Crosshair</label>
                        <div className="inpuBox">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="------" selected="">
                              -------
                            </option>
                            <option value="......">.......</option>
                            <option value="=======">=======</option>
                          </select>
                          <input
                            type="color"
                            id="favcolor"
                            name="favcolor"
                            value="#8FF8FC"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mboderbottom mb-3 pb-3">
                    <h5 className="smalltitle p-0 mb-2 mt-3">Scales</h5>
                    <div className="colorOption">
                      <div>
                        <label>Text</label>
                        <div className="inpuBox">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="10" selected="">
                              10
                            </option>
                            <option value="12">12</option>
                            <option value="14">14</option>
                            <option value="16">16</option>
                            <option value="18">18</option>
                            <option value="20">20</option>
                          </select>
                          <input
                            type="color"
                            id="favcolor"
                            name="favcolor"
                            value="#8FF8FC"
                          />
                        </div>
                      </div>
                      <div>
                        <label>Lines</label>
                        <div className="inpuBox">
                          <input
                            type="color"
                            id="favcolor"
                            name="favcolor"
                            value="#0000"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mboderbottom mb-3 pb-3">
                    <h5 className="smalltitle p-0 mb-2 mt-3">Scales</h5>
                    <div className="selectinputOption">
                      <div>
                        <label>Navigation</label>
                        <div className="selectOption">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="Visible on Mouse Over" selected="">
                              Visible on Mouse Over
                            </option>
                            <option value="Hidden on Mouse Over">
                              Hidden on Mouse Over
                            </option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <label>Pane</label>
                        <div className="selectOption">
                          <select
                            className="form-select"
                            aria-label="Default select example"
                          >
                            <option value="Visible on Mouse Over" selected="">
                              Visible on Mouse Over
                            </option>
                            <option value="Hidden on Mouse Over">
                              Hidden on Mouse Over
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <h5 className="smalltitle p-0 mb-2">Margins</h5>
                    <div className="selectinputOption">
                      <div>
                        <label>Top</label>
                        <div className="inputOption">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="0"
                              value="10%"
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label>Bottom</label>
                        <div className="inputOption">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="0"
                              value="8%"
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label>Right</label>
                        <div className="inputOption">
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="0"
                              value="10%"
                            />
                            <span className="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="btngroup mt-3">
                    <button type="button" className="btn grayBtn">
                      Cancel
                    </button>
                    <button type="button" className="btn bgBtn">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Userdeshboard;
